define('viewmodels/survey/ConfigureSurvey',['knockout', 'plugins/router', 'services/navigation', 'durandal/app', 'services/appsecurity', 'services/logger', 'durandal/system', 'viewmodels/survey/QuantitativeSurveySetup', 'services/utils', 'viewmodels/GeneralSettings'], function (ko, router, navigation, app, appsecurity, logger, system, QuantitativeSurveySetup, utils, ObjGeneralSettings) {
    var title = 'Survey Configuration';
    var SCViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        utils: utils,
        ObjGeneralSettings: ObjGeneralSettings,
        BUTitle: ko.observable('Business Unit'),
        addPopUpCssSurvey: ko.observable(),
        popUpTitle: ko.observable(),
        CheckAllMandatory: CheckAllMandatory,
        RespMandateQuanAll: RespMandateQuanAll,
        ConfirmRespMandateQuanAll: ConfirmRespMandateQuanAll,
        CommentMandateAll: CommentMandateAll,
        ConfirmCommentMandateAll: ConfirmCommentMandateAll,
        DocumentMandateAll: DocumentMandateAll,
        ConfirmDocumentMandateAll: ConfirmDocumentMandateAll,
        RespMandateQualAll: RespMandateQualAll,
        ConfirmRespMandateQualAll: ConfirmRespMandateQualAll,
        PreviewEdit: PreviewEdit,
        PreviewEditUpdated: ko.observable(false),
        SelectAllCommentsFlag: ko.observable(false),
        SelectAllDocsFlag: ko.observable(false),
        tableStateSave: ko.observable(false),
        CommentMandateQualAll: CommentMandateQualAll,
        ConfirmCommentMandateQualAll: ConfirmCommentMandateQualAll,
        DocumentMandateQualAll: DocumentMandateQualAll,
        ConfirmDocumentMandateQualAll: ConfirmDocumentMandateQualAll,
        LocaleCheckFlag: ko.observable(false),
        CommentMandateControlAll: CommentMandateControlAll,
        ConfirmCommentMandateControlAll: ConfirmCommentMandateControlAll,

        DocumentMandateControlAll: DocumentMandateControlAll,
        ConfirmDocumentMandateControlAll: ConfirmDocumentMandateControlAll,
        RespMandateControlAll: RespMandateControlAll,
        ConfirmRespMandateControlAll: ConfirmRespMandateControlAll,
        SelectAllForQual: SelectAllForQual,
        editableSurvey: ko.observable(),
        IsSubArea: ko.observable(),
        IsSubAreapreview: ko.observable(),
        AssessmentTypeListDup: ko.observable([]),
        SelectedSurveyType: ko.observable(),
        SelectedSurveyTypeName: ko.observable(),
        AssessmentTypeList: ko.observableArray([]),
        AssessmentTypeListDupAsPerSurveytype: ko.observableArray([]),
        AssessmentTypeListAsPerSurveytype: ko.observableArray([]),
        SelectedAssessmentType: ko.observableArray([]),
        popUpTitleSurvey: ko.observable(),
        SurveyList: ko.observableArray([]),
        SurveyTypesList: ko.observableArray([]),
        SurveyTypeTabClick: SurveyTypeTabClick,
        DisableSurveyDropdown: ko.observable(false),
        DisableApplicabilityDropdown: ko.observable(false),
        EditFactorVisible: ko.observable(false),
        SurveyCateogarySelected: ko.observable(false),
        SubAreasPreviewList: ko.observableArray([]),
        DisabledCss: ko.observable(),
        ShowLabel: ko.observable(),
        LabelText: ko.observable(),
        DisableSaveButton: ko.observable(),
        DisableLaunchButton: ko.observable(),
        ClickedSurveyProfileId: ko.observable(),
        ClickedSurveyProfileName: ko.observable(),
        ConfigureSurveyFlag: ko.observable(false),
        DisableActionButtons: ko.observable(),
        BuModelList: ko.observableArray([]),
        CreatedSurveyList: ko.observableArray([]),
        SurveyLaunch: SurveyLaunch,
        SelectedBuIdList: ko.observableArray([]),
        SelectedSpIdList: ko.observableArray([]),
        AllAreaListIds: ko.observableArray([]),
        SelectedActionType: ko.observableArray([]),
        L1SurveyUsersList: ko.observableArray([]),
        L2SurveyUsersList: ko.observableArray([]),
        SurveyUsersList: ko.observableArray([]),
        QuestionsList: ko.observableArray([]),
        CompleteAreaList: ko.observableArray([]),
        SubAreasList: ko.observableArray([]),
        SelectedUserType: ko.observable(),
        IsBulkAction: ko.observable(),
        CloseMappingPopUp: CloseMappingPopUp,
        //functions
        SaveSurvey: SaveSurvey,
        UpdateSurvey: UpdateSurvey,

        ActionChanged: ActionChanged,
        SurveyClick: SurveyClick,
        OpenAddSurveyPopup: OpenAddSurveyPopup,
        EditSurvey: EditSurvey,
        SaveMappingPopUp: SaveMappingPopUp,
        ReplaceUserMapping: ReplaceUserMapping,
        AssignQuestionnairePopup: AssignQuestionnairePopup,
        SaveQuestionMapping: SaveQuestionMapping,
        DisableApplicabilityPopUp: ko.observable(false),
        AssignBulkQuestionnanire: AssignBulkQuestionnanire,
        SurveyCreateModel: ko.observableArray([]),
        closeAssignment: closeAssignment,
        SelectAllQuestionnaire: SelectAllQuestionnaire,
        SelectAllUsers: SelectAllUsers,
        SelectAllBusinessUnits: SelectAllBusinessUnits,
        OpenlaunchSurveyPopup: OpenlaunchSurveyPopup,
        CloseLaunchSurveyPopup: CloseLaunchSurveyPopup,
        LaunchBusinessunitList: ko.observableArray([]),
        LaunchSurvey: LaunchSurvey,
        PreviewQuestionnaire: PreviewQuestionnaire,
        RiskAreaList: ko.observableArray([]),
        SelectedAreas: ko.observableArray([]),
        SelectedBuId: ko.observable(),
        closeQuestionnaire: closeQuestionnaire,
        QuantitativeSurveySetup: QuantitativeSurveySetup,
        SaveMappings: SaveMappings,
        ActionChangedExcel: ActionChangedExcel,

        GetAreaDetails: GetAreaDetails,
        SurveyType: ko.observable(),
        GetDetails: GetDetails,
        AreaList: ko.observableArray([]),
        AreaTabClick: AreaTabClick,
        SubAreaTabClick: SubAreaTabClick,
        SelectedRiskAreaId: ko.observable(),
        AreasSelected: ko.observableArray([]),
        SelectAllQuestionnaireByArea: SelectAllQuestionnaireByArea,
        ChangeSelectAll: ko.observable(),
        QuestionsForCheckedAreasList: ko.observableArray([]),
        AreaWiseSelectedQuestion: ko.observableArray([]),
        SaveQuestionnaireMappingQTDR: SaveQuestionnaireMappingQTDR,
        SelectedBusinessUnitName: ko.observable(),
        ClosePreviewPopUp: ClosePreviewPopUp,
        PreviewQuestions: PreviewQuestions,
        AreaTabClickPreviewQuestion: AreaTabClickPreviewQuestion,
        ClosePreviewQuestionPopUp: ClosePreviewQuestionPopUp,
        ClickedRiskAreaId: ko.observable(),
        QualColumnDetails: ko.observableArray([]),
        SurveyTypeId: ko.observable(),
        QualResponseListData: ko.observableArray([]),

        ControlColumnDetails: ko.observableArray([]),
        ControlsResponseData: ko.observableArray([]),

        FactorList: ko.observableArray([]),
        RiskFactorTabClick: RiskFactorTabClick,
        LabelText: ko.observable(),
        ClickedRiskFactorId: ko.observable(),
        QuanColumnDetails: ko.observableArray([]),
        ValidateResponse: ValidateResponse,
        QuanResponseObject: ko.observableArray([]),

        InputChangedAreaQual: InputChangedAreaQual,
        UpFunctionalityQualSort: UpFunctionalityQualSort,
        DownFunctionalityQualSort: DownFunctionalityQualSort,

        InputChangedAreaQuant: InputChangedAreaQuant,
        UpFunctionalityQuantSort: UpFunctionalityQuantSort,
        DownFunctionalityQuantSort: DownFunctionalityQuantSort,

        InputChangedAreaCont: InputChangedAreaCont,
        UpFunctionalityContSort: UpFunctionalityContSort,
        DownFunctionalityContSort: DownFunctionalityContSort,
        QuantQuesionSortOrder: ko.observable(),
        QualQuesionSortOrder: ko.observable(),
        ContQuesionSortOrder: ko.observable(),

        RegenerateQuestionPreview: RegenerateQuestionPreview,
        SaveQuestionPreview: SaveQuestionPreview,
        DisablePreviewSaveBtn: ko.observable(true),
        RegenertePreviewQuestionFlag: ko.observable(false),

        InputChangedRankQuant: InputChangedRankQuant,
        InputChangedRankQual: InputChangedRankQual,
        InputChangedRankCont: InputChangedRankCont,
        PreviewToggle: PreviewToggle,
        PreviewView: ko.observable(true),
        ExcelSurveyTypeId: ko.observable(),
        ExcelSurveyProfileId: ko.observable(),
        CreatedSurveyListExcel: ko.observableArray([]),
        uploadDownloadDetails: ko.observable(),
        ParentResponseMandatory: ko.observable(false),
        ParentCommentMandatory: ko.observable(false),
        ParentDocumentMandatory: ko.observable(false),
        ParentResponseMandatoryQual: ko.observable(false),
        ParentCommentMandatoryQual: ko.observable(false),
        ParentDocumentMandatoryQual: ko.observable(false),
        ParentResponseMandatoryControl: ko.observable(false),
        ParentCommentMandatoryControl: ko.observable(false),
        ParentDocumentMandatoryControl: ko.observable(false),
        IsControlBluePrintApplicable: ko.observable(false),
        IsInternalBluePrintApplicable: ko.observable(false),
        IsExternalBluePrintApplicable: ko.observable(false),
        selectedLevelId: ko.observable(),
        availableLevelId: ko.observableArray(),
        ControlsAccess: ko.observable(false),
        GetallProfileSurveys: GetallProfileSurveys,
        AddUserMapping: AddUserMapping,
        RemoveUserMapping: RemoveUserMapping,
        BulkAssignUsers: BulkAssignUsers,
        NavPillId: ko.observable('REV'), // Survey as default Nav Pill
        NavTabClick: NavTabClick,
        SaveUserMapping: SaveUserMapping,
        SaveMappingPopUpReplace: SaveMappingPopUpReplace,
        ClosePopUpMapUsers: ClosePopUpMapUsers,
        workflowModelList: ko.observableArray([]),
        GetRoleUserDetailsForBUSurveyConfiguration: GetRoleUserDetailsForBUSurveyConfiguration,
        showBusinessUnitInfoClick: showBusinessUnitInfoClick,
        showUsersList: ko.observable(false),
        NavPillIdSC: ko.observable('ALL'), // Survey as default Nav Pill
        NavTabClickSC: NavTabClickSC,

        WorkFlowList: ko.observableArray([]),
        CurrentRoleType: ko.observable(),
        UsersList: ko.observableArray([]),
        AssignUsers: AssignUsers,
        RoleNameClick: RoleNameClick,
        CloseMappingPopUp: CloseMappingPopUp,
        MappedRiskAreasFlag: ko.observable(true),

        BulkUserActionsFlag: ko.observable(false),
        OpenConfigureDueDatePopupBulk: OpenConfigureDueDatePopupBulk,
        CloseConfigureDueDatePopup: CloseConfigureDueDatePopup,
        DueDate: ko.observable(),
        SaveDueDate: SaveDueDate,
        SaveDueDateGlobalFlag: ko.observable(1),
        OpenConfigureDueDatePopup: OpenConfigureDueDatePopup,
        SelectedSurveyName: ko.observable(),
        SelectedSurveyId: ko.observable(),
        SurComponentDrpDwn: ko.observable(),

        SurveyComponentSelected: ko.observable(),
        CopyOverUsers: CopyOverUsers,
        CopyOverUsersPopUpData: ko.observable(),

        IsSideNavOpen: ko.observable(0),
        FiltersListFlag: ko.observable(false),
        OrgLvlDrpDwnList: ko.observableArray(),
        OrgLvlValueList: ko.observableArray(),
        StatusFilter: ko.observable('Status'),
        SurveyTypeFilterName: ko.observable('Survey Type'),
        SurveyCategoryFilterName: ko.observable('Survey Component'),
        DistinctFileredBUs: ko.observableArray([]),
        BusinessUnitListForFiltersDUP: ko.observableArray([]),
        BusinessUnitFilters: ko.observableArray([]),
        StatusFilterValues: ko.observableArray([]),
        DistinctFileredStatus: ko.observableArray([]),
        SurveyTypeFilter: ko.observable([]),
        SelectedCheckedList: ko.observableArray([]),
        SelectedCheckedBUList: ko.observableArray([]),
        SelectedCheckedSurveyComponentList: ko.observableArray([]),
        SelectedCheckedBUFiltersList: ko.observableArray([]),
        DistinctFileredSurveyType: ko.observableArray([]),
        NumberOfBUsSelected: ko.observable(0),
        SelectedCheckedStatusList: ko.observableArray([]),
        BusinessUnitList: ko.observableArray([]),
        BusinessUnitListForFilters: ko.observableArray([]),
        BusinessUnitListForFiltersDUP: ko.observableArray([]),
        SelectedCheckedBUFiltersList: ko.observableArray([]),
        SelectedCheckedSurveyTypeList: ko.observableArray([]),
        SubCheckboxSelected: SubCheckboxSelected,
        DistinctFileredSurveyCategory: ko.observableArray([]),
        SurveyCategoryFilterValues: ko.observableArray([]),
        SetSurveyTypeFilterSelection: SetSurveyTypeFilterSelection,
        SetFilterSelection: SetFilterSelection,
        FinalOrgFilterList: ko.observableArray([]),
        BusinessUnitListDUP: ko.observableArray([]),
        // Filter Functionality
        openSideNav: openSideNav,
        ApplyFilters: ApplyFilters,
        BUFiltersApplied: ko.observable(false),
        ApplyFiltersclickedcount: ko.observable(),

        SelectedBUs: ko.observable(),
        SelectedFilters: ko.observable(),
        ClearAllBuFilters: ClearAllBuFilters,
        SelectedSurveyTypeFilters: ko.observable(''),
        SelectedSpId: ko.observable(),
        SelectedSurveyTypeforSummary: ko.observable(),


        IsSideNavOpen: ko.observable(0),
        FiltersListFlag: ko.observable(false),
        OrgLvlDrpDwnList: ko.observableArray(),
        OrgLvlValueList: ko.observableArray(),
        StatusFilter: ko.observable('Status'),
        DistinctFileredBUs: ko.observableArray([]),
        BusinessUnitListForFiltersDUP: ko.observableArray([]),
        BusinessUnitFilters: ko.observableArray([]),
        StatusFilterValues: ko.observableArray([]),
        DistinctFileredStatus: ko.observableArray([]),
        SurveyTypeFilter: ko.observable([]),
        SelectedCheckedList: ko.observableArray([]),
        SelectedCheckedBUList: ko.observableArray([]),
        SelectedCheckedSurveyComponentList: ko.observableArray([]),
        SelectedCheckedBUFiltersList: ko.observableArray([]),
        DistinctFileredSurveyType: ko.observableArray([]),
        NumberOfBUsSelected: ko.observable(0),
        SelectedCheckedStatusList: ko.observableArray([]),
        BusinessUnitList: ko.observableArray([]),
        BusinessUnitListForFilters: ko.observableArray([]),
        BusinessUnitListForFiltersDUP: ko.observableArray([]),
        SelectedCheckedBUFiltersList: ko.observableArray([]),
        SelectedCheckedSurveyTypeList: ko.observableArray([]),
        SubCheckboxSelected: SubCheckboxSelected,
        DistinctFileredSurveyCategory: ko.observableArray([]),
        SurveyCategoryFilterValues: ko.observableArray([]),
        SetSurveyTypeFilterSelection: SetSurveyTypeFilterSelection,
        SetFilterSelection: SetFilterSelection,
        FinalOrgFilterList: ko.observableArray([]),
        BusinessUnitListDUP: ko.observableArray([]),
        // Filter Functionality
        openSideNav: openSideNav,
        ApplyFilters: ApplyFilters,
        BUFiltersApplied: ko.observable(false),
        SetBUFilterSelection: SetBUFilterSelection,
        ClearBUFilterSelection: ClearBUFilterSelection,

        SelectedBUs: ko.observable(),
        SelectedFilters: ko.observable(),
        SelectedSurveyTypeFilters: ko.observable(''),
        SelectedSurveyComponentTypeFilters: ko.observable(''),
        SelectedSpId: ko.observable(),
        AreFiltersApplied: ko.observable(0),
        ClearSurveyTypeFilterSelection: ClearSurveyTypeFilterSelection,
        ClearStatusFilterSelection: ClearStatusFilterSelection,
        ClearOrgFilterSelection: ClearOrgFilterSelection,
        SetSurveyComponentFilterSelection: SetSurveyComponentFilterSelection,
        ClearSurveyComponentFilterSelection: ClearSurveyComponentFilterSelection


    }

    return SCViewModel;
    var TableObject;
    var RaTableObj;
    var Object = false;
    var TableObjectPopup;
    function activate() {
        try {
            if (SCViewModel.ObjGeneralSettings === undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((SCViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && SCViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                SCViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (SCViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() == null || SCViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        SCViewModel.LocaleCheckFlag(false);
                    else
                        SCViewModel.LocaleCheckFlag(true);
                });
            } else
                SCViewModel.LocaleCheckFlag(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            if (SCViewModel.ObjGeneralSettings === undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((SCViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && SCViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                SCViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (SCViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() == null || SCViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        SCViewModel.LocaleCheckFlag(false);
                    else
                        SCViewModel.LocaleCheckFlag(true);
                });
            }
            SCViewModel.BUTitle((SCViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedTextList() == null || SCViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SCViewModel.ObjGeneralSettings.LocalizedIndexList() == null || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

            SCViewModel.FiltersListFlag(false);
            SCViewModel.ApplyFiltersclickedcount(0);
            SCViewModel.AreFiltersApplied(0);
            SCViewModel.BUFiltersApplied(false);
            SCViewModel.NumberOfBUsSelected(0);
            SCViewModel.SelectedBUs('');
            GetAllAssessmentTypes();
            GetAllSurveyType();

            TableObjectPopup = $("#tblPreviewQuestions").DataTable();
            $('#tblSurveyDetails').DataTable().state.clear();
            SCViewModel.PreviewView(true);
            GetIndentationLevels();
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        SCViewModel.ControlsAccess(true);
                    }
                    else {
                        SCViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                SCViewModel.ControlsAccess(true);
            }
            else {
                SCViewModel.ControlsAccess(false);
            }
            SCViewModel.PreviewEditUpdated(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    //function OnChangeSurveyComponent(data, event) {
    //    try {
    //        var countCheck = 0;
    //        $('#blueprintpopupvalidation').hide();
    //        for (var i = 0; i < SCViewModel.SurveyTypesList().length; i++) {
    //            if (SCViewModel.SelectedSurveyComponent()[0] === SCViewModel.SurveyTypesList()[i].SurveyCategoryId()) {
    //                if (SCViewModel.SurveyTypesList()[i].LaunchFlag() === 0) {
    //                    SCViewModel.IsLaunchedFlag(false);
    //                    countCheck++;
    //                    break;
    //                }
    //            }
    //        }
    //        if (countCheck === 0) {
    //            SCViewModel.IsLaunchedFlag(true);
    //            if (SCViewModel.SelectedSurveyComponent()[0] !== undefined) {
    //                $('#blueprintpopupvalidation').show();
    //                document.getElementById('blueprintpopupvalidation').innerHTML = "Surveys have been launched for this Component. Cannot apply Blueprint.";
    //            }
    //        }
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: OnChangeSurveyComponent() method in ConfigureSurvey.js';
    //        logger.logMessage(msg);
    //    }
    //}

    //function applyBlueprintSetup(data) {
    //    try {
    //        document.getElementById('blueprintpopupvalidation').innerHTML = "Applying Blueprint...";
    //        $('#blueprintpopupvalidation').show();
    //        var csrfToken = $("input[name='__RequestVerificationToken']").val();
    //        var headers = appsecurity.getSecurityHeaders();
    //        headers.__RequestVerificationToken = csrfToken;
    //        return $.ajax({
    //            url: "/api/Survey/ApplyBluePrint?SurveyCategoryId=" + parseInt(SCViewModel.SelectedSurveyComponent()[0]),
    //            type: "POST",
    //            headers: headers
    //        })
    //            .success(function (jsonResult, success) {
    //                if (jsonResult == null) {
    //                    logger.logError('Please Configure ' + SCViewModel.BUTitle() + '.', 'Error', system.getModuleId(AMLRaViewModel), true);
    //                }
    //                else if (jsonResult > 0) {
    //                    document.getElementById('blueprintpopupvalidation').innerHTML = "Blueprint Matrix has been applied successfully.";
    //                    logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ApplicabilityMatrixSuccessMsg') == -1) ? 'Applicability Matrix has been applied successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ApplicabilityMatrixSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
    //                    $('#ApplyBlueprintPopup').modal('hide');
    //                    $('body').removeClass('modal-open');
    //                    $('.modal-backdrop').remove();
    //                    GetAllSurveyType();
    //                }
    //                else {
    //                    document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
    //                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
    //                }
    //            })
    //            .fail(function (error, fail) {
    //                document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
    //                logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
    //            })
    //    }
    //    catch (e) {
    //        document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
    //        var msg = 'Exception: ' + e + ' | Source: GetAllBusinessUnits() method in ConfigureSurvey.js';
    //        logger.logMessage(msg);
    //    }

    //}
    //function ApplyBlueprintPopup() {
    //    try {
    //        SCViewModel.SelectedSurveyComponent([]);
    //        SCViewModel.IsLaunchedFlag(true);
    //        $('#blueprintpopupvalidation').hide();
    //        $('#ApplyBlueprintPopup').modal('show');
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: ApplyBlueprintPopup() method in ConfigureSurvey.js';
    //        logger.logMessage(msg);
    //    }
    //}


    //-----excel download and upload starts here
    function ActionChangedExcel(data, event) {
        try {
            //debugger;
            getSurveysBasedOnTypeExcel(SCViewModel.ExcelSurveyTypeId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChangedExcel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ClearAllBuFilters(data, event) {
        try {
            RecheckSelectBoxOnClear();
            SCViewModel.BusinessUnitList(SCViewModel.BusinessUnitListDUP());
            SCViewModel.SelectedCheckedBUList([]);
            SCViewModel.SelectedCheckedList([]);
            SCViewModel.BusinessUnitListForFilters([]);
            SCViewModel.SelectedBUs('');
            SCViewModel.NumberOfBUsSelected(0);
            closeSideNav();

            SCViewModel.BUFiltersApplied(false);
            SCViewModel.SelectedCheckedStatusList([]);
            SCViewModel.SelectedCheckedSurveyTypeList([]);
            SCViewModel.SelectedCheckedSurveyComponentList([]);

            SetStatusFilterSelection();
            SetFilterSelection();
            SetSurveyTypeFilterSelection();
            SetSurveyComponentFilterSelection();

            $('.badge').css({ 'display': 'none' });
            //SCViewModel.AreFiltersApplied(0);
            $('#ParentDynamicOrgOptedFilters').innerHTML = '';
            ApplyFilters();
            SCViewModel.AreFiltersApplied(0);
            SCViewModel.ApplyFiltersclickedcount(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearAllBuFilters() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function RecheckSelectBoxOnClear() {
        try {
            if (SCViewModel.SelectedCheckedStatusList().length > 0) {
                for (var g = 0; g < SCViewModel.SelectedCheckedStatusList().length; g++) {
                    $("#sublevelStatus" + SCViewModel.SelectedCheckedStatusList()[g].Process_Id).prop("checked", false);
                    $('.fa-check.' + SCViewModel.SelectedCheckedStatusList()[g].Process_Id).css({ 'display': 'none' });
                }
            }

            if (SCViewModel.SelectedCheckedSurveyTypeList().length > 0) {
                for (var g = 0; g < SCViewModel.SelectedCheckedSurveyTypeList().length; g++) {
                    $("#sublevelSurveyType" + SCViewModel.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).prop("checked", false);
                    $('.fa-check.' + SCViewModel.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).css({ 'display': 'none' });
                }
            }

            if (SCViewModel.SelectedCheckedList().length > 0) {
                for (var g = 0; g < SCViewModel.SelectedCheckedList().length; g++) {
                    $("#sublevel" + SCViewModel.SelectedCheckedList()[g].SubLevelId).prop("checked", false);
                    $('.fa-check.' + SCViewModel.SelectedCheckedList()[g].SubLevelId).css({ 'display': 'none' });
                }
            }

            if (SCViewModel.SelectedCheckedBUList().length > 0) {
                for (var g = 0; g < SCViewModel.SelectedCheckedBUList().length; g++) {
                    $("#sublevelBU" + SCViewModel.SelectedCheckedBUList()[g].SubLevelId).prop("checked", false);
                    $('.fa-check.' + SCViewModel.SelectedCheckedBUList()[g].SubLevelId).css({ 'display': 'none' });
                }
            }

            if (SCViewModel.SelectedCheckedSurveyComponentList().length > 0) {
                for (var g = 0; g < SCViewModel.SelectedCheckedSurveyComponentList().length; g++) {
                    $("#sublevelZAT" + SCViewModel.SelectedCheckedSurveyComponentList()[g].SurveyCategory_Id).prop("checked", false);
                    $('.fa-check.' + SCViewModel.SelectedCheckedSurveyComponentList()[g].SurveyCategory_Id).css({ 'display': 'none' });
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RecheckSelectBoxOnClear() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function SetStatusFilterSelection() {
        try {
            document.getElementById('DynamicStatusOptedFilters').innerHTML = "";

            var contentHtml = "";
            for (var k = 0; k < SCViewModel.SelectedCheckedStatusList().length; k++) {
                contentHtml += '<div id="DynamicStatusFilters_' + SCViewModel.SelectedCheckedStatusList()[k].Process_Id + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">Status </span> : ' + SCViewModel.SelectedCheckedStatusList()[k].Process_Name + '<span  class="f-clear" id="ClearFilterTextStatus_' + SCViewModel.SelectedCheckedStatusList()[k].Process_Id + '" data-bind="click:ClearStatusFilterSelection"><i class="demo-icon icon-cross_special"></i>  </span></span></div>';
            }

            document.getElementById('DynamicStatusOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < SCViewModel.SelectedCheckedStatusList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterTextStatus_' + SCViewModel.SelectedCheckedStatusList()[k].Process_Id), { click: SCViewModel.ClearStatusFilterSelection }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetStatusFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearStatusFilterSelection(data, event) {
        try {
            var ProcessId = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicStatusFilters_' + ProcessId).innerHTML = "";

            $('.fa-check.' + ProcessId).css({ 'display': 'none' });
            if (SCViewModel.SelectedCheckedStatusList().length > 0) {
                SCViewModel.SelectedCheckedStatusList.remove(function (item) { return item.Process_Id == ProcessId })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearStatusFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function openSideNav() {
        try {
            if (SCViewModel.IsSideNavOpen() == 1) {
                $('#sideNav').fadeOut(200);
                SCViewModel.IsSideNavOpen(0);
            }
            else {
                $('#sideNav').fadeIn(200);
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                document.getElementById("sideNav").style.top = "unset";
                document.getElementById("sideNav").style.height = "auto";
                SCViewModel.IsSideNavOpen(1);
                if (SCViewModel.FiltersListFlag() == false) {
                    GetAllOrganizationalLevels();
                    GetAllSurveyProfileTypes();
                    GetAllBusinessUnitsForFilters();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: openSideNav() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearStatusFilterSelectionoseSideNav() {
        try {
            $('#sideNav').fadeOut(200);
            $('#OrgFilterError').hide();
            $('#BUFilterError').hide();
            $('#loadingImgMain').modal('hide');
            SCViewModel.IsSideNavOpen(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }


    //#region Filter related Get Methods

    // to fetch all Org Level details - Used in filters
    function GetAllOrganizationalLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/getDistinctBusinessLevelsAll",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in SurveyConfig.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult[0].IsCompletedFlag == -1) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                        ? jsonResult[0].SurveyStatus + " - An error occurred. Please contact your Application Administrator."
                        : jsonResult[0].SurveyStatus + " - " + SCViewModel.ObjGeneralSettings.LocalizedTextList()
                        [SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                }
                else if (jsonResult != undefined && jsonResult.length > 0 && jsonResult[0].IsCompletedFlag != -1) {
                    if (jsonResult != null) {
                        var OrganizationalLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelsModel(result);
                        });

                        if (OrganizationalLevels.length > 0) {
                            SCViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                            BindHTMLFilters();
                            SCViewModel.OrgLvlValueList(SCViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                        }
                        else {
                            BindHTMLFilters();
                        }
                    }
                }
                else {
                    var msg = (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                    logger.logError(msg, 'Error', system.getModuleId(SCViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in SurveyConfig.js';
                logger.logMessage(msg);

            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SurveyConfig.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SurveyConfig.js';
                logger.logMessage(msg);
            }
        }
    }


    // to fetch all SP Names  - Used in filters
    function GetAllSurveyProfileTypes() {
        try {
            return $.ajax({
                url: "/api/Survey/GetSurveyProfileTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' || Source: ajax call in GetAllSurveyProfileTypes() in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult[0].SurveyProfileId == -1) {
                    $('#MainPage_Div').hide();
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                        ? jsonResult[0].SurveyProfileName + " - An error occurred. Please contact your Application Administrator."
                        : jsonResult[0].SurveyProfileName + " - " + SCViewModel.ObjGeneralSettings.LocalizedTextList()
                        [SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                }
                else if (jsonResult != undefined && jsonResult.length > 0 && jsonResult[0].SurveyProfileId != -1) {

                    if (jsonResult != null) {
                        var mappedSurvey = $.map(jsonResult, function (result) {
                            return new SurveyProfileModel(result);
                        });
                        SCViewModel.SurveyTypeFilter(mappedSurvey);
                    }
                }
                else {
                    $('#MainPage_Div').hide();
                    var msg = (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                    logger.logError(msg, 'Error', system.getModuleId(SCViewModel), true);
                }
            }

            catch (e) {
                $('#MainPage_Div').hide();
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyProfileTypes() in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                $('#MainPage_Div').hide();
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyProfileTypes() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyProfileTypes() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
    }


    // to fetch all Business Unit details - Used in filters
    function GetAllBusinessUnitsForFilters() {
        try {
            return $.ajax({
                url: "/api/Survey/getAllBusinessUnitsFilters",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllBusinessUnitsForFilters() in ConfigureSurvey.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult != undefined && jsonResult.length > 0) {
                    if (jsonResult[0].IsCompletedFlag == -1) {
                        logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult[0].SurveyStatus + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult[0].SurveyStatus + " - " + SCViewModel.ObjGeneralSettings.LocalizedTextList()
                            [SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else {
                        var mappedBuList = $.map(jsonResult, function (result) {
                            return new BusinessUnitModel(result);
                        });
                        SCViewModel.BusinessUnitListForFiltersDUP(mappedBuList);
                        SCViewModel.BusinessUnitFilters(mappedBuList);

                        SCViewModel.BusinessUnitListDUP = ko.dependentObservable(function () {
                            var seen = [];
                            return mappedBuList.filter(function (n) {
                                return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                            });
                        });
                        BindHTMLFilters();
                        $('#OrgFilterError').hide();
                        $('#BUFilterError').hide();
                        document.getElementById("sideNav").style.top = "unset";
                        document.getElementById("sideNav").style.height = "auto";
                        SCViewModel.FiltersListFlag(true);
                    }
                }
                else {
                    var msg = (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                    logger.logError(jsonResult[0].SurveyStatus + " - " + msg, 'Error', system.getModuleId(SCViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
    }

    //navtabclick also uses this to fetch the actual data
    function ApplyFilters() {
        try {
            $('#SurDetailTabDiv').hide();
            $('#loadingImgSurveyTracking').show();

            SCViewModel.SelectedBUs('');
            var SelectedBUsString = "";

            if (SCViewModel.SelectedCheckedList().length > 0 || SCViewModel.SelectedCheckedBUList().length > 0) {
                for (var i = 0; i < SCViewModel.BusinessUnitListForFilters().length; i++) {
                    if (SelectedBUsString === "")
                        SelectedBUsString = SCViewModel.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                    else
                        SelectedBUsString += "," + SCViewModel.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                }
            }

            var SelectedFilterString = "";
            for (var i = 0; i < SCViewModel.SelectedCheckedStatusList().length; i++) {
                if (SelectedFilterString === "")
                    SelectedFilterString = SCViewModel.SelectedCheckedStatusList()[i].Process_Id.toString();
                else
                    SelectedFilterString += "," + SCViewModel.SelectedCheckedStatusList()[i].Process_Id.toString();
            }

            var SelectedSurveyTypeFilterString = "";
            for (var i = 0; i < SCViewModel.SelectedCheckedSurveyTypeList().length; i++) {
                if (SelectedSurveyTypeFilterString === "")
                    SelectedSurveyTypeFilterString = SCViewModel.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
                else
                    SelectedSurveyTypeFilterString += "," + SCViewModel.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
            }

            var SelectedSurveyComponentString = "";
            for (var i = 0; i < SCViewModel.SelectedCheckedSurveyComponentList().length; i++) {
                if (SelectedSurveyComponentString === "")
                    SelectedSurveyComponentString = SCViewModel.SelectedCheckedSurveyComponentList()[i].SurveyCategory_Id.toString();
                else
                    SelectedSurveyComponentString += "," + SCViewModel.SelectedCheckedSurveyComponentList()[i].SurveyCategory_Id.toString();
            }

            SCViewModel.SelectedBUs(SelectedBUsString);

            if (SCViewModel.SelectedBUs() === undefined)
                SCViewModel.SelectedBUs("");

            SCViewModel.SelectedFilters(SelectedFilterString);

            if (SCViewModel.SelectedFilters() === undefined)
                SCViewModel.SelectedFilters("");

            SCViewModel.SelectedSurveyTypeFilters(SelectedSurveyTypeFilterString);

            if (SCViewModel.SelectedSurveyTypeFilters() === undefined)
                SCViewModel.SelectedSurveyTypeFilters("");

            SCViewModel.SelectedSurveyComponentTypeFilters(SelectedSurveyComponentString);

            if (SCViewModel.SelectedSurveyComponentTypeFilters() === undefined)
                SCViewModel.SelectedSurveyComponentTypeFilters("");

            var data = {
                SurveyprofileId: function () { return SCViewModel.ClickedSurveyProfileId(); },
                SurveyName: function () {
                    return SCViewModel.ClickedSurveyProfileName();
                }
            }
            SurveyClick(data, "");

            closeSideNav();
            $('#SurDetailTabDiv').show();

        }
        catch (e) {
            var msg = 'Exception' + e + ' || source: ajax call in ApplyFilters() in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#endregion

    function closeSideNav() {
        try {
            $('#sideNav').fadeOut(200);
            $('#OrgFilterError').hide();
            $('#BUFilterError').hide();
            //$('#loadingImgMain').modal('hide');
            SCViewModel.IsSideNavOpen(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in SurveyTracking.js';
            logger.logMessage(msg);
        }
    }

    function BusinessLevelsModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
            self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            self.BlId = ko.observable(item.BlId)
            var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                return new BuLevelValueListModel(result);
            });
            self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function BuLevelValueListModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable(item.BlvalueId);
            self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
            self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function BindHTMLFilters() {
        try {
            //Org Level Filter Fossil style
            var OrgList = "";
            OrgList += '<div class="filter-nav1">' +
                '<ul class="nav nav-tabs"><li class="fl-lbl"><span data-bind="html: (!SCViewModel.LocaleCheckFlag() ||��SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters") == -1 )?"Add Filters": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters")].Name"></span></li>';

            for (var i = 0; i < SCViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<li class=""><a href="#tab_' + SCViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SCViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'
                } else {
                    OrgList += '<li class=""><a href="#tab_' + SCViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SCViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'
                }
            }
            OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + SCViewModel.BUTitle() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

            /* OrgList += '<li class=""><a href="#tab_Status" data-toggle="tab">' + SCViewModel.StatusFilter() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'*/

            OrgList += '<li class=""><a href="#tab_SurveyType" data-toggle="tab">' + SCViewModel.SurveyTypeFilterName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

            OrgList += '<li class=""><a href="#tab_SurveyCategory" data-toggle="tab">' + SCViewModel.SurveyCategoryFilterName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

            OrgList += '</ul>' +
                '<div class="tab-content filter-content">';

            for (var i = 0; i < SCViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<div class="tab-pane active" id="tab_' + SCViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                } else {
                    OrgList += '<div class="tab-pane" id="tab_' + SCViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                }

                if (SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                    for (var j = 0; j < SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                        OrgList += '<label class="ft-selection">' +
                            '<input id=sublevel' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                            '<i class="fa fa-check ' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i>' +
                            '<span class="cc-facet-result-text tag-text">' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span>' +
                            '</label>';
                    }

                }

                OrgList += '</div>';
            }
            OrgList += '<div class="tab-pane" id="tab_BU">';

            SCViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                var seen = [];
                return SCViewModel.BusinessUnitListForFiltersDUP().filter(function (n) {
                    return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                });
            });

            SCViewModel.BusinessUnitFilters(SCViewModel.DistinctFileredBUs());

            for (var w = 0; w < SCViewModel.BusinessUnitFilters().length; w++) {
                OrgList += '<label class="ft-selection">' +
                    '<input id=sublevelBU' + SCViewModel.BusinessUnitFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected`}" class="heatmap-sublevel">' +
                    '<i class="fa fa-check ' + SCViewModel.BusinessUnitFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                    '<span class="cc-facet-result-text tag-text">' + SCViewModel.BusinessUnitFilters()[w].BusinessUnitName() + '</span>' +
                    '</label>';
            }
            OrgList += '</div>';

            //OrgList += '<div class="tab-pane" id="tab_Status">';

            //for (var n = 0; n < SCViewModel.StatusFilterValues().length; n++) {
            //    OrgList += '<label class="ft-selection">' +
            //        '<input id=sublevelStatus' + SCViewModel.StatusFilterValues()[n].PROCESS_ID() + ' type="checkbox" class="heatmap-sublevel">' +
            //        '<i class="fa fa-check ' + SCViewModel.StatusFilterValues()[n].PROCESS_ID() + '" aria-hidden="true" style="display:none"></i>' +
            //        '<span class="cc-facet-result-text tag-text">' + SCViewModel.StatusFilterValues()[n].PROCESS_POINT_NAME() + '</span>' +
            //        '</label>';
            //}

            //SCViewModel.DistinctFileredStatus = ko.dependentObservable(function () {
            //    var seen = [];
            //    return SCViewModel.StatusFilterValues().filter(function (n) {
            //        return seen.indexOf(n) == -1 && seen.push(n);
            //    });
            //});

            //SCViewModel.StatusFilterValues(SCViewModel.DistinctFileredStatus());


            //OrgList += '</div>';

            OrgList += '<div class="tab-pane" id="tab_SurveyType">';

            for (var t = 0; t < SCViewModel.SurveyTypeFilter().length; t++) {
                if (SCViewModel.SurveyTypeFilter()[t].SurveyProfileId() != -999)  //to exclude the Socialzaition option from filter
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelSurveyType' + SCViewModel.SurveyTypeFilter()[t].SurveyProfileId() + ' type="checkbox" class="heatmap-sublevel">' +
                        '<i class="fa fa-check ' + SCViewModel.SurveyTypeFilter()[t].SurveyProfileId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SCViewModel.SurveyTypeFilter()[t].SurveyProfileName() + '</span>' +
                        '</label>';
            }

            SCViewModel.DistinctFileredSurveyType = ko.dependentObservable(function () {
                var seen = [];
                return SCViewModel.SurveyTypeFilter().filter(function (n) {
                    return seen.indexOf(n) == -1 && seen.push(n);
                });
            });

            SCViewModel.SurveyTypeFilter(SCViewModel.DistinctFileredSurveyType());


            OrgList += '</div>';

            //added for survey category

            OrgList += '<div class="tab-pane" id="tab_SurveyCategory">';

            for (var n = 0; n < SCViewModel.SurveyTypesList().length; n++) {
                if (SCViewModel.SurveyTypesList()[n].SurveyCategoryId() != 999)     //to exclude the Summary option from filter
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelSurveyCategory' + SCViewModel.SurveyTypesList()[n].SurveyCategoryId() + ' type="checkbox" class="heatmap-sublevel">' +
                        '<i class="fa fa-check ' + SCViewModel.SurveyTypesList()[n].SurveyCategoryId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SCViewModel.SurveyTypesList()[n].SurveyCategoryName() + '</span>' +
                        '</label>';
            }

            SCViewModel.DistinctFileredSurveyCategory = ko.dependentObservable(function () {
                var seen = [];
                return SCViewModel.SurveyTypesList().filter(function (n) {
                    return seen.indexOf(n) == -1 && seen.push(n);
                });
            });

            SCViewModel.SurveyTypesList(SCViewModel.DistinctFileredSurveyCategory());


            OrgList += '</div>';

            if (OrgList == "") {
                OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label"  data-bind="html: (!SCViewModel.LocaleCheckFlag() ||��SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf("OrgLevelsNotConfigured") == -1 )?"Organizational Levels are not configured for this Year of Assessment.": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("OrgLevelsNotConfigured")].Name"></label></div>';

            }
            document.getElementById('OrganizationalLevel').innerHTML = OrgList;
            var element = $('#tab_SurveyType')[0];
            ko.cleanNode(element);
            ko.applyBindings(SCViewModel, document.getElementById('tab_SurveyType'));


            for (var i = 0; i < SCViewModel.OrgLvlDrpDwnList().length; i++) {
                for (var l = 0; l < SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                    ko.applyBindingsToNode($('#sublevel' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: SCViewModel.SubCheckboxSelected } }, SCViewModel);
                }
            }

            for (var k = 0; k < SCViewModel.BusinessUnitFilters().length; k++) {
                ko.applyBindingsToNode($('#sublevelBU' + SCViewModel.BusinessUnitFilters()[k].BusinessUnitId()), { event: { change: SCViewModel.SubCheckboxSelected } }, SCViewModel);
            }

            //for (var l = 0; l < SCViewModel.StatusFilterValues().length; l++) {
            //    ko.applyBindingsToNode($('#sublevelStatus' + SCViewModel.StatusFilterValues()[l].PROCESS_ID()), { event: { change: SCViewModel.SubCheckboxSelected } }, SCViewModel);
            //}

            for (var q = 0; q < SCViewModel.SurveyTypeFilter().length; q++) {
                ko.applyBindingsToNode($('#sublevelSurveyType' + SCViewModel.SurveyTypeFilter()[q].SurveyProfileId()), { event: { change: SCViewModel.SubCheckboxSelected } }, SCViewModel);
            }

            for (var r = 0; r < SCViewModel.SurveyTypesList().length; r++) {
                ko.applyBindingsToNode($('#sublevelSurveyCategory' + SCViewModel.SurveyTypesList()[r].SurveyCategoryId()), { event: { change: SCViewModel.SubCheckboxSelected } }, SCViewModel);
            }

            $('#loadingImgMainHm').modal('hide');

            if (SCViewModel.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage() == false) {
                if (SCViewModel.SelectedCheckedList().length > 0 || SCViewModel.SelectedCheckedBUList().length > 0)
                    SCViewModel.NumberOfBUsSelected(SCViewModel.BusinessUnitFilters().length); // 30 initially
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' || source: BindHTMLFilters function in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SubCheckboxSelected(data, event) {
        try {
            $('#OrgFilterError').hide();
            $('#BUFilterError').hide();
            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
            var BUselected = "";
            var StatusSelected = "";

            // CHECKS WHETHER SELECTED SUB CHECKBOX HAS STATUS OR NOT
            if (selectedSubOrgLevelID.includes("Status")) {
                var counterCheck = 0;
                for (var g = 0; g < SCViewModel.StatusFilterValues().length; g++) {
                    if (('Status' + SCViewModel.StatusFilterValues()[g].PROCESS_ID()) == selectedSubOrgLevelID) {
                        if (event.currentTarget.checked) {
                            $("#sublevelStatus" + SCViewModel.StatusFilterValues()[g].PROCESS_ID()).prop("checked", true);
                            $('.fa-check.' + SCViewModel.StatusFilterValues()[g].PROCESS_ID()).css({ 'display': 'inline-block' });

                            SCViewModel.SelectedCheckedStatusList.push({
                                Process_Id: SCViewModel.StatusFilterValues()[g].PROCESS_ID(),
                                Process_Name: SCViewModel.StatusFilterValues()[g].PROCESS_POINT_NAME(),
                            });
                        }
                        else {
                            $("#sublevelStatus" + SCViewModel.StatusFilterValues()[g].PROCESS_ID()).prop("checked", false);
                            $('.fa-check.' + SCViewModel.StatusFilterValues()[g].PROCESS_ID()).css({ 'display': 'none' });
                            if (SCViewModel.SelectedCheckedStatusList().length > 0) {
                                SCViewModel.SelectedCheckedStatusList.remove(function (item) { return item.Process_Id == SCViewModel.StatusFilterValues()[g].PROCESS_ID() })
                            }

                        }
                        //Mark parent check box as checked if all sub levels are selected
                    }
                }
                SetStatusFilterSelection();
            }

            // CHECKS WHETHER SELECTED SUB CHECKBOX HAS SURVEY TYPE OR NOT
            else if (selectedSubOrgLevelID.includes("SurveyType")) {
                var counterCheck = 0;
                for (var g = 0; g < SCViewModel.SurveyTypeFilter().length; g++) {
                    if (('SurveyType' + SCViewModel.SurveyTypeFilter()[g].SurveyProfileId()) == selectedSubOrgLevelID) {
                        if (event.currentTarget.checked) {
                            $("#sublevelSurveyType" + SCViewModel.SurveyTypeFilter()[g].SurveyProfileId()).prop("checked", true);
                            $('.fa-check.' + SCViewModel.SurveyTypeFilter()[g].SurveyProfileId()).css({ 'display': 'inline-block' });

                            SCViewModel.SelectedCheckedSurveyTypeList.push({
                                SurveyType_Id: SCViewModel.SurveyTypeFilter()[g].SurveyProfileId(),
                                SurveyType_Name: SCViewModel.SurveyTypeFilter()[g].SurveyProfileName(),
                            });
                        }
                        else {
                            $("#sublevelSurveyType" + SCViewModel.SurveyTypeFilter()[g].SurveyProfileId()).prop("checked", false);
                            $('.fa-check.' + SCViewModel.SurveyTypeFilter()[g].SurveyProfileId()).css({ 'display': 'none' });
                            if (SCViewModel.SelectedCheckedSurveyTypeList().length > 0) {
                                SCViewModel.SelectedCheckedSurveyTypeList.remove(function (item) { return item.SurveyType_Id == SCViewModel.SurveyTypeFilter()[g].SurveyProfileId() })
                            }

                        }
                        //Mark parent check box as checked if all sub levels are selected
                    }
                }
                SetSurveyTypeFilterSelection();
            }

            else if (selectedSubOrgLevelID.includes("SurveyCategory")) {
                var counterCheck = 0;
                for (var g = 0; g < SCViewModel.SurveyTypesList().length; g++) {
                    if (('SurveyCategory' + SCViewModel.SurveyTypesList()[g].SurveyCategoryId()) == selectedSubOrgLevelID) {
                        if (event.currentTarget.checked) {
                            $("#sublevelSurveyCategory" + SCViewModel.SurveyTypesList()[g].SurveyCategoryId()).prop("checked", true);
                            $('.fa-check.' + SCViewModel.SurveyTypesList()[g].SurveyCategoryId()).css({ 'display': 'inline-block' });

                            SCViewModel.SelectedCheckedSurveyComponentList.push({
                                SurveyCategory_Id: SCViewModel.SurveyTypesList()[g].SurveyCategoryId(),
                                SurveyCategory_Name: SCViewModel.SurveyTypesList()[g].SurveyCategoryName(),
                            });
                        }
                        else {
                            $("#sublevelSurveyCategory" + SCViewModel.SurveyTypesList()[g].SurveyCategoryId()).prop("checked", false);
                            $('.fa-check.' + SCViewModel.SurveyTypesList()[g].SurveyCategoryId()).css({ 'display': 'none' });
                            if (SCViewModel.SelectedCheckedSurveyComponentList().length > 0) {
                                SCViewModel.SelectedCheckedSurveyComponentList.remove(function (item) { return item.SurveyCategory_Id == SCViewModel.SurveyTypesList()[g].SurveyCategoryId() })
                            }

                        }
                        //Mark parent check box as checked if all sub levels are selected
                    }
                }
                SetSurveyComponentFilterSelection();
            }

            else if (isNaN(parseInt(selectedSubOrgLevelID)) && SCViewModel.SelectedCheckedList().length > 0) {
                $('#BUFilterError').show();
                return false;
            }
            else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SCViewModel.SelectedCheckedBUList().length > 0) {
                $('#OrgFilterError').show();
                return false;
            }

            else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SCViewModel.SelectedCheckedBUList().length == 0) {
                for (var i = 0; i < SCViewModel.OrgLvlDrpDwnList().length; i++) {
                    var counterCheck = 0;
                    for (var g = 0; g < SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                        if (SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                            if (event.currentTarget.checked) {
                                $("#sublevel" + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                $('.fa-check.' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                SCViewModel.SelectedCheckedList.push({
                                    SubLevelId: SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                    SubLevelName: SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                    OrgLevelName: SCViewModel.OrgLvlDrpDwnList()[i].BlName()
                                });
                            }
                            else {
                                $("#sublevel" + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                $('.fa-check.' + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                if (SCViewModel.SelectedCheckedList().length > 0) {
                                    SCViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                }
                            }
                        }

                        //Mark parent check box as checked if all sub levels are selected
                        if ($("#sublevel" + SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                            counterCheck++;
                        }
                        if (counterCheck > 0 && counterCheck == SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                            $("#" + SCViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                        }
                        else if (counterCheck > 0 && counterCheck == SCViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                            $("#" + SCViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                        }
                    }
                }
                //Logic to re-set the BU list
                SCViewModel.BusinessUnitListForFilters([]);
                if (SCViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < SCViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == SCViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SCViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    SCViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    SCViewModel.BusinessUnitListForFilters([]);
                    mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SCViewModel.BusinessUnitListForFilters(mappedBuList);
                    SCViewModel.FinalOrgFilterList(mappedBuList);
                }
                SetFilterSelection();
            }
            else if (isNaN(parseInt(selectedSubOrgLevelID)) && SCViewModel.SelectedCheckedList().length == 0) {
                BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                for (var i = 0; i < SCViewModel.BusinessUnitListDUP().length; i++) {
                    if (SCViewModel.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                        if (event.currentTarget.checked) {
                            $("#sublevelBU" + BUselected).prop("checked", true);
                            $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                            SCViewModel.SelectedCheckedBUList.push({
                                SubLevelId: SCViewModel.BusinessUnitListDUP()[i].BusinessUnitId(),
                                SubLevelName: SCViewModel.BusinessUnitListDUP()[i].BusinessUnitName()
                            });
                        }
                        else {
                            $("#sublevelBU" + BUselected).prop("checked", false);
                            $('.fa-check.' + BUselected).css({ 'display': 'none' });
                            if (SCViewModel.SelectedCheckedBUList().length > 0) {
                                SCViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == SCViewModel.BusinessUnitListDUP()[i].BusinessUnitId() })
                            }
                        }
                    }
                }

                if (SCViewModel.SelectedCheckedBUList().length > 0) {
                    //Logic to re-set the BU list
                    SCViewModel.BusinessUnitListForFilters([]);

                    var mappedBuList = $.map(SCViewModel.BusinessUnitListDUP(), function (result) {
                        for (var m = 0; m < SCViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == SCViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SCViewModel.BusinessUnitListForFilters(mappedBuList);
                }
                else {
                    SCViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SCViewModel.BusinessUnitListForFilters(mappedBuList);
                    SCViewModel.FinalOrgFilterList(mappedBuList);
                }
                SetBUFilterSelection();
            }
            //Set count of BU's selected
            if (SCViewModel.BusinessUnitListForFilters().length > 0) {
                SCViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return SCViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                SCViewModel.BusinessUnitListForFilters(SCViewModel.DistinctFileredBUs());
            }

            if (SCViewModel.SelectedCheckedList().length > 0 || SCViewModel.SelectedCheckedBUList().length > 0)
                SCViewModel.NumberOfBUsSelected(SCViewModel.BusinessUnitListForFilters().length);
            else
                SCViewModel.NumberOfBUsSelected(0);
        }
        catch (e) {
            var msg = 'Exception' + e + ' || source:  SubCheckboxSelected function in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function SetBUFilterSelection() {
        try {
            document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

            var contentHtml = "";
            for (var k = 0; k < SCViewModel.SelectedCheckedBUList().length; k++) {
                contentHtml += '<div id="DynamicBUOptedFilters_' + SCViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">BU </span> : ' + SCViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + SCViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearBUFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
            }

            document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < SCViewModel.SelectedCheckedBUList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterTextBU_' + SCViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: SCViewModel.ClearBUFilterSelection }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearBUFilterSelection(data, event) {
        try {

            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

            $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
            if (SCViewModel.SelectedCheckedBUList().length > 0) {
                SCViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
            }

            //Logic to re-set the BU list
            SCViewModel.BusinessUnitListForFilters([]);
            if (SCViewModel.SelectedCheckedBUList().length > 0) {
                var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    for (var m = 0; m < SCViewModel.SelectedCheckedBUList().length; m++) {
                        if (result.BusinessUnitId() == SCViewModel.SelectedCheckedBUList()[m].SubLevelId)
                            return new BusinessUnitModelDUP(result);
                    }
                });
                SCViewModel.BusinessUnitListForFilters(mappedBuList);

            }
            else {
                SCViewModel.BusinessUnitListForFilters([]);
                var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    return new BusinessUnitModelDUP(result);
                });
                SCViewModel.BusinessUnitListForFilters(mappedBuList);

                $('#OrgFilterError').hide();
            }
            //Set count of BU's selected
            if (SCViewModel.BusinessUnitListForFilters().length > 0) {
                SCViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return SCViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                SCViewModel.BusinessUnitListForFilters(SCViewModel.DistinctFileredBUs());
            }
            if (SCViewModel.SelectedCheckedList().length > 0 || SCViewModel.SelectedCheckedBUList().length > 0)
                SCViewModel.NumberOfBUsSelected(SCViewModel.BusinessUnitListForFilters().length);
            else
                SCViewModel.NumberOfBUsSelected(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function SetSurveyTypeFilterSelection() {
        try {
            document.getElementById('DynamicSurveyTypeOptedFilters').innerHTML = "";

            var contentHtml = "";
            for (var k = 0; k < SCViewModel.SelectedCheckedSurveyTypeList().length; k++) {
                contentHtml += '<div id="DynamicSurveyTypeFilters_' + SCViewModel.SelectedCheckedSurveyTypeList()[k].SurveyType_Id + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">Survey Type </span> : ' + SCViewModel.SelectedCheckedSurveyTypeList()[k].SurveyType_Name + '<span class="f-clear" id="ClearFilterTextSurveyType_' + SCViewModel.SelectedCheckedSurveyTypeList()[k].SurveyType_Id + '" data-bind="click: ClearSurveyTypeFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
            }

            document.getElementById('DynamicSurveyTypeOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < SCViewModel.SelectedCheckedSurveyTypeList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterTextSurveyType_' + SCViewModel.SelectedCheckedSurveyTypeList()[k].SurveyType_Id), { click: SCViewModel.ClearSurveyTypeFilterSelection }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetSurveyTypeFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearSurveyTypeFilterSelection(data, event) {
        try {
            var ProcessId = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicSurveyTypeFilters_' + ProcessId).innerHTML = "";

            $('.fa-check.' + ProcessId).css({ 'display': 'none' });
            if (SCViewModel.SelectedCheckedSurveyTypeList().length > 0) {
                SCViewModel.SelectedCheckedSurveyTypeList.remove(function (item) { return item.SurveyType_Id == ProcessId })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearSurveyTypeFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function SetSurveyComponentFilterSelection() {
        try {
            document.getElementById('DynamicSurveyComponentOptedFilters').innerHTML = "";

            var contentHtml = "";
            for (var k = 0; k < SCViewModel.SelectedCheckedSurveyComponentList().length; k++) {
                contentHtml += '<div id="DynamicSurveyComponentOptedFilters' + SCViewModel.SelectedCheckedSurveyComponentList()[k].SurveyCategory_Id + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">Survey Component </span> : ' + SCViewModel.SelectedCheckedSurveyComponentList()[k].SurveyCategory_Name + '<span class="f-clear" id="ClearFilterTextSurveyComponent_' + SCViewModel.SelectedCheckedSurveyComponentList()[k].SurveyCategory_Id + '" data-bind="click: ClearSurveyComponentFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
            }

            document.getElementById('DynamicSurveyTypeOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < SCViewModel.SelectedCheckedSurveyComponentList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterTextSurveyComponent_' + SCViewModel.SelectedCheckedSurveyComponentList()[k].SurveyCategory_Id), { click: SCViewModel.ClearSurveyComponentFilterSelection }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetSurveyComponentFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearSurveyComponentFilterSelection(data, event) {
        try {
            var ProcessId = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicSurveyComponentOptedFilters' + ProcessId).innerHTML = "";

            $('.fa-check.' + ProcessId).css({ 'display': 'none' });
            if (SCViewModel.SelectedCheckedSurveyComponentList().length > 0) {
                SCViewModel.SelectedCheckedSurveyComponentList.remove(function (item) { return item.SurveyCategory_Id == ProcessId })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearSurveyComponentFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function ClearOrgFilterSelection(data, event) {
        try {
            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

            $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
            if (SCViewModel.SelectedCheckedList().length > 0) {
                SCViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID });
            }

            //Logic to re-set the BU list
            SCViewModel.BusinessUnitListForFilters([]);
            if (SCViewModel.SelectedCheckedList().length > 0) {
                var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    for (var m = 0; m < SCViewModel.SelectedCheckedList().length; m++) {
                        if (result.SubLevelId() == SCViewModel.SelectedCheckedList()[m].SubLevelId)
                            return new BusinessUnitModelDUP(result);
                    }
                });
                SCViewModel.BusinessUnitListForFilters(mappedBuList);
                //Main tain this list to retain the org filters on deselection of applicability filters
                SCViewModel.FinalOrgFilterList(mappedBuList);

            }
            else {
                SCViewModel.BusinessUnitListForFilters([]);
                var mappedBuList = $.map(SCViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    return new BusinessUnitModelDUP(result);
                });
                SCViewModel.BusinessUnitListForFilters(mappedBuList);
                SCViewModel.FinalOrgFilterList(mappedBuList);
                $('#BUFilterError').hide();
            }
            //Set count of BU's selected
            if (SCViewModel.BusinessUnitListForFilters().length > 0) {
                SCViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return SCViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                SCViewModel.BusinessUnitListForFilters(SCViewModel.DistinctFileredBUs());
            }

            if (SCViewModel.SelectedCheckedList().length > 0 || SCViewModel.SelectedCheckedBUList().length > 0)
                SCViewModel.NumberOfBUsSelected(SCViewModel.BusinessUnitListForFilters().length);
            else
                SCViewModel.NumberOfBUsSelected(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function SetFilterSelection() {
        try {
            document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
            //Mark Org levels filter seletion
            var contentHtml = "";
            for (var k = 0; k < SCViewModel.SelectedCheckedList().length; k++) {
                contentHtml += '<div id="DynamicOptedFilters_' + SCViewModel.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">' + SCViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + SCViewModel.SelectedCheckedList()[k].SubLevelName + '<span class="f-clear" id="ClearFilterText_' + SCViewModel.SelectedCheckedList()[k].SubLevelId + '" data-bind="click:ClearOrgFilterSelection"><i class="demo-icon icon-cross_special"></i></span></span></div>';
            }
            document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < SCViewModel.SelectedCheckedList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterText_' + SCViewModel.SelectedCheckedList()[k].SubLevelId), { click: SCViewModel.ClearOrgFilterSelection }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetFilterSelection() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitModelDUP(item) {
        try {
            var self = this;
            self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
            self.BU_ID = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
            self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
            self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
            self.BU_NAME = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
            self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
            self.SubLevelId = ko.observable(item.SubLevelId());
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModelDUP() method in SurveyConfig.js';
            logger.logMessage(msg);
        }
    }

    function getSurveysBasedOnTypeExcel(Type) {
        try {
            return $.ajax({
                url: "/api/Survey/GetCreatedSurveys",
                type: "GET",
                data: { "surveyTypeId": Type },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {

                    if (jsonResult != null)
                    {

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                        {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else if (jsonResult.length > 0)
                        {
                            SCViewModel.CreatedSurveyListExcel([]);
                            var mappedSurveyListgroup = $.map(jsonResult, function (result) {
                                var SurveyModelObj = new SurveySetupModel(result);
                                return SurveyModelObj;
                            });
                            SCViewModel.CreatedSurveyListExcel(mappedSurveyListgroup);
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);

                })
                .fail(function (jsonnResult, error) {

                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);

                });
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from getallSurveysBasedonType() method in CreateSurvey.js';
            logger.logMessage(msg);
        }
    }

    //-------excel download and upload ends here
    function GetAllRiskAreas(SurveyType) {
        try {
            SCViewModel.RiskAreaList([]);
            GetAllRiskAreaAjax = {

                url: "/api/Configuration/GetAllRiskAreasByProfile",
                data: {
                    "SurveyProfileId": (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    "AreaType": SurveyType
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };


            $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null)
                {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }

                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {

                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        if (result.Parent_Flag == 0) {
                            var RiskAreaModelObj = new RiskAreaModel(result);
                            return RiskAreaModelObj;
                        }

                    });
                    var mappedCompleteRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;

                    });
                    var mappedRiskAreaIdsList = $.map(jsonResult, function (result) {
                        if (result.Parent_Flag == 0) {
                            var RiskAreaModelObjIds = new RiskAreaModel(result);
                            return RiskAreaModelObjIds.RiskAreaId();
                        }
                    });

                    SCViewModel.AllAreaListIds(mappedRiskAreaIdsList)
                    SCViewModel.RiskAreaList(mappedRiskAreaList);
                    SCViewModel.CompleteAreaList(mappedCompleteRiskAreaList);

                    if (SurveyType == "QTDR") {

                        $("#menuDiv").css("width", "191px");
                        $("#PreviewQuestionnaire").modal('show');
                        //$("#ddlAreaList").multiselect('destroy');
                        $("#ddlArea").multiselect();
                        $("#ddlArea").multiselect('refresh');
                    }
                    else {

                        $("#menuDiv").css("width", "191px");
                        $("#Preview").modal('show');
                        //  $("#ddlAreaList").multiselect('destroy');
                        $("#ddlAreaList").multiselect();
                        $("#ddlAreaList").multiselect('refresh');
                        $('#loadingImgMain').hide();
                        $('#PreviewQuestionsDiv').hide();
                        $('#loadingImgMain').show();
                    }
                    GetQuestionsBySelectedAreas_first(SurveyType);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetIndentationLevels() {
        try {
            return $.ajax({
                url: "/api/Survey/GetIndentationLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, Success) {

                    if (jsonResult != null)
                    {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            var MappedLevelList = $.map(jsonResult, function (result) {
                                return new IndentationLevelsModel(result);
                            });
                            SCViewModel.availableLevelId([]);
                            SCViewModel.availableLevelId(MappedLevelList);
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                })
                .fail(function (jsonResult, error) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetIndentationLevels() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function PreviewToggle(data, event) {
        try {

            if (SCViewModel.SurveyType() != 'QTDR') {
                if ($("#togglePreviewQualControl").is(':checked')) {
                    SCViewModel.PreviewView(true);
                }
                else {
                    SCViewModel.PreviewView(false);
                }
                if (SCViewModel.SurveyType() == 'QLDR')
                    BindDynamicHtmlQualitative();
                if (SCViewModel.SurveyType() == 'CDR')
                    BindDynamicHtmlForControls();
            }
            else {
                if ($("#togglePreview").is(':checked')) {
                    SCViewModel.PreviewView(true);
                }
                else {
                    SCViewModel.PreviewView(false);
                }
                BindDynamicHtmlQuantitative();
            }
        }
        catch (e) {
            var msg = 'exception' + e + ' InherentDataToggle() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }

    }


    function GetAllRiskAreasForPreview(SurveyType, BuId) {
        try {
            SCViewModel.MappedRiskAreasFlag(true);
            GetAllRiskAreaAjax = {
                url: "/api/Configuration/GetAllRiskAreasPreview",
                data: {
                    "SurveyProfileId": (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    "AreaType": SurveyType, "BuId": BuId
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };

            $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreasForPreview() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                    {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }

                SCViewModel.RiskAreaList([]);
                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                    SCViewModel.DisablePreviewSaveBtn(true);
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        //if (result.Parent_Id == 0) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;
                        //}

                    });
                    var mappedCompleteRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;

                    });
                    var mappedRiskAreaIdsList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObjIds = new RiskAreaModel(result);
                        return RiskAreaModelObjIds.RiskAreaId();
                    });

                    SCViewModel.AllAreaListIds(mappedRiskAreaIdsList)
                    SCViewModel.RiskAreaList(mappedRiskAreaList);

                    if (mappedRiskAreaList.length == 1 && mappedRiskAreaList[0].RiskAreaId() == 0) {
                        SCViewModel.RiskAreaList([]);
                        SCViewModel.MappedRiskAreasFlag(false);
                    }

                    SCViewModel.CompleteAreaList(mappedCompleteRiskAreaList);
                    SCViewModel.SurveyTypeId(SurveyType);
                    if (SCViewModel.SurveyTypeId() == "QTDR") {

                        //$("#menuDiv").css("display", "block");
                        //$("#menuDiv").css("width", "191px");
                        $("#PreviewNewQuestion").modal('show');
                        $('#loadingImgMain').hide();
                        $("#MainTabDiv").show();
                        $('#MainTabDivQ').show()

                        $("#CATabQ").tabs();
                        $("#CATabQ").tabs('refresh');
                        $("#CATabQ").tabs({ active: 0 });
                        scrollableTabs();
                        $($("#CATabQ li").get(0)).trigger('click');

                    }
                    else {
                        $('#PreviewNewQuestionQualControls').modal('show');
                        $('#CATabQualControlPreview').tabs();
                        $('#CATabQualControlPreview').tabs('refresh');
                        $('#CATabQualControlPreview').tabs({ active: 0 });
                        scrollableTabs();
                        $($('#PreviewMappingAreaTabQualCtrlUL li').get(0)).trigger('click');
                    }

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreasForPreview() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetQuestionsBySelectedAreas_first(SurveyType) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetAllRiskAreaAjax = {
                url: "/api/Configuration/GetAllRiskAreaDetails",
                type: "POST",
                headers: headers,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    BuId: SCViewModel.SelectedBuId(),
                    SurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    RiskAreaIds: SCViewModel.AllAreaListIds()
                })
            };


            return $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQuestionsBySelectedAreas_first() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                        if (jsonResult.length != null) {
                            var MappedQuestionList = $.map(jsonResult, function (result) {
                                return new QuestionListModel(result);
                            });

                            var MappedCheckedAreasList = $.map(jsonResult, function (result) {
                                var RiskAreaModelObjIds = new QuestionListModel(result);
                                if (RiskAreaModelObjIds.IsApplicable() && RiskAreaModelObjIds.Is_Child_Flag() == 0) {
                                    return RiskAreaModelObjIds.RiskAreaId();
                                }
                                else {
                                    if (RiskAreaModelObjIds.IsApplicable() && RiskAreaModelObjIds.Is_Child_Flag() == 1) {
                                        return RiskAreaModelObjIds.Parent_Id();
                                    }
                                }
                            });

                            if (MappedCheckedAreasList.length > 0) {
                                SCViewModel.AreasSelected = ko.computed(function () {
                                    return ko.utils.arrayGetDistinctValues(MappedCheckedAreasList).sort();
                                });

                                if (!SCViewModel.IsBulkAction() || SCViewModel.SelectedBuIdList().length == 1) {
                                    SCViewModel.SelectedAreas(SCViewModel.AreasSelected().slice(0));
                                }
                                else {
                                    SCViewModel.SelectedAreas([]);
                                }
                                if (SurveyType == "QTDR") {
                                    //   $("#ddlAreaList").multiselect('destroy');
                                    $("#ddlArea").multiselect();
                                    $("#ddlArea").multiselect('refresh');
                                    $('#QTDRButtonID').click();
                                }
                                else {

                                    //  $("#ddlAreaList").multiselect('destroy');
                                    $("#ddlAreaList").multiselect();
                                    $("#ddlAreaList").multiselect('refresh');
                                    $('#GetSelectedAreasButtonID').click();
                                }
                            }
                            else {

                                $('#MainTabDiv').hide();
                                if (SurveyType == "QTDR") {
                                    $("#ddlArea").multiselect();
                                    $("#ddlArea").multiselect('refresh');
                                }
                                else {
                                    $('#loadingImgMain').hide();
                                    $("#ddlAreaList").multiselect();
                                    $("#ddlAreaList").multiselect('refresh');
                                }
                            }


                        }
                        else {
                            SCViewModel.QuestionsForCheckedAreasList([]);
                        }
                    }
                }
                else {
                    logger.logError('Some error occured while fetching areas. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionsBySelectedAreas_first() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionsBySelectedAreas_first() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionsBySelectedAreas_first() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetDetails(data, event) {
        try {
            if (data.SelectedAreas().length <= 0) {
                $('#NoRiskAreasSelected').show()
            }
            else {
                $('#NoRiskAreasSelected').hide()
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                GetAllRiskAreaAjax = {
                    url: "/api/Configuration/GetSelectedRiskAreas",
                    type: "POST",
                    headers: headers,
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        RiskAreaIds: data.SelectedAreas(),
                        AreaType: (SCViewModel.ClickedSurveyProfileId() != -999) ? data.SurveyType() : SCViewModel.SelectedSurveyTypeforSummary(),
                        BuId: data.SelectedBuId(),
                        SurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId())
                    })
                };

            }
            $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {

                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;
                    });
                    SCViewModel.AreaList([]);
                    SCViewModel.AreaList(mappedRiskAreaList);
                    SCViewModel.SelectedRiskAreaId(SCViewModel.AreaList()[0].RiskAreaId());
                    GetQuestionsBySelectedAreas_second();
                }
                else if (jsonResult[0].RiskAreaId == 0 && jsonResult[0].RiskAreaName == null) {
                    $('#error').show();
                    $('#MainTabDiv').empty();
                    $('#MainTabDiv').hide();
                    SCViewModel.AreaList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetQuestionsBySelectedAreas_second() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetAllRiskAreaAjax = {
                url: "/api/Configuration/GetAllRiskAreaDetails",
                type: "POST",
                headers: headers,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    BuId: SCViewModel.SelectedBuId(),
                    SurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    RiskAreaIds: SCViewModel.SelectedAreas()
                })
            };


            return $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQuestionsBySelectedAreas_second() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                    if (jsonResult.length != null) {
                        var MappedQuestionList = $.map(jsonResult, function (result) {
                            return new QuestionListModel(result);
                        });
                        $("#MainTabDiv").show();
                        SCViewModel.QuestionsList([]);
                        Object = SCViewModel.QuestionsList(MappedQuestionList);

                        if (SCViewModel.IsBulkAction() && SCViewModel.SelectedBuIdList().length > 1) {
                            ko.utils.arrayForEach(SCViewModel.QuestionsList(), function (item) {
                                item.IsApplicable(false);
                            });

                        }

                        $("#CATab").tabs();
                        $('#CATab').tabs('refresh');
                        $('#CATab').tabs({ active: 0 });
                        $($('#CATab li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else {
                        SCViewModel.QuestionsList([]);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionsBySelectedAreas_second() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionsBySelectedAreas_second() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionsBySelectedAreas_second() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function AreaTabClick(data, event) {
        try {

            $('#loadingImgMain').hide();
            $('#PreviewQuestionsDiv').show();
            $('#MappingAreaTabQualCtrlUL li').removeClass('active');
            $('#MappingSubAreaTabQualCtrlUL li').removeClass('active');
            $('#RiskAreaQualCtrlTab_' + data.RiskAreaId()).addClass('active');
            if (data.Parent_Flag() == 0) {
                if (data.Parent_Id() == 0) {
                    SCViewModel.IsSubArea(false);

                }

                SCViewModel.SelectedRiskAreaId(data.RiskAreaId());
                var waffle = 0, pancake = 0;

                ko.utils.arrayForEach(SCViewModel.QuestionsList(), function (item) {
                    ko.utils.arrayForEach(SCViewModel.QuestionsForCheckedAreasList(), function (AgainItem) {
                        if (AgainItem.QuestionId() == item.QuestionId()) {
                            item.IsApplicable(AgainItem.IsApplicable());
                        }
                    });

                    if (item.RiskAreaId() == data.RiskAreaId()) {
                        waffle++;
                    }
                    if (item.RiskAreaId() == data.RiskAreaId() && item.IsApplicable()) {
                        pancake++;
                    }
                });
                SCViewModel.AreaWiseSelectedQuestion([]);
                SCViewModel.QuestionsForCheckedAreasList([]);

                //TableObjectPopup = $("#tblPreviewQuestions").DataTable();
                //TableObjectPopup.destroy();


                //$("#tblPreviewQuestions tbody tr").remove();
                SCViewModel.QuestionsForCheckedAreasList(SCViewModel.QuestionsList.slice(0));

                ko.utils.arrayForEach(SCViewModel.QuestionsForCheckedAreasList(), function (item) {
                    if (item != undefined) {
                        if (item.RiskAreaId() == data.RiskAreaId()) {
                            SCViewModel.AreaWiseSelectedQuestion.push(item);
                        }
                    }
                });
                SCViewModel.QuestionsForCheckedAreasList([]);
                SCViewModel.QuestionsForCheckedAreasList(SCViewModel.AreaWiseSelectedQuestion());
                BindDynamicHTMLforPreviewGrid();

                SCViewModel.ChangeSelectAll((waffle + pancake == 0) ? false : waffle == pancake);
            }
            else {

                ShowSubtabsMapQuestionnaire(data.RiskAreaId())
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in AreaTabClick() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SubAreaTabClick(data, event) {
        try {

            $('#loadingImgMain').hide();
            $('#PreviewQuestionsDiv').show();
            $('#MappingSubAreaTabQualCtrlUL li').removeClass('active');
            $('#RiskAreaQualCtrlTab_' + data.RiskAreaId()).addClass('active');
            if (data.Parent_Flag() == 0) {
                if (data.Parent_Id() == 0) {
                    SCViewModel.IsSubArea(false);

                }

                SCViewModel.SelectedRiskAreaId(data.RiskAreaId());
                var waffle = 0, pancake = 0;

                ko.utils.arrayForEach(SCViewModel.QuestionsList(), function (item) {
                    ko.utils.arrayForEach(SCViewModel.QuestionsForCheckedAreasList(), function (AgainItem) {
                        if (AgainItem.QuestionId() == item.QuestionId()) {
                            item.IsApplicable(AgainItem.IsApplicable());
                        }
                    });

                    if (item.RiskAreaId() == data.RiskAreaId()) {
                        waffle++;
                    }
                    if (item.RiskAreaId() == data.RiskAreaId() && item.IsApplicable()) {
                        pancake++;
                    }
                });
                SCViewModel.AreaWiseSelectedQuestion([]);
                SCViewModel.QuestionsForCheckedAreasList([]);

                //TableObjectPopup = $("#tblPreviewQuestions").DataTable();
                //TableObjectPopup.destroy();


                //$("#tblPreviewQuestions tbody tr").remove();
                SCViewModel.QuestionsForCheckedAreasList(SCViewModel.QuestionsList.slice(0));

                ko.utils.arrayForEach(SCViewModel.QuestionsForCheckedAreasList(), function (item) {
                    if (item != undefined) {
                        if (item.RiskAreaId() == data.RiskAreaId()) {
                            SCViewModel.AreaWiseSelectedQuestion.push(item);
                        }
                    }
                });
                SCViewModel.QuestionsForCheckedAreasList([]);
                SCViewModel.QuestionsForCheckedAreasList(SCViewModel.AreaWiseSelectedQuestion());
                BindDynamicHTMLforPreviewGrid();

                SCViewModel.ChangeSelectAll((waffle + pancake == 0) ? false : waffle == pancake);
            }
            else {

                ShowSubtabsMapQuestionnaire(data.RiskAreaId())
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in AreaTabClick() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHTMLforPreviewGrid() {
        try {
            var HTML = "";
            HTML += '<div id="PreviewQuestionsDiv">' +
                ' <table id="tblPreviewQuestions" class="table table-bordered border-0" cellspacing="0">' +
                ' <thead>' +
                '<tr>' +
                '  <th style="display:none"> Question Id</th>' +
                '  <th style="display:none"> Area Id</th>' +
                ' <th class="text-center" style="width: 10%;">' +
                '    <label class="cc-checkbox">' +
                '       <input  type="checkbox" data-bind="checked: ChangeSelectAll, event: {change: SelectAllQuestionnaireByArea}">' +
                '      <span class="cc-facet-result-text tag-text">Select All</span>' +
                ' </label>' +
                '</th>' +
                '<th class="site_name" style="width:150em"> Question Name</th>' +

                '</tr>' +
                '</thead>' +
                '<tbody data-bind="foreach: $root.QuestionsForCheckedAreasList">' +
                '   <tr>' +
                '      <td id="QuestionId" style="display:none" data-bind="text: RiskFactorId"></td>' +
                '     <td id="AreaId" style="display:none" data-bind="text: RiskAreaId"></td>' +
                '    <td class="text-center">' +
                '       <label class="cc-checkbox">' +
                '          <input type="checkbox" data-bind="checked: IsApplicable" />' +
                '         <span class="cc-facet-result-text tag-text"></span>' +
                '    </label>' +

                '</td>' +
                '<td id="QuestionName" style="text-align: left;" data-bind="text: Question"></td>' +
                '</tr>' +

                '</tbody>' +
                ' </table>' +
                '<b></b>' +
                '</div>';
            $("#DynamichtmlTableDiv").html("");
            $("#DynamichtmlTableDiv").html(HTML);
            var element = $('#DynamichtmlTableDiv')[0];
            ko.cleanNode(element);
            ko.applyBindings(SCViewModel, document.getElementById('DynamichtmlTableDiv'));
            $("#tblPreviewQuestions").DataTable({
                "iDisplayLength": 25
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHTMLforPreviewGrid() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function ShowSubtabsMapQuestionnaire(Id) {
        try {
            SCViewModel.SubAreasList([]);
            var x = [];
            for (var i = 0; i < SCViewModel.CompleteAreaList().length; i++) {
                if (SCViewModel.CompleteAreaList()[i].Parent_Id() == Id) {

                    x.push(SCViewModel.CompleteAreaList()[i]);

                }

            }
            SCViewModel.SubAreasList(x);
            SCViewModel.IsSubArea(true);
            $('#SubAreaTabDiv').tabs();
            $('#SubAreaTabDiv').tabs('refresh');
            $('#SubAreaTabDiv').tabs({
                active: 0
            });
            $($('#SubAreaTabDiv li').get(0)).trigger('click');
            scrollableTabs();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ShowSubtabsMapQuestionnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function BindSubTabsPreview(Id) {
        try {
            SCViewModel.IsSubAreapreview(true);
            SCViewModel.SubAreasPreviewList([]);
            var x = [];
            for (var i = 0; i < SCViewModel.CompleteAreaList().length; i++) {
                if (SCViewModel.CompleteAreaList()[i].Parent_Id() == Id) {

                    x.push(SCViewModel.CompleteAreaList()[i]);

                }

            }
            SCViewModel.SubAreasPreviewList([]);
            SCViewModel.SubAreasPreviewList(x);
            $('#SubAreaTabDivPreview').tabs();
            $('#SubAreaTabDivPreview').tabs('refresh');
            $('#SubAreaTabDivPreview').tabs({
                active: 0
            });
            scrollableTabs();
            $($('#PreviewMappingSubAreaTabQualCtrlUL li').get(0)).trigger('click');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindSubTabsPreview() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }
    function ClosePreviewPopUp() {
        try {
            SCViewModel.SubAreasList([]);
            $('#SubAreaTabDiv').hide();
            $("#Preview").modal('hide');
            SCViewModel.AreaList([]);
            $("#ddlArea").multiselect();
            $("#ddlArea").multiselect('refresh');
            $("#ddlArea").multiselect('destroy');
            SCViewModel.QuestionsForCheckedAreasList([]);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in ClosePreviewPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AreaTabClickPreviewQuestion(data, event) {
        if (SCViewModel.PreviewEditUpdated() == true) {
            app.showMessage('Please save the data before moving to other areas.', 'Warning', ['Save', 'Cancel'], true, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                .then(function (option) {
                    if (option === 'Save') {
                        SaveQuestionPreview(data, event);
                    }
                    AreaTabClickPreviewQuestionAccept(data, event);
                });
        }
        else
            AreaTabClickPreviewQuestionAccept(data, event);
    }

    function AreaTabClickPreviewQuestionAccept(data, event) {
        try {
            $('#loadingImgMain').hide();
            $('#NewPreviewQuestionsDiv').show();
            $('#SRTabDiv').show();
            SCViewModel.SelectedRiskAreaId(data.RiskAreaId());
            SCViewModel.SelectAllCommentsFlag(false);
            SCViewModel.SelectAllDocsFlag(false);
            SCViewModel.tableStateSave(false);

            if (SCViewModel.SurveyTypeId() == "QTDR") {
                //if (SCViewModel.SurveyDashBoard.RoutedFrom() == "Dashboard" && SCViewModel.SurveyStatus() != 'Survey Review - Pending'&& SCViewModel.ValuesChanged()) {
                //        CheckForDirtyData(data, event);
                //    }
                //else{
                $('#PreviewMappingAreaTabQuantUL li').removeClass('active');
                $('#AreaQuantTab_' + data.RiskAreaId()).addClass('active');
                SCViewModel.ClickedRiskAreaId(data.RiskAreaId());
                GetQuantRiskFactors();
                // }
            }
            else if (SCViewModel.SurveyTypeId() == "QLDR") {

                $('#QualControlsDiv').html("");
                $('#PreviewMappingAreaTabQualCtrlUL li').removeClass('active');
                $('#PreviewMappingSubAreaTabQualCtrlUL li').removeClass('active');
                $('#AreaQualCtrlTab_' + data.RiskAreaId()).addClass('active');
                SCViewModel.ClickedRiskAreaId(data.RiskAreaId());
                if (data.Parent_Flag() == 0) {
                    if (data.Parent_Id() == 0) {
                        SCViewModel.IsSubAreapreview(false);
                    }
                    GetQualColumnDetails().then(function () {
                        GetQualResponseDetails().then(function () {
                            if (SCViewModel.ParentResponseMandatoryQual() === true) {
                                for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {

                                    SCViewModel.QualResponseListData()[i].Is_ResponseMandatory(true);
                                }
                            }


                            if (SCViewModel.ParentCommentMandatoryQual() === true) {
                                for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {

                                    SCViewModel.QualResponseListData()[i].Is_CommentMandatory(true);
                                }
                            }

                            if (SCViewModel.ParentDocumentMandatoryQual() === true) {
                                for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {

                                    SCViewModel.QualResponseListData()[i].Is_DocumentMandatory(true);
                                }
                            }
                        })
                    })

                }
                else {
                    BindSubTabsPreview(data.RiskAreaId());
                }

            }
            else {
                //if (SCViewModel.SurveyDashBoard.RoutedFrom() == "Dashboard" && SCViewModel.SurveyStatus() != 'Survey Review - Pending'&& SCViewModel.ValuesChanged()) {
                //            CheckForDirtyData(data, event);
                //        }
                //else{
                $('#QualControlsDiv').html("");
                $('#PreviewMappingAreaTabQualCtrlUL li').removeClass('active');
                $('#PreviewMappingSubAreaTabQualCtrlUL li').removeClass('active');
                $('#AreaQualCtrlTab_' + data.RiskAreaId()).addClass('active');
                SCViewModel.ClickedRiskAreaId(data.RiskAreaId);
                if (data.Parent_Flag() == 0) {
                    if (data.Parent_Id() == 0) {
                        SCViewModel.IsSubAreapreview(false);
                    }
                    GetControlColumnDetails().then(function () {
                        GetControlResponseData().then(function () {
                            if (SCViewModel.ParentResponseMandatoryControl() === true) {
                                for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {

                                    SCViewModel.ControlsResponseData()[i].Is_ResponseMandatory(true);
                                }
                            }


                            if (SCViewModel.ParentCommentMandatoryControl() === true) {
                                for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {

                                    SCViewModel.ControlsResponseData()[i].Is_CommentMandatory(true);
                                }
                            }


                            if (SCViewModel.ParentDocumentMandatoryControl() === true) {
                                for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {

                                    SCViewModel.ControlsResponseData()[i].Is_DocumentMandatory(true);
                                }
                            }

                        })
                    })

                }
                else {
                    BindSubTabsPreview(data.RiskAreaId());
                }

                // }
            }
            //  SCViewModel.ValuesChanged(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TabClick() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }



    ///// Preview quesiont QTDR section

    function GetQuantRiskFactors() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllRiskfactorAreaWiseSurvey",
                data: { "SurveyProfileId": (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), "RiskAreaId": SCViewModel.ClickedRiskAreaId(), "BusinessUnitId": SCViewModel.SelectedBuIdList() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetQuantRiskFactors() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length != 0)
                {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else {

                        var mappedRiskFactorList = $.map(jsonResult, function (result) {
                            return RiskFactorModelObj = new RiskFactorModel(result);
                        });

                        SCViewModel.FactorList(mappedRiskFactorList);
                        //SCViewModel.RiskFactorTabClickOnLoad(1);
                        if (SCViewModel.FactorList().length > 0) {
                            $('#SRFactorTab').show();
                            $('#RfTabResponse').show();
                            $('#QTDRFactorTabs').show();

                        }
                        else {
                            $('#SRFactorTab').hide();
                            $('#RfTabResponse').hide();
                            $('#QTDRFactorTabs').hide();
                        }
                        $('#RfTabResponse').tabs();
                        $($('#RiskFactorTab_' + SCViewModel.FactorList()[0].RiskFactorId()).get(0)).trigger('click');
                        scrollableTabs();
                        //else
                        //    document.getElementById('MainTabDiv').innerHTML = "There are no Risk Areas available for this year of Assessment";
                    }
                }
                else if (jsonResult.length == 0) {
                    SCViewModel.FactorList([]);
                    $('#SRFactorTab').hide();
                    $('#QTDRFactorTabs').hide();
                    SCViewModel.LabelText("There are no Risk Factors available for this Risk Area.");

                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuantRiskFactors() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn-default", primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuantRiskFactors() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuantRiskFactors() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

    }

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorTabClick(data, event) {
        try {
            if (SCViewModel.PreviewEditUpdated() == true) {
                app.showMessage('Please save the data before moving to other tab.', 'Warning', ['Save', 'Cancel'], true, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                    .then(function (option) {
                        if (option === 'Save') {
                            SaveQuestionPreview(data, event);
                        }
                        RiskFactorTabClickAccept(data, event);
                    });
            }
            else
                RiskFactorTabClickAccept(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClick() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorTabClickAccept(data, event) {
        try {
            $('#PreviewMappingFactorTabUL li').removeClass('active');
            $('#RiskFactorTab_' + data.RiskFactorId()).addClass('active');
            SCViewModel.SelectAllCommentsFlag(false);
            SCViewModel.SelectAllDocsFlag(false);
            SCViewModel.tableStateSave(false);
            if (SCViewModel.SurveyTypeId() == "QTDR") {
                $('#DynamicQuestionPreviewHTMLDiv').html("");
                SCViewModel.ClickedRiskFactorId(data.RiskFactorId());
                GetQuanColumnDetails().then(function () {
                    BindQuantiativeTable().then(function () {
                    })
                })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClickAccept() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //Preview questions from here

    function InputChangedRankQuant(data, event) {
        try {
            SCViewModel.DisablePreviewSaveBtn(false);
            SCViewModel.PreviewEditUpdated(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedRankQuant() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function InputChangedRankQual(data, event) {
        try {
            SCViewModel.DisablePreviewSaveBtn(false);
            SCViewModel.PreviewEditUpdated(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedRankQual() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function InputChangedRankCont(data, event) {
        try {
            SCViewModel.DisablePreviewSaveBtn(false);
            SCViewModel.PreviewEditUpdated(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedRankCont() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveQuestionPreview(data, event) {
        try {
            SCViewModel.RegenertePreviewQuestionFlag(false);
            SCViewModel.PreviewEditUpdated(false);
            SCViewModel.tableStateSave(true);
            if (SCViewModel.SurveyType() == "QTDR") {
                SaveQuantSortOrder(data);
            }
            else if (SCViewModel.SurveyType() == "QLDR") {
                SaveQualSortOrder(data);
            }
            else {
                SaveContSortOrder(data);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveQuestionPreview() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RegenerateQuestionPreview(data, event) {
        try {
            SCViewModel.RegenertePreviewQuestionFlag(true);
            if (SCViewModel.SurveyType() == "QTDR") {
                SaveQuantSortOrder(data);
            }
            else if (SCViewModel.SurveyType() == "QLDR") {
                SaveQualSortOrder(data);
            }
            else {
                SaveContSortOrder(data);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RegenerateQuestionPreview() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function GetQuanColumnDetails() {
        try {
            return $.ajax({
                url: "/api/Survey/GetQuanColumnDetailsConfig",
                data: {
                    FactorId: SCViewModel.ClickedRiskFactorId(), SurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    BusinessUnitId: SCViewModel.SelectedBuIdList()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (JsonResult, Success) {

                    if (JsonResult.length > 0 && JsonResult[0].Incident_Description != null) {
                        logger.logError(JsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else {
                        SCViewModel.QuanColumnDetails([]);
                        var MappedColumnObject = $.map(JsonResult, function (result) {
                            return new QuanColumnDetailsModel(result);
                        })
                        SCViewModel.QuanColumnDetails(MappedColumnObject)
                    }
                })
                .fail(function (Error, fail) { });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQuanColumnDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function QuanColumnDetailsModel(item) {
        try {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.ColumnName = ko.observable($('<div/>').html(item.ColumnName).text());
            self.ColumnTotal = ko.observable(0);
            self.ColumnSelectFlag = ko.observable(false);
            self.OptionType = ko.observable(item.OptionType);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuanColumnDetailsModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function BindQuantiativeTable() {
        try {


            return $.ajax({
                url: "/api/Survey/GetQuanResponseConfigData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    SurveyId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                    FactorId: SCViewModel.ClickedRiskFactorId(), BusinessUnitId: SCViewModel.SelectedBuIdList()
                }
            })
                .success(function (JsonResult, Success) {

                    if (JsonResult.length > 0 && JsonResult[0].Incident_Description != null) {
                        logger.logError(JsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else {
                        SCViewModel.QuantQuesionSortOrder(0);
                        var MappedResponses = $.map(JsonResult, function (result) {
                            return new QuantitativeResponseModel(result);
                        });
                        SCViewModel.QuanResponseObject(MappedResponses);

                        BindDynamicHtmlQuantitative();
                    }
                })
                .fail(function (fail, error) {

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindQuantiativeTable() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function PreviewEdit() {
        SCViewModel.PreviewEditUpdated(true);
        return true;
    }

    function BindDynamicHtmlQuantitative() {
        try {
            //ResponseList use this in the method that gets the quan resposne details
            //create a sublist in the response list ResponseList (ResponseColumnList)
            var DynamicHTML = "";
            SCViewModel.QuanColumnDetails();


            DynamicHTML = '<table id="tblQuanResponseResponse" class="table table-bordered border-0 table-condensed dataTable" style="table-layout: fixed;" role="grid" aria-describedby="tblResponse_info">';
            DynamicHTML += '<thead>'
            DynamicHTML += '<th class="site_name" rowspan="1" colspan="1" aria-label="No." style="width:10% !important">No.</th>'
            DynamicHTML += '<th style="display:none" class="site_name " rowspan="1" colspan="1" aria-label="No.">QuestionId</th>'
            DynamicHTML += '<th class="site_name w-25" rowspan="1" colspan="1" aria-label="Question">Question</th>'
            DynamicHTML += '<th class="site_name"  aria-label="Sort" style="width:17% !important" data-bind="visible : !$root.PreviewView()">Sort</th>'
            for (var i = 0; i < SCViewModel.QuanColumnDetails().length; i++) {
                if (SCViewModel.PreviewView())
                    DynamicHTML += '<th class="site_name" rowspan="1" colspan="1" aria-label="Response Type" style="width:10% !important" data-bind="visible : $root.PreviewView()">' + SCViewModel.QuanColumnDetails()[i].ColumnName() + '</th>'
                else
                    DynamicHTML += '<th class="site_name" aria-label="Response Type" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Response Mandatory" data-bind="checked: ' + SCViewModel.QuanColumnDetails()[i].ColumnSelectFlag() + ', event: {change :  function (data, event) {$root.CheckAllMandatory(' + SCViewModel.QuanColumnDetails()[i].ColumnId() + ', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>' + SCViewModel.QuanColumnDetails()[i].ColumnName() + '</th>'
            }
            DynamicHTML += '<th class="site_name" aria-label="Sort" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Comment Mandatory"  data-bind="checked: $root.SelectAllCommentsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'cmt\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Comments</th>'
            DynamicHTML += '<th class="site_name" aria-label="Sort" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Document Mandatory" data-bind="checked: $root.SelectAllDocsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'doc\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Documents</th>'
            DynamicHTML += '</thead>';
            DynamicHTML += '<tbody data-bind="foreach: $root.QuanResponseObject">';
            DynamicHTML += '<tr data-bind="css: { GreyBackground : Is_Header() == 1}">';
            DynamicHTML += '<td><input type="text" data-bind="value:OverallRank, event: { change: $root.InputChangedRankQuant }" style="text-align: center;width: 100%;"></td>';
            DynamicHTML += '<td style="display:none" data-bind="text:QuestionId"></td>';
            DynamicHTML += '<td data-bind="text:QuestionText"></td>';
            DynamicHTML += '<td style="text-align:center;display: flex;" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<input class="form-control" data-bind="value:SortOrder, event: { change: $root.InputChangedAreaQuant }" type="text" style="margin-right: 1rem;" />';
            DynamicHTML += '<a href="javascript:void(0)" title="Move above" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.UpFunctionalityQuantSort">';
            DynamicHTML += '<i class="fa fa-arrow-up text-success icon-bar" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '<a href="javascript:void(0)" title="Move Down" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.DownFunctionalityQuantSort">';
            DynamicHTML += '<i class="fa fa-arrow-down text-danger" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '</td>';
            for (var i = 0; i < SCViewModel.QuanColumnDetails().length; i++) {
                if (SCViewModel.PreviewView()) {
                    DynamicHTML += '<td class="site_name text-center" data-bind="visible : $root.PreviewView()">';
                    DynamicHTML += '<div data-bind="visible:Is_Header() != 1">';
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseOptionType() != \'T\' -->';
                    DynamicHTML += '<input class="form-control text-right" type="text" data-bind="value:ResponseList[' + i + '].ResponseValue,event:{change:$root.ValidateResponse}"/>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseOptionType() == \'T\' -->';
                    DynamicHTML += '<input class="form-control" type="text" placeholder="Type Response"/>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '</div>'
                    DynamicHTML += '</td>'
                }
                else {
                    DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()">'
                    DynamicHTML += '<!-- ko if: Is_Header() != 1 -->';
                    DynamicHTML += '<input type="checkbox" data-bind="checked: ResponseList[' + i + '].Is_ResponseMandatory_RT, click: $root.PreviewEdit">'
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '</td>'
                }

            }
            DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<!-- ko if: Is_Header() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_CommentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'
            DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<!-- ko if: Is_Header() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_DocumentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'
            DynamicHTML += '</tr>';
            DynamicHTML += '</tbody>'
            DynamicHTML += '<tfoot data-bind="visible: $root.PreviewView()">';
            DynamicHTML += '<tr>'
            DynamicHTML += '<td rowspan="1" colspan="1"></td>';
            DynamicHTML += '<td class="text-right td-label" style="background-color:transparent" rowspan="1" colspan="1">Total</td>';
            for (var i = 0; i < SCViewModel.QuanColumnDetails().length; i++) {
                if (SCViewModel.QuanColumnDetails()[i].OptionType() != 'T')
                    DynamicHTML += '<td class="text-right td-label" data-bind="text: $root.QuanColumnDetails()[' + i + '].ColumnTotal" rowspan="1" colspan="1"></td>';
                else if (SCViewModel.QuanColumnDetails()[i].OptionType() == 'T')
                    DynamicHTML += '<td class="text-right td-label" rowspan="1" colspan="1"></td>';
            }
            DynamicHTML += '</tr>'
            DynamicHTML += '</tfoot>'
            DynamicHTML += '</table>'

            $('#DynamicQuestionPreviewHTMLDiv').html("");

            $('#DynamicQuestionPreviewHTMLDiv').html(DynamicHTML);
            var element = $('#DynamicQuestionPreviewHTMLDiv')[0];
            ko.cleanNode(element);
            ko.applyBindings(SCViewModel, document.getElementById('DynamicQuestionPreviewHTMLDiv'));
            $('#DynamicQuestionPreviewHTMLDiv').show();
            $('#MainTabDivQ').show();
            $('#tblQuanResponseResponse').DataTable({
                stateSave: SCViewModel.tableStateSave(),
                rowReorder: true,
                columnDefs: [
                    { orderable: true, className: 'reorder', targets: 2 },
                    { orderable: false, targets: '_all' }
                ]
            });
            scrollableTabs();
            //CalculateTotalResponse();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlQuantitative() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function ValidateResponse() {
        //try {
        //    ValidateQuantResponseData();
        //    CalculateTotalResponse();
        //    SCViewModel.ValuesChanged(true);
        //}
        //catch (e) {
        //    var msg = 'Exception: ' + e + ' | Source: ValidateResponse() method in ConfigureSurvey.js';
        //    logger.logMessage(msg);
        //}
    }
    function CalculateTotalResponse() {
        try {
            for (var i = 0; i < SCViewModel.QuanColumnDetails().length; i++) {
                var sum = 0;
                for (var j = 0; j < SCViewModel.QuanResponseObject().length; j++) {
                    for (var k = 0; k < SCViewModel.QuanResponseObject()[j].ResponseList.length; k++) {
                        if (SCViewModel.QuanResponseObject()[j].ResponseList[k].ResponseId() == SCViewModel.QuanColumnDetails()[i].ColumnId())
                            sum += parseFloat(SCViewModel.QuanResponseObject()[j].ResponseList[k].ResponseValue());
                    }
                }

                SCViewModel.QuanColumnDetails()[i].ColumnTotal(sum);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CalculateTotalResponse() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function QuantitativeResponseModel(item) {
        try {
            var self = this;
            self.OverallRank = ko.observable(item.OverallRank);
            self.QuestionId = ko.observable(item.QuestionId);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SortOrder = ko.observable(SCViewModel.QuantQuesionSortOrder() + 1);
            self.Is_Header = ko.observable(item.Is_Header);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
            SCViewModel.QuantQuesionSortOrder(SCViewModel.QuantQuesionSortOrder() + 1);
            var mappedResposneList = $.map(item.ResponseModelObject, function (result) {
                return ResponseObject = new ResponseListModel(result);
            });
            self.ResponseList = mappedResposneList;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function QuantitativeResponseModelSort(item) {
        try {
            var self = this;
            self.OverallRank = ko.observable(item.OverallRank);
            self.QuestionId = ko.observable(item.QuestionId);
            self.Is_Header = ko.observable(item.Is_Header);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SortOrder = ko.observable(SCViewModel.QuantQuesionSortOrder() + 1);
            SCViewModel.QuantQuesionSortOrder(SCViewModel.QuantQuesionSortOrder() + 1);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new ResponseListModelSort(result);
            });
            self.ResponseList = mappedResposneList;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function QuantitativeResponseModelSort1(item) {
        try {
            var self = this;
            self.OverallRank = ko.observable(item.OverallRank());
            self.QuestionId = ko.observable(item.QuestionId());
            self.Is_Header = ko.observable(item.Is_Header);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText()).text());
            self.SortOrder = ko.observable(SCViewModel.QuantQuesionSortOrder() + 1);
            SCViewModel.QuantQuesionSortOrder(SCViewModel.QuantQuesionSortOrder() + 1);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new ResponseListModelSort(result);
            });
            self.ResponseList = mappedResposneList;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function QuantitativeResponseModelSort2(item) {
        try {
            var self = this;
            self.Is_Header = ko.observable(item.Is_Header);
            self.OverallRank = ko.observable(item.OverallRank);
            self.QuestionId = ko.observable(item.QuestionId);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SortOrder = ko.observable(item.SortOrder);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new ResponseListModelSort(result);
            });
            self.ResponseList = mappedResposneList;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ResponseListModelSort(item) {
        var self = this;
        self.ResponseId = ko.observable(item.ResponseId());
        self.ResponseValue = ko.observable($('<div/>').html(item.ResponseValue()).text());
        self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
        self.ResponseOptionType = ko.observable(item.ResponseOptionType);
    }

    function ResponseListModel(item) {
        var self = this;
        self.ResponseId = ko.observable(item.ResponseId);
        self.ResponseValue = ko.observable($('<div/>').html(item.ResponseValue).text());
        self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
        self.ResponseOptionType = ko.observable(item.ResponseOptionType);
    }
    //sort feature quant
    function InputChangedAreaQuant(data, event) {
        try {
            $('#valError').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= SCViewModel.QuanResponseObject().length && data.SortOrder() > 0) {

                var riskareacount = SCViewModel.QuanResponseObject().length - 1;
                SCViewModel.QuanResponseObject.remove(function (item) { return item.QuestionId() == data.QuestionId() })
                SCViewModel.QuantQuesionSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskAreaModel1 = $.map(SCViewModel.QuanResponseObject(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new QuantitativeResponseModelSort1(result);
                    }

                });

                var ChangedModel = new QuantitativeResponseModelSort({
                    OverallRank: data.OverallRank(), QuestionId: data.QuestionId(), QuestionText: data.QuestionText(), SortOrder: data.SortOrder(), Is_Header: data.Is_Header(), ResponseList: $.map(data.ResponseList, function (result) {
                        return ResponseObject = new ResponseListModelSort(result);
                    })
                })

                var Model = [];
                if (MappedRiskAreaModel1.length > 0) {
                    for (var i = 0; i < MappedRiskAreaModel1.length; i++) {
                        var NewModel = new QuantitativeResponseModelSort2({
                            OverallRank: MappedRiskAreaModel1[i].OverallRank(), QuestionId: MappedRiskAreaModel1[i].QuestionId(), Is_Header: MappedRiskAreaModel1[i].Is_Header(), QuestionText: MappedRiskAreaModel1[i].QuestionText(), SortOrder: MappedRiskAreaModel1[i].SortOrder(), ResponseList: $.map(MappedRiskAreaModel1[i].ResponseList, function (result) {
                                return ResponseObject = new ResponseListModelSort(result);
                            })
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskareacount + 1; k++) {
                    var ChangedModel = new QuantitativeResponseModelSort({
                        OverallRank: SCViewModel.QuanResponseObject()[k - 1].OverallRank(), Is_Header: SCViewModel.QuanResponseObject()[k - 1].Is_Header(), QuestionId: SCViewModel.QuanResponseObject()[k - 1].QuestionId(), QuestionText: SCViewModel.QuanResponseObject()[k - 1].QuestionText(), SortOrder: SCViewModel.QuanResponseObject()[k - 1].SortOrder(), ResponseList: SCViewModel.QuanResponseObject()[k - 1].ResponseList
                    })
                    Model.push(ChangedModel);
                }
                SCViewModel.QuanResponseObject([]);
                SCViewModel.QuanResponseObject(Model);

                BindDynamicHtmlQuantitative();

                SCViewModel.DisablePreviewSaveBtn(false);
            }
            else {
                $('#valError').show();
                $('#valError').html("Please enter a valid number")
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedAreaQuant() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function UpFunctionalityQuantSort(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < SCViewModel.QuanResponseObject().length; i++) {

                if (data.QuestionId() == SCViewModel.QuanResponseObject()[i].QuestionId()) {
                    if (i == 0) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = SCViewModel.QuanResponseObject()[i].QuestionId();
                        var y = SCViewModel.QuanResponseObject()[i].QuestionText();
                        var z = SCViewModel.QuanResponseObject()[i].OverallRank();

                        SCViewModel.QuanResponseObject()[i].QuestionId(SCViewModel.QuanResponseObject()[i - 1].QuestionId());
                        SCViewModel.QuanResponseObject()[i].QuestionText(SCViewModel.QuanResponseObject()[i - 1].QuestionText());
                        SCViewModel.QuanResponseObject()[i].OverallRank(SCViewModel.QuanResponseObject()[i - 1].OverallRank());

                        for (var j = 0; j < SCViewModel.QuanColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.QuanResponseObject()[i].ResponseList.length; k++) {
                                if (SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseId() == SCViewModel.QuanColumnDetails()[j].ColumnId()) {
                                    var p = SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue();
                                    SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue(SCViewModel.QuanResponseObject()[i - 1].ResponseList[k].ResponseValue());
                                    SCViewModel.QuanResponseObject()[i - 1].ResponseList[k].ResponseValue(p);
                                }
                            }
                        }

                        SCViewModel.QuanResponseObject()[i - 1].QuestionId(x);
                        SCViewModel.QuanResponseObject()[i - 1].QuestionText(y);
                        SCViewModel.QuanResponseObject()[i - 1].OverallRank(z);
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpFunctionalityQuantSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllForQual(data, event) {

        if (event.target.checked == true) {

            for (i = 0; i < SCViewModel.QuestionsList().length; i++) {
                SCViewModel.QuestionsList()[i].IsApplicable(true);
            }
        }
        else {
            for (i = 0; i < SCViewModel.QuestionsList().length; i++) {
                SCViewModel.QuestionsList()[i].IsApplicable(false);
            }
        }

    }


    //#region MandateAllMethods

    function CheckAllMandatory(type_id, event) {
        try {
            var checkedValue = event.target.checked;
            SCViewModel.tableStateSave(true);
            SCViewModel.PreviewEditUpdated(true);
            if (SCViewModel.SurveyType() == 'QTDR') {
                if (type_id == 'cmt') {
                    SCViewModel.SelectAllCommentsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                        if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0)
                            SCViewModel.QuanResponseObject()[i].Is_CommentMandatory(checkedValue);
                    }
                }
                else if (type_id == 'doc') {
                    SCViewModel.SelectAllDocsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                        if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0)
                            SCViewModel.QuanResponseObject()[i].Is_DocumentMandatory(checkedValue);
                    }
                }
                else if (type_id != 'cmt' && type_id != 'doc') {
                    // for all response types
                    var rtIndex = -1;
                    ko.utils.arrayFilter(SCViewModel.QuanColumnDetails(), function (arr) {
                        if (arr.ColumnId() === parseInt(type_id)) {
                            rtIndex = ko.utils.arrayIndexOf(SCViewModel.QuanColumnDetails(), arr);
                        }
                    });
                    SCViewModel.QuanColumnDetails()[rtIndex].ColumnSelectFlag(checkedValue);

                    for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                        for (j = 0; j < SCViewModel.QuanResponseObject()[i].ResponseList.length; j++) {
                            if (parseInt(SCViewModel.QuanResponseObject()[i].ResponseList[j].ResponseId()) == parseInt(type_id)) {
                                if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0)
                                    SCViewModel.QuanResponseObject()[i].ResponseList[j].Is_ResponseMandatory_RT(checkedValue);
                            }
                        }
                    }
                }
                BindDynamicHtmlQuantitative();
            }
            else if (SCViewModel.SurveyType() == 'QLDR') {
                if (type_id == 'cmt') {
                    SCViewModel.SelectAllCommentsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                        if (SCViewModel.QualResponseListData()[i].IsHeader() == 0)
                            SCViewModel.QualResponseListData()[i].Is_CommentMandatory(checkedValue);
                    }
                }
                else if (type_id == 'doc') {
                    SCViewModel.SelectAllDocsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                        if (SCViewModel.QualResponseListData()[i].IsHeader() == 0)
                            SCViewModel.QualResponseListData()[i].Is_DocumentMandatory(checkedValue);
                    }
                }
                else if (type_id != 'cmt' && type_id != 'doc') {
                    // for all response types
                    var rtIndex = -1;
                    ko.utils.arrayFilter(SCViewModel.QualColumnDetails(), function (arr) {
                        if (arr.ColumnId() === parseInt(type_id)) {
                            rtIndex = ko.utils.arrayIndexOf(SCViewModel.QualColumnDetails(), arr);
                        }
                    });
                    SCViewModel.QualColumnDetails()[rtIndex].ColumnSelectFlag(checkedValue);

                    for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                        for (j = 0; j < SCViewModel.QualResponseListData()[i].ResponseList.length; j++) {
                            if (parseInt(SCViewModel.QualResponseListData()[i].ResponseList[j].ResponseId()) == parseInt(type_id)) {
                                if (SCViewModel.QualResponseListData()[i].IsHeader() == 0)
                                    SCViewModel.QualResponseListData()[i].ResponseList[j].Is_ResponseMandatory_RT(checkedValue);
                            }
                        }
                    }
                }
                BindDynamicHtmlQualitative();
            }
            else if (SCViewModel.SurveyType() == 'CDR') {
                if (type_id == 'cmt') {
                    SCViewModel.SelectAllCommentsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                        if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0)
                            SCViewModel.ControlsResponseData()[i].Is_CommentMandatory(checkedValue);
                    }
                }
                else if (type_id == 'doc') {
                    SCViewModel.SelectAllDocsFlag(checkedValue);
                    for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                        if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0)
                            SCViewModel.ControlsResponseData()[i].Is_DocumentMandatory(checkedValue);
                    }
                }
                else if (type_id != 'cmt' && type_id != 'doc') {
                    // for all response types
                    var rtIndex = -1;
                    ko.utils.arrayFilter(SCViewModel.QualColumnDetails(), function (arr) {
                        if (arr.ColumnId() === parseInt(type_id)) {
                            rtIndex = ko.utils.arrayIndexOf(SCViewModel.QualColumnDetails(), arr);
                        }
                    });
                    SCViewModel.QualColumnDetails()[rtIndex].ColumnSelectFlag(checkedValue);

                    for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                        for (j = 0; j < SCViewModel.ControlsResponseData()[i].ResponseList.length; j++) {
                            if (parseInt(SCViewModel.ControlsResponseData()[i].ResponseList[j].ResponseId()) == parseInt(type_id)) {
                                if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0)
                                    SCViewModel.ControlsResponseData()[i].ResponseList[j].Is_ResponseMandatory_RT(checkedValue);
                            }
                        }
                    }
                }
                BindDynamicHtmlForControls();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CheckAllMandatory() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#region Controls-MandateAllMethods

    function ConfirmRespMandateControlAll() {
        app.showMessage('Are you sure you want to mandate responses for the entire questionnaire?', 'Mandate the responses for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    RespMandateControlAll();
                }
            });
    }

    function RespMandateControlAll() {
        try {
            SCViewModel.ParentResponseMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveControlSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {

                        if (jsonResult.startsWith("INC")) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                                for (j = 0; j < SCViewModel.ControlsResponseData()[i].ResponseList.length; j++) {
                                    if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0) {
                                        SCViewModel.ControlsResponseData()[i].ResponseList[j].Is_ResponseMandatory_RT(true);
                                    }
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlForControls();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg') == -1) ? 'Responses saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in RespMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RespMandateControlAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in RespMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RespMandateControlAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmCommentMandateControlAll() {
        app.showMessage('Are you sure you want to mandate comments for the entire questionnaire?', 'Mandate the comments for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    CommentMandateControlAll();
                }
            });
    }

    function CommentMandateControlAll() {
        try {
            SCViewModel.ParentCommentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveControlSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC"))
                        {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                        {
                            for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                                if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0) {
                                    SCViewModel.ControlsResponseData()[i].Is_CommentMandatory(true);
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlForControls();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg') == -1) ? 'Comments saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in CommentMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CommentMandateControlAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in CommentMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CommentMandateControlAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmDocumentMandateControlAll() {
        app.showMessage('Are you sure you want to mandate documents for the entire questionnaire?', 'Mandate the documents for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    DocumentMandateControlAll();
                }
            });
    }

    function DocumentMandateControlAll() {
        try {
            SCViewModel.ParentDocumentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveControlSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC"))
                        {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                        {
                            for (i = 0; i < SCViewModel.ControlsResponseData().length; i++) {
                                if (SCViewModel.ControlsResponseData()[i].IsHeader() == 0) {
                                    SCViewModel.ControlsResponseData()[i].Is_DocumentMandatory(true);
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlForControls();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg') == -1) ? 'Documents saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in DocumentMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DocumentMandateControlAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in DocumentMandateControlAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DocumentMandateControlAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#endregion

    //#region Qual-MandateAllMethods

    function ConfirmRespMandateQualAll() {
        app.showMessage('Are you sure you want to mandate responses for the entire questionnaire?', 'Mandate the responses for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    RespMandateQualAll();
                }
            });
    }

    function RespMandateQualAll() {
        try {
            SCViewModel.ParentResponseMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveQualSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC"))
                        {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                                for (j = 0; j < SCViewModel.QualResponseListData()[i].ResponseList.length; j++) {
                                    if (SCViewModel.QualResponseListData()[i].IsHeader() == 0) {
                                        SCViewModel.QualResponseListData()[i].ResponseList[j].Is_ResponseMandatory_RT(true);
                                    }
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQualitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg') == -1) ? 'Responses saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in RespMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RespMandateQualAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in RespMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RespMandateQualAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmCommentMandateQualAll() {
        app.showMessage('Are you sure you want to mandate comments for the entire questionnaire?', 'Mandate the comments for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    CommentMandateQualAll();
                }
            });
    }

    function CommentMandateQualAll() {
        try {
            SCViewModel.ParentCommentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Survey/SaveQualSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);



            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {

                        if (jsonResult.startsWith("INC")) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                                if (SCViewModel.QualResponseListData()[i].IsHeader() == 0) {
                                    SCViewModel.QualResponseListData()[i].Is_CommentMandatory(true);
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQualitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg') == -1) ? 'Comments saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in CommentMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CommentMandateQualAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in CommentMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CommentMandateQualAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmDocumentMandateQualAll() {
        app.showMessage('Are you sure you want to mandate documents for the entire questionnaire?', 'Mandate the documents for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    DocumentMandateQualAll();
                }
            });
    }

    function DocumentMandateQualAll() {
        try {
            SCViewModel.ParentDocumentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveQualSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC"))
                        {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            for (i = 0; i < SCViewModel.QualResponseListData().length; i++) {
                                if (SCViewModel.QualResponseListData()[i].IsHeader() == 0) {
                                    SCViewModel.QualResponseListData()[i].Is_DocumentMandatory(true);
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQualitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg') == -1) ? 'Documents saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in DocumentMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DocumentMandateQualAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in DocumentMandateQualAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DocumentMandateQualAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#endregion

    //#region Quan-MandateAllMethods

    function ConfirmRespMandateQuanAll() {
        app.showMessage('Are you sure you want to mandate responses for all response types in the entire questionnaire?', 'Mandate the responses for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
            .then(function (option) {
                if (option === 'Confirm') {
                    RespMandateQuanAll();
                }
            });
    }

    function RespMandateQuanAll() {
        try {
            SCViewModel.ParentResponseMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Survey/SaveQuanSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {

                        if (jsonResult.startsWith("INC")) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                                for (j = 0; j < SCViewModel.QuanResponseObject()[i].ResponseList.length; j++) {
                                    if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0) {
                                        SCViewModel.QuanResponseObject()[i].ResponseList[j].Is_ResponseMandatory_RT(true);
                                    }
                                }
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQuantitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg') == -1) ? 'Responses saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsesSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in RespMandateQuanAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RespMandateQuanAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in RespMandateQuanAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RespMandateQuanAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmCommentMandateAll() {
        try {
            app.showMessage('Are you sure you want to mandate comments for the entire questionnaire ?', 'Mandate the comments for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        CommentMandateAll();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConfirmCommentMandateAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function CommentMandateAll() {
        try {
            SCViewModel.ParentCommentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Survey/SaveQuanSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC")) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                                if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0)
                                    SCViewModel.QuanResponseObject()[i].Is_CommentMandatory(true);
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQuantitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg') == -1) ? 'Comments saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CommentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in CommentMandateAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CommentMandateAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in CommentMandateAll()method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CommentMandateAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConfirmDocumentMandateAll() {
        try {
            app.showMessage('Are you sure you want to mandate documents for the entire questionnaire ?', 'Mandate the documents for the entire questionnaire', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        DocumentMandateAll();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConfirmDocumentMandateAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function DocumentMandateAll() {
        try {
            SCViewModel.ParentDocumentMandatory(true);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Survey/SaveQuanSelectAll",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ SurveyId: SCViewModel.ClickedSurveyProfileId(), BusinessUnitId: SCViewModel.SelectedBuIdList()[0], Parent_Response_Mandatory: SCViewModel.ParentResponseMandatory(), Parent_Comment_Mandatory: SCViewModel.ParentCommentMandatory(), Parent_Document_Mandatory: SCViewModel.ParentDocumentMandatory() })
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith("INC")) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            for (i = 0; i < SCViewModel.QuanResponseObject().length; i++) {
                                if (SCViewModel.QuanResponseObject()[i].Is_Header() == 0)
                                    SCViewModel.QuanResponseObject()[i].Is_DocumentMandatory(true);
                            }
                            SCViewModel.tableStateSave(true);
                            BindDynamicHtmlQuantitative();
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg') == -1) ? 'Documents saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocumentsSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in DocumentMandateAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DocumentMandateAll() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in DocumentMandateAll() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DocumentMandateAll() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#endregion

    //#endregion


    function DownFunctionalityQuantSort(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < SCViewModel.QuanResponseObject().length; i++) {

                if (data.QuestionId() == SCViewModel.QuanResponseObject()[i].QuestionId()) {
                    if (i == SCViewModel.QuanResponseObject().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = SCViewModel.QuanResponseObject()[i].QuestionId();
                        var y = SCViewModel.QuanResponseObject()[i].QuestionText();
                        var z = SCViewModel.QuanResponseObject()[i].OverallRank();

                        SCViewModel.QuanResponseObject()[i].QuestionId(SCViewModel.QuanResponseObject()[i + 1].QuestionId());
                        SCViewModel.QuanResponseObject()[i].QuestionText(SCViewModel.QuanResponseObject()[i + 1].QuestionText());
                        SCViewModel.QuanResponseObject()[i].OverallRank(SCViewModel.QuanResponseObject()[i + 1].OverallRank());

                        SCViewModel.QuanResponseObject()[i + 1].QuestionId(x);
                        SCViewModel.QuanResponseObject()[i + 1].QuestionText(y);
                        SCViewModel.QuanResponseObject()[i + 1].OverallRank(z);

                        for (var j = 0; j < SCViewModel.QuanColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.QuanResponseObject()[i].ResponseList.length; k++) {
                                if (SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseId() == SCViewModel.QuanColumnDetails()[j].ColumnId()) {
                                    var p = SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue();
                                    SCViewModel.QuanResponseObject()[i].ResponseList[k].ResponseValue(SCViewModel.QuanResponseObject()[i + 1].ResponseList[k].ResponseValue());
                                    SCViewModel.QuanResponseObject()[i + 1].ResponseList[k].ResponseValue(p);
                                }
                            }
                        }
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownFunctionalityQuantSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //Quant sort order save
    function SaveQuantSortOrder(data) {
        try {
            $('#DynamicQuestionPreviewHTMLDiv').hide();
            var RegenrateFlag = 0;
            if (SCViewModel.RegenertePreviewQuestionFlag() === true) {
                RegenrateFlag = 1;
            }

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            var obj = $.map(SCViewModel.QuanResponseObject(), function (item) {
                return {
                    QuestionId: item.QuestionId(), Is_CommentMandatory: item.Is_CommentMandatory(), Is_DocumentMandatory: item.Is_DocumentMandatory(),
                    OverallRank: item.OverallRank(), SortOrder: item.SortOrder(), SurveyId: SCViewModel.ClickedSurveyProfileId(), FactorId: SCViewModel.ClickedRiskFactorId(),
                    BusinessUnitId: SCViewModel.SelectedBuIdList()[0], RegenerateFlag: RegenrateFlag,
                    ResponseModelObject: $.map(item.ResponseList, function (row) {
                        return {
                            ResponseId: row.ResponseId(), Is_ResponseMandatory_RT: row.Is_ResponseMandatory_RT()
                        }
                    })
                };
            })
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveQuanResponseSortData",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(obj)
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try
                {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (jsonResult != null)
                    {

                        if (parseInt(jsonResult) != 1 && !jsonResult.startsWith("INC"))
                        {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ChangesSaveSuccessMsg') == -1) ? 'Changes have been successfully saved.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ChangesSaveSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in SaveQuantSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQuantSortOrder() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in SaveQuantSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveQuantSortOrder() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

    }

    //Question Preview code  QLDR

    function GetQualColumnDetails() {
        try {
            return $.ajax({
                url: "/api/Survey/GetQualColumnDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    SurveyProfileId:(SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), AreaId: SCViewModel.ClickedRiskAreaId() }
            })
                .success(function (jsonResult, success) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else
                    {
                        SCViewModel.QualColumnDetails([]);
                        var mappedcolumndetails = $.map(jsonResult, function (result) {
                            return new QualColumnDetailsModel(result);
                        })
                        SCViewModel.QualColumnDetails(mappedcolumndetails);
                    }
                })
                .fail(function (fail, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualColumnDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function QualColumnDetailsModel(item) {
        try {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.ColumnName = ko.observable($('<div/>').html(item.ColumnName).text());
            self.ColumnSelectFlag = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualColumnDetailsModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function QualResposneSelectObject(item) {
        try {
            var self = this;
            self.SelectResponseId = ko.observable(item.SelectResponseId);
            self.SelectResposneOption = ko.observable($('<div/>').html(item.SelectResposneOption).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResposneSelectObject() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function GetQualResponseDetails() {
        try {
            return $.ajax({
                url: "/api/Survey/GetQualitativeResponseConfigData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { SurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), AreaId: SCViewModel.ClickedRiskAreaId(), BusinessUnitId: SCViewModel.SelectedBuIdList() }
            })
                .success(function (jsonResult, Success)
                {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else {
                        SCViewModel.QualResponseListData([]);
                        SCViewModel.QualQuesionSortOrder(0);
                        //have to write the dynamic html logic
                        var mappedResponseList = $.map(jsonResult, function (result) {
                            return new QualResponseModel(result);
                        })
                        SCViewModel.QualResponseListData(mappedResponseList);

                        BindDynamicHtmlQualitative();
                    }
                })
                .fail(function (error, fail) {

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResponseModel(item) {
        try {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId);
            self.LevelId = ko.observable(item.LevelId);
            self.selectedLevelId = ko.observable(item.LevelId);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsHeader = ko.observable(item.IsHeader);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.IsConditional = ko.observable(item.IsConditional);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
            var mappedResposneList = $.map(item.QualResponseObject, function (result) {
                return ResponseObject = new QualResponseObject(result);
            });
            self.ResponseList = mappedResposneList;
            self.SortOrder = ko.observable(SCViewModel.QualQuesionSortOrder() + 1);
            SCViewModel.QualQuesionSortOrder(SCViewModel.QualQuesionSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResponseModelSort(item) {
        try {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId());
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText()).text());
            self.SerialNo = ko.observable(item.SerialNo());
            self.IsHeader = ko.observable(item.IsHeader());
            self.selectedLevelId = ko.observable(item.selectedLevelId);
            self.IsReadOnly = ko.observable(item.IsReadOnly());
            self.IsConditional = ko.observable(item.IsConditional());
            self.ParentQuestionId = ko.observable(item.ParentQuestionId());
            self.ParentResponseId = ko.observable(item.ParentResponseId());
            self.ParentResponseType = ko.observable(item.ParentResponseType());
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new QualResponseObjectSort(result);
            });
            self.ResponseList = mappedResposneList;
            self.SortOrder = ko.observable(SCViewModel.QualQuesionSortOrder() + 1);
            SCViewModel.QualQuesionSortOrder(SCViewModel.QualQuesionSortOrder() + 1);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }


    function QualResponseModelSort1(item) {
        try {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsHeader = ko.observable(item.IsHeader);
            self.selectedLevelId = ko.observable(item.selectedLevelId);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.IsConditional = ko.observable(item.IsConditional);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new QualResponseObjectSort(result);
            });
            self.ResponseList = mappedResposneList;
            self.SortOrder = ko.observable(SCViewModel.QualQuesionSortOrder() + 1);
            SCViewModel.QualQuesionSortOrder(SCViewModel.QualQuesionSortOrder() + 1);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResponseModelSort2(item) {
        try {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId);
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsHeader = ko.observable(item.IsHeader);
            self.selectedLevelId = ko.observable(item.selectedLevelId);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.IsConditional = ko.observable(item.IsConditional);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            var mappedResposneList = $.map(item.ResponseList, function (result) {
                return ResponseObject = new QualResponseObjectSort(result);
            });
            self.ResponseList = mappedResposneList;
            self.SortOrder = ko.observable(item.SortOrder);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResponseObject(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.ResponseValue = ko.observable(item.ResponseValue);
            self.ResponseInputValue = ko.observable(item.ResponseInputValue);
            self.Applicability = ko.observable(item.Applicability);
            self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
            self.ResponseOptionType = ko.observable(item.ResponseOptionType);
            var mappedResposneList = $.map(item.ModelObject, function (result) {
                return ResponseObject = new QualResposneSelectObject(result);
            });
            self.SelectedOptionsList = ko.observableArray(mappedResposneList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseObject() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }
    function QualResponseObjectSort(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId());
            self.ResponseValue = ko.observable(item.ResponseValue());
            self.ResponseInputValue = ko.observable(item.ResponseInputValue());
            self.Applicability = ko.observable(item.Applicability());
            self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
            self.ResponseOptionType = ko.observable(item.ResponseOptionType);
            var mappedResposneList = $.map(item.SelectedOptionsList(), function (result) {
                return ResponseObject = new QualResposneSelectObjectSort(result);
            });
            self.SelectedOptionsList = ko.observableArray(mappedResposneList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResponseObject() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResposneSelectObjectSort(item) {
        try {
            var self = this;
            self.SelectResponseId = ko.observable(item.SelectResponseId());
            self.SelectResposneOption = ko.observable($('<div/>').html(item.SelectResposneOption()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResposneSelectObject() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function QualResposneSelectObject(item) {
        try {
            var self = this;
            self.SelectResponseId = ko.observable(item.SelectResponseId);
            self.SelectResposneOption = ko.observable($('<div/>').html(item.SelectResposneOption).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualResposneSelectObject() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }




    function BindDynamicHtmlQualitative() {
        try {
            SCViewModel.selectedLevelId(null);
            SCViewModel.PreviewEditUpdated(false);
            var DynamicHTML = "";
            //ResponseList use this in the method that gets the quan resposne details
            //create a sublist in the response list ResponseList (ResponseColumnList)
            var DynamicHTML = "";
            DynamicHTML = '<table id="tblResponsequalitative" class="table table-bordered border-0 table-condensed dataTable">';
            DynamicHTML += '<thead>'
            DynamicHTML += '<th class="site_name text-center" style="width:7% !important" aria-label="No.">No.</th>'
            DynamicHTML += '<th class="site_name text-center" style="width:5% !important" aria-label="Levels">Levels</th>'
            DynamicHTML += '<th class="site_name w-25" aria-label="Question">Question</th>'
            DynamicHTML += '<th class="site_name" style="width:10% !Important" aria-label="Sort" data-bind="visible : !$root.PreviewView()">Sort</th>'
            for (var i = 0; i < SCViewModel.QualColumnDetails().length; i++) {
                if (SCViewModel.PreviewView())
                    DynamicHTML += '<th class="site_name" style="width:10% !important" data-bind="visible : $root.PreviewView()">' + SCViewModel.QualColumnDetails()[i].ColumnName() + '</th>'
                else
                    DynamicHTML += '<th class="site_name" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Response Mandatory" data-bind="checked: ' + SCViewModel.QualColumnDetails()[i].ColumnSelectFlag() + ', event: {change :  function (data, event) {$root.CheckAllMandatory(' + SCViewModel.QualColumnDetails()[i].ColumnId() + ', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>' + SCViewModel.QualColumnDetails()[i].ColumnName() + '</th>'
            }
            DynamicHTML += '<th class="site_name text-center" aria-label="Sort" style="width:15% !important;" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Comment Mandatory"  data-bind="checked: $root.SelectAllCommentsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'cmt\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Comments</th>'
            DynamicHTML += '<th class="site_name text-center" aria-label="Sort" style="width:15% !important;" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Document Mandatory" data-bind="checked: $root.SelectAllDocsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'doc\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Documents</th>'
            DynamicHTML += '</thead>';
            DynamicHTML += '<tbody data-bind="foreach: $root.QualResponseListData">';
            DynamicHTML += '<tr data-bind="css: { GreyBackground : IsHeader() == 1}">';
            DynamicHTML += '<td><input type="text" class="text-center" data-bind="value:SerialNo, event: { change: $root.InputChangedRankQual }" style="width: 100%;" /></td>';
            if (SCViewModel.PreviewView() == true) {
                DynamicHTML += '<td class="site_name"><select data-bind ="options:$root.availableLevelId,optionsText:\'LevelName\',optionsValue:\'LevelUId\',value:selectedLevelId, click: $root.PreviewEdit" disabled></select></td>';
            }
            else {
                DynamicHTML += '<td class="site_name"><select data-bind ="options:$root.availableLevelId,optionsText:\'LevelName\',optionsValue:\'LevelUId\',value:selectedLevelId, click: $root.PreviewEdit"></select></td>';
            }
            DynamicHTML += '<td data-bind="text:QuestionText"></td>';
            DynamicHTML += '<td style="text-align:center;display: flex;" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<input class="form-control" data-bind="value:SortOrder, event: { change: $root.InputChangedAreaQual }" type="text" style="margin-right: 1rem;" />';
            DynamicHTML += '<a href="javascript:void(0)" title="Move above" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.UpFunctionalityQualSort">';
            DynamicHTML += '<i class="fa fa-arrow-up text-success icon-bar" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '<a href="javascript:void(0)" title="Move Down" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.DownFunctionalityQualSort">';
            DynamicHTML += '<i class="fa fa-arrow-down text-danger" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '</td>';
            for (var i = 0; i < SCViewModel.QualColumnDetails().length; i++) {
                var ID = 'ResponseList[' + i + '].SelectedOptionsList()';
                if (SCViewModel.PreviewView()) {
                    DynamicHTML += '<td class="site_name" data-bind="visible : $root.PreviewView()">';
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '] != undefined && IsHeader() == 0 -->';

                    // for question where response-option types is not configured
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseOptionType() == \'-\' -->';
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].SelectedOptionsList().length > 0 -->';
                    DynamicHTML += '<select class="form-control" data-bind="options:' + ID + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\'"></select>';
                    DynamicHTML += '<!--/ko-->';

                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].SelectedOptionsList().length == 0 -->';
                    DynamicHTML += '<input class="form-control" type="text" placeholder="Type Response"></input>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // single dropdown
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseOptionType() == \'D\' -->';
                    DynamicHTML += '<select class="form-control" data-bind="options:' + ID + ',optionsCaption:\'Select\',optionsText :\'SelectResposneOption\',optionsValue:\'SelectResponseId\'"></select>';
                    DynamicHTML += '<!--/ko-->';

                    // multi select
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseOptionType() == \'C\' -->';
                    DynamicHTML += '<!--ko foreach: ' + ID + ' -->';
                    DynamicHTML += '<div>';
                    DynamicHTML += '<input type="checkbox" data-bind="checkedValue: SelectResponseId">';
                    DynamicHTML += '<span class="ml-1" data-bind="html: SelectResposneOption"></span>';
                    DynamicHTML += '</div>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // for both radio-buttons and Horizontal radio-buttons
                    DynamicHTML += '<!-- ko if: (ResponseList[' + i + '].ResponseOptionType() == \'B\' || ResponseList[' + i + '].ResponseOptionType() == \'HB\') -->';
                    DynamicHTML += '<!--ko foreach: ' + ID + ' -->';
                    DynamicHTML += '<div>';
                    DynamicHTML += '<input type="radio" data-bind="checkedValue: SelectResponseId">';
                    DynamicHTML += '<span class="ml-1" data-bind="html: SelectResposneOption"></span>';
                    DynamicHTML += '</div>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // for both text input and rich text box
                    DynamicHTML += '<!-- ko if: (ResponseList[' + i + '].ResponseOptionType() == \'T\' || ResponseList[' + i + '].ResponseOptionType() == \'R\') -->';
                    DynamicHTML += '<input class="form-control" type="text" placeholder="Type Response"></input>';
                    DynamicHTML += '<!--/ko-->';

                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '</td>'
                }
                else {
                    var colIndex = i + 1;
                    DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()">'
                    DynamicHTML += '<!-- ko if: IsHeader() == 0 && ' + colIndex + ' <= ResponseList.length -->';
                    DynamicHTML += '<!-- ko if: ResponseList[' + i + '].ResponseId() == ' + SCViewModel.QualColumnDetails()[i].ColumnId() +' -->';
                    DynamicHTML += '<input type="checkbox" data-bind="checked: ResponseList[' + i + '].Is_ResponseMandatory_RT, click: $root.PreviewEdit">'
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '</td>'
                }
            }
            DynamicHTML += '<td class="site_name text-center" style="width:8% !important" data-bind="visible : !$root.PreviewView()" >'
            DynamicHTML += '<!-- ko if: IsHeader() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_CommentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'
            DynamicHTML += '<td class="site_name text-center" style="width:8% !important" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<!-- ko if: IsHeader() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_DocumentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'
            DynamicHTML += '</tr>';
            DynamicHTML += '</tbody>'
            DynamicHTML += '</table>'

            $('#QualControlsDiv').html(" ");
            $('#QualControlsDiv').html(DynamicHTML);
            var element = $('#QualControlsDiv')[0];
            ko.cleanNode(element);
            ko.applyBindings(SCViewModel, document.getElementById('QualControlsDiv'));
            $('#CADataDiv').show();
            $('#MainTabDivQ').show();
            $('#loadingImgMain').hide();
            $('#tblResponsequalitative').DataTable({
                stateSave: SCViewModel.tableStateSave(),
                rowReorder: true,
                columnDefs: [
                    { orderable: true, className: 'reorder', targets: 2 },
                    { orderable: false, targets: '_all' }
                ]
            });
            $('#loadingImgMain').hide();
            scrollableTabs();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }



    //sort feature qual
    function InputChangedAreaQual(data, event) {
        try {
            $('#valError').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= SCViewModel.QualResponseListData().length && data.SortOrder() > 0) {

                var riskareacount = SCViewModel.QualResponseListData().length - 1;
                SCViewModel.QualResponseListData.remove(function (item) { return item.QuestionId() == data.QuestionId() });
                var count = data.SortOrder() - 1;
                SCViewModel.QualQuesionSortOrder(count);
                var counter = 1;
                var MappedRiskAreaModel1 = $.map(SCViewModel.QualResponseListData(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return result;
                    }

                });

                var ChangedModel = new QualResponseModelSort1({
                    IsHeader: data.IsHeader(), selectedLevelId: data.selectedLevelId(), IsReadOnly: data.IsReadOnly(), IsConditional: data.IsConditional(),
                    ParentQuestionId: data.ParentQuestionId(), ParentResponseId: data.ParentResponseId(), ParentResponseType: data.ParentResponseType(),
                    SerialNo: data.SerialNo(), QuestionId: data.QuestionId(), QuestionText: data.QuestionText(), Is_CommentMandatory: data.Is_CommentMandatory(),
                    Is_ResponseMandatory: data.Is_ResponseMandatory(), Is_DocumentMandatory: data.Is_DocumentMandatory(),
                    ResponseList: $.map(data.ResponseList, function (result) {
                        return ResponseObject = new QualResponseObjectSort(result);
                    })
                })

                var Model = [];
                if (MappedRiskAreaModel1.length > 0) {
                    for (var i = 0; i < MappedRiskAreaModel1.length; i++) {
                        var NewModel = new QualResponseModelSort2({
                            IsHeader: MappedRiskAreaModel1[i].IsHeader(), selectedLevelId: MappedRiskAreaModel1[i].selectedLevelId(), IsReadOnly: MappedRiskAreaModel1[i].IsReadOnly(),
                            IsConditional: MappedRiskAreaModel1[i].IsConditional(), ParentQuestionId: MappedRiskAreaModel1[i].ParentQuestionId(), ParentResponseId: MappedRiskAreaModel1[i].ParentResponseId(),
                            ParentResponseType: MappedRiskAreaModel1[i].ParentResponseType(), SerialNo: MappedRiskAreaModel1[i].SerialNo(), QuestionId: MappedRiskAreaModel1[i].QuestionId(),
                            QuestionText: MappedRiskAreaModel1[i].QuestionText(), SortOrder: MappedRiskAreaModel1[i].SortOrder(), Is_CommentMandatory: MappedRiskAreaModel1[i].Is_CommentMandatory(),
                            Is_ResponseMandatory: MappedRiskAreaModel1[i].Is_ResponseMandatory(), Is_DocumentMandatory: MappedRiskAreaModel1[i].Is_DocumentMandatory(),
                            ResponseList: $.map(MappedRiskAreaModel1[i].ResponseList, function (result) {
                                return ResponseObject = new QualResponseObjectSort(result);
                            })
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskareacount + 1; k++) {

                    var ChangedModel = new QualResponseModelSort1({
                        IsHeader: SCViewModel.QualResponseListData()[k - 1].IsHeader(), selectedLevelId: SCViewModel.QualResponseListData()[k - 1].selectedLevelId(),
                        IsReadOnly: SCViewModel.QualResponseListData()[k - 1].IsReadOnly(), IsConditional: SCViewModel.QualResponseListData()[k - 1].IsConditional(),
                        ParentQuestionId: SCViewModel.QualResponseListData()[k - 1].ParentQuestionId(), ParentResponseId: SCViewModel.QualResponseListData()[k - 1].ParentResponseId(),
                        ParentResponseType: SCViewModel.QualResponseListData()[k - 1].ParentResponseType(), SerialNo: SCViewModel.QualResponseListData()[k - 1].SerialNo(),
                        QuestionId: SCViewModel.QualResponseListData()[k - 1].QuestionId(), QuestionText: SCViewModel.QualResponseListData()[k - 1].QuestionText(),
                        Is_CommentMandatory: SCViewModel.QualResponseListData()[k - 1].Is_CommentMandatory(), Is_ResponseMandatory: SCViewModel.QualResponseListData()[k - 1].Is_ResponseMandatory(),
                        Is_DocumentMandatory: SCViewModel.QualResponseListData()[k - 1].Is_DocumentMandatory(),
                        ResponseList: $.map(SCViewModel.QualResponseListData()[k - 1].ResponseList, function (result) {
                            return ResponseObject = new QualResponseObjectSort(result);
                        })
                    })

                    Model.push(ChangedModel);
                }
                SCViewModel.QualResponseListData([]);
                SCViewModel.QualResponseListData(Model);

                BindDynamicHtmlQualitative();
                SCViewModel.DisablePreviewSaveBtn(false);
            }
            else {
                $('#valError').show();
                $('#valError').html("Please enter a valid number")
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedAreaQual() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function UpFunctionalityQualSort(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < SCViewModel.QualResponseListData().length; i++) {

                if (data.QuestionId() == SCViewModel.QualResponseListData()[i].QuestionId()) {
                    if (i == 0) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = SCViewModel.QualResponseListData()[i].QuestionId();
                        var y = SCViewModel.QualResponseListData()[i].QuestionText();
                        var z = SCViewModel.QualResponseListData()[i].SerialNo();
                        var LId = SCViewModel.QualResponseListData()[i].selectedLevelId();

                        SCViewModel.QualResponseListData()[i].QuestionId(SCViewModel.QualResponseListData()[i - 1].QuestionId());
                        SCViewModel.QualResponseListData()[i].QuestionText(SCViewModel.QualResponseListData()[i - 1].QuestionText());
                        SCViewModel.QualResponseListData()[i].SerialNo(SCViewModel.QualResponseListData()[i - 1].SerialNo());
                        SCViewModel.QualResponseListData()[i].selectedLevelId(SCViewModel.QualResponseListData()[i - 1].selectedLevelId());

                        SCViewModel.QualResponseListData()[i - 1].QuestionId(x);
                        SCViewModel.QualResponseListData()[i - 1].QuestionText(y);
                        SCViewModel.QualResponseListData()[i - 1].SerialNo(z);
                        SCViewModel.QualResponseListData()[i - 1].selectedLevelId(LId);


                        for (var j = 0; j < SCViewModel.QualColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.QualResponseListData()[i].ResponseList.length; k++) {
                                if (SCViewModel.QualResponseListData()[i].ResponseList[k].ResponseId() == SCViewModel.QualColumnDetails()[j].ColumnId()) {
                                    var p = SCViewModel.QualResponseListData()[i].ResponseList[k].SelectedOptionsList();
                                    var selectedValueP = SCViewModel.QualResponseListData()[i].ResponseList[k].ResponseInputValue();
                                    var selectedValueLast = SCViewModel.QualResponseListData()[i - 1].ResponseList[k].ResponseInputValue();

                                    SCViewModel.QualResponseListData()[i].ResponseList[k].SelectedOptionsList(SCViewModel.QualResponseListData()[i - 1].ResponseList[k].SelectedOptionsList());
                                    //set selected dropdown value
                                    $("#ddq_" + SCViewModel.QualResponseListData()[i].ResponseList[k].ResponseInputValue() + "_" + SCViewModel.QualColumnDetails()[j].ColumnId()).val(selectedValueLast);

                                    SCViewModel.QualResponseListData()[i - 1].ResponseList[k].SelectedOptionsList(p);
                                    //set selected dropdown value
                                    $("#ddq_" + SCViewModel.QualResponseListData()[i - 1].ResponseList[k].ResponseInputValue() + "_" + SCViewModel.QualColumnDetails()[j].ColumnId()).val(selectedValueP);
                                }
                            }
                        }
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
            BindDynamicHtmlQualitative();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpFunctionalityQualSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function DownFunctionalityQualSort(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < SCViewModel.QualResponseListData().length; i++) {

                if (data.QuestionId() == SCViewModel.QualResponseListData()[i].QuestionId()) {
                    if (i == SCViewModel.QualResponseListData().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = SCViewModel.QualResponseListData()[i].QuestionId();
                        var y = SCViewModel.QualResponseListData()[i].QuestionText();
                        var z = SCViewModel.QualResponseListData()[i].SerialNo();
                        var LId = SCViewModel.QualResponseListData()[i].selectedLevelId();

                        SCViewModel.QualResponseListData()[i].QuestionId(SCViewModel.QualResponseListData()[i + 1].QuestionId());
                        SCViewModel.QualResponseListData()[i].QuestionText(SCViewModel.QualResponseListData()[i + 1].QuestionText());
                        SCViewModel.QualResponseListData()[i].SerialNo(SCViewModel.QualResponseListData()[i + 1].SerialNo());
                        SCViewModel.QualResponseListData()[i].selectedLevelId(SCViewModel.QualResponseListData()[i + 1].selectedLevelId());

                        SCViewModel.QualResponseListData()[i + 1].QuestionId(x);
                        SCViewModel.QualResponseListData()[i + 1].QuestionText(y);
                        SCViewModel.QualResponseListData()[i + 1].SerialNo(z);
                        SCViewModel.QualResponseListData()[i + 1].selectedLevelId(LId);

                        for (var j = 0; j < SCViewModel.QualColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.QualResponseListData()[i].ResponseList.length; k++) {
                                if (SCViewModel.QualResponseListData()[i].ResponseList[k].ResponseId() == SCViewModel.QualColumnDetails()[j].ColumnId()) {
                                    var p = SCViewModel.QualResponseListData()[i].ResponseList[k].SelectedOptionsList();
                                    SCViewModel.QualResponseListData()[i].ResponseList[k].SelectedOptionsList(SCViewModel.QualResponseListData()[i + 1].ResponseList[k].SelectedOptionsList());
                                    SCViewModel.QualResponseListData()[i + 1].ResponseList[k].SelectedOptionsList(p);
                                }
                            }
                        }
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownFunctionalityQualSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //Qual sort order save
    function SaveQualSortOrder(data) {
        try {
            $('#DynamicQuestionPreviewHTMLDiv').hide();
            var RegenrateFlag = 0;
            if (SCViewModel.RegenertePreviewQuestionFlag() === true) {
                RegenrateFlag = 1;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveQualResponseSortData",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(SCViewModel.QualResponseListData(), function (item) {
                    return {
                        QuestionId: item.QuestionId(), LevelId: item.selectedLevelId(), Is_CommentMandatory: item.Is_CommentMandatory(), Is_DocumentMandatory: item.Is_DocumentMandatory(),
                        SerialNo: item.SerialNo(), SortOrder: item.SortOrder(), SurveyId: SCViewModel.ClickedSurveyProfileId(), RiskAreaId: SCViewModel.ClickedRiskAreaId(),
                        BusinessUnitId: SCViewModel.SelectedBuIdList()[0], RegenerateFlag: RegenrateFlag,
                        QualResponseObject: $.map(item.ResponseList, function (row) {
                            return {
                                ResponseId: row.ResponseId(), Is_ResponseMandatory_RT: row.Is_ResponseMandatory_RT()
                            }
                        })
                    };
                }))
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (jsonResult != null) {

                        if (parseInt(jsonResult) != 1 && !jsonResult.startsWith("INC")) {
                            logger.logSuccess('Changes have been saved successfully.', 'Success', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in SaveQualSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQualSortOrder() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in SaveQualSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveQualSortOrder() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    ///// Preview quesiont Control section

    function GetControlColumnDetails() {
        try {
            return $.ajax({
                url: "/api/Survey/GetControlsColumnDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AreaId: SCViewModel.ClickedRiskAreaId(), SurveyId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()) }
            })
                .success(function (jsonResult, Success) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else
                    {
                        SCViewModel.ControlColumnDetails([]);
                        var mappedcolumndetails = $.map(jsonResult, function (result) {
                            return new ControlsColumnDetailsModel(result);
                        })
                        SCViewModel.ControlColumnDetails(mappedcolumndetails);
                    }
                })
                .fail(function (fail, error) { });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetControlColumnDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetControlResponseData() {
        try {
            return $.ajax({
                url: "/api/Survey/GetControlResponseConfigData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AreaId: SCViewModel.ClickedRiskAreaId(), SurveyId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), BusinessUnitId: SCViewModel.SelectedBuIdList() }
            })
                .success(function (JsonResult, success) {
                    if (JsonResult != null)
                    {
                        if (JsonResult.Incident_Description != null) {
                            logger.logError(JsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            SCViewModel.ContQuesionSortOrder(0);
                            var mappeedControlData = $.map(JsonResult.ControlSurveyResponseList, function (result) {
                                return new ControlResponseModel(result);
                            })
                            SCViewModel.ControlsResponseData(mappeedControlData);

                            for (var i = 0; i < JsonResult.RTApplicabilityList.length; i++) {
                                for (var j = 0; j < SCViewModel.ControlColumnDetails().length; j++) {
                                    if (JsonResult.RTApplicabilityList[i].ResponseTypeId == SCViewModel.ControlColumnDetails()[j].ColumnId())
                                        SCViewModel.ControlColumnDetails()[j].RTApplicability(JsonResult.RTApplicabilityList[i].ResponseTypeApplicability);
                                }
                            }
                            BindDynamicHtmlForControls();
                        }
                    }
                })
                .fail(function (fail, error) {

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetControlResponseData() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function ControlsColumnDetailsModel(item) {
        try {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.Columntext = ko.observable($('<div/>').html(item.Columntext).text());
            self.ColumnSelectFlag = ko.observable(false);
            self.RTApplicability = ko.observable(0);
            var mappedSelectlist = $.map(item.OptionsListObject, function (result) {
                return ResponseObject = new ControlSelectlistModel(result);
            });
            self.ResponseOptions = ko.observableArray(mappedSelectlist);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlsColumnDetailsModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function ControlSelectlistModel(item) {
        try {
            var self = this;
            self.OptionId = ko.observable(item.OptionId);
            self.OptionsText = ko.observable($('<div/>').html(item.OptionsText).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlSelectlistModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ControlResponseModel(item) {
        try {
            var self = this;
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.QuestionId = ko.observable(item.QuestionId);
            self.LevelId = ko.observable(item.LevelId);
            self.selectedLevelId = ko.observable(item.LevelId);
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsConditional = ko.observable(item.IsConditional);
            self.IsHeader = ko.observable(item.IsHeader);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            var mappedSelectlist = $.map(item.ResposneObejct, function (result) {
                return ResponseObject = new ControlSelectResponseModel(result);
            });
            self.QuesitonOptionValue = ko.observableArray(mappedSelectlist);
            self.SortOrder = ko.observable(SCViewModel.ContQuesionSortOrder() + 1);
            SCViewModel.ContQuesionSortOrder(SCViewModel.ContQuesionSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function ControlResponseModelSort(item) {
        try {
            var self = this;
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.QuestionId = ko.observable(item.QuestionId);
            self.selectedLevelId = ko.observable(item.selectedLevelId);
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsConditional = ko.observable(item.IsConditional);
            self.IsHeader = ko.observable(item.IsHeader);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            var mappedSelectlist = $.map(item.QuesitonOptionValue, function (result) {
                return ResponseObject = new ControlSelectResponseModelSort(result);
            });
            self.QuesitonOptionValue = ko.observableArray(mappedSelectlist);
            self.SortOrder = ko.observable(SCViewModel.ContQuesionSortOrder() + 1);
            SCViewModel.ContQuesionSortOrder(SCViewModel.ContQuesionSortOrder() + 1);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function ControlResponseModelSort2(item) {
        try {
            var self = this;
            self.QuestionText = ko.observable($('<div/>').html(item.QuestionText).text());
            self.QuestionId = ko.observable(item.QuestionId);
            self.selectedLevelId = ko.observable(item.selectedLevelId);
            self.SerialNo = ko.observable(item.SerialNo);
            self.IsConditional = ko.observable(item.IsConditional);
            self.IsHeader = ko.observable(item.IsHeader);
            self.IsReadOnly = ko.observable(item.IsReadOnly);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.ParentResponseType = ko.observable(item.ParentResponseType);
            var mappedSelectlist = $.map(item.QuesitonOptionValue, function (result) {
                return ResponseObject = new ControlSelectResponseModelSort(result);
            });
            self.QuesitonOptionValue = ko.observableArray(mappedSelectlist);
            self.SortOrder = ko.observable(item.SortOrder);
            self.Is_CommentMandatory = ko.observable(item.Is_CommentMandatory);
            self.Is_DocumentMandatory = ko.observable(item.Is_DocumentMandatory);
            self.Is_ResponseMandatory = ko.observable(item.Is_ResponseMandatory);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }


    function ControlSelectResponseModel(item) {
        try {
            var self = this;
            self.Response = ko.observable(item.Response);
            self.ResponseId = ko.observable(item.ResponseId);
            self.ResponseApplicability = ko.observable(item.ResponseApplicability);
            self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT);
            self.ResponseOptionType = ko.observable(item.ResponseOptionType);
            var mappedOptions = $.map(item.ResponseOptions, function (result) {
                return ResponseObject = new ControlResponsOptionsModel(result);
            });
            self.ResponseOptions = ko.observable(mappedOptions);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlSelectResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function ControlResponsOptionsModel(item) {
        try {
            var self = this;
            self.optionId = ko.observable(item.optionId);
            self.OptionName = ko.observable(item.OptionName);


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlResponsOptionsModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function ControlSelectResponseModelSort(item) {
        try {
            var self = this;
            self.Response = ko.observable(item.Response());
            self.ResponseId = ko.observable(item.ResponseId());
            self.ResponseApplicability = ko.observable(item.ResponseApplicability());
            self.Is_ResponseMandatory_RT = ko.observable(item.Is_ResponseMandatory_RT());
            self.ResponseOptionType = ko.observable(item.ResponseOptionType());
            var mappedOptions = $.map(item.ResponseOptions, function (result) {
                return ResponseObject = new ControlResponsOptionsModel(result);
            });
            self.ResponseOptions = ko.observable(mappedOptions);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlSelectResponseModel() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForControls() {
        try {
            SCViewModel.selectedLevelId(null);
            SCViewModel.PreviewEditUpdated(false);

            var DynamicHTML = "";
            //ResponseList use this in the method that gets the quan resposne details
            //create a sublist in the response list ResponseList (ResponseColumnList)

            //DynamicHTML = '<table id="tblResponse" class="table table-bordered table-condensed border-0 dataTable" style="table-layout: fixed; role="grid" aria-describedby="tblResponse_info">';
            DynamicHTML = '<table id="tblResponse" class="table table-bordered table-condensed border-0 dataTable" role="grid" aria-describedby="tblResponse_info">';
            DynamicHTML += '<thead>'
            DynamicHTML += '<th class="site_name" aria-label="No." style="width:15% !important;">No.</th>'
            DynamicHTML += '<th class="site_name" aria-label="Levels" style="text-align:center; width:7% !important" >Levels</th>'
            DynamicHTML += '<th class="site_name w-25" aria-label="Question">Question</th>'
            DynamicHTML += '<th style="display:none" class="site_name" aria-label="QuestionId">QuestionId</th>'
            DynamicHTML += '<th style="width:15% !important"  class="site_name" aria-label="Sort" data-bind="visible : !$root.PreviewView()">Sort</th>'
            for (var i = 0; i < SCViewModel.ControlColumnDetails().length; i++) {
                if (SCViewModel.PreviewView())
                    DynamicHTML += '<th class="site_name" style="width:10% !important;" data-bind="visible : $root.PreviewView()">' + SCViewModel.ControlColumnDetails()[i].Columntext() + '</th>'
                else {
                    if (SCViewModel.ControlColumnDetails()[i].RTApplicability() == 1)
                        DynamicHTML += '<th class="site_name" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Response Mandatory" data-bind="checked: ' + SCViewModel.ControlColumnDetails()[i].ColumnSelectFlag() + ', event: {change :  function (data, event) {$root.CheckAllMandatory(' + SCViewModel.ControlColumnDetails()[i].ColumnId() + ', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>' + SCViewModel.ControlColumnDetails()[i].Columntext() + '</th>'
                }
            }
            DynamicHTML += '<th class="site_name"  aria-label="Sort" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Comment Mandatory"  data-bind="checked: $root.SelectAllCommentsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'cmt\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Comments</th>'
            DynamicHTML += '<th class="site_name"  aria-label="Sort" style="width:15% !important" data-bind="visible : !$root.PreviewView()"><label class="cc-checkbox"><input type="checkbox" name="Document Mandatory" data-bind="checked: $root.SelectAllDocsFlag, event: {change :function (data, event) { $root.CheckAllMandatory(\'doc\', event) }}" /><span class="cc-facet-result-text tag-text"></span></label>Documents</th>'
            DynamicHTML += '</thead>';
            DynamicHTML += '<tbody data-bind="foreach: $root.ControlsResponseData">';
            DynamicHTML += '<tr data-bind="css: { GreyBackground : IsHeader() == 1}">';
            DynamicHTML += '<td><input type="text" class="text-center" data-bind="value:SerialNo, event: { change: $root.InputChangedRankCont }" style="width: 100%;" /></td>';
            if (SCViewModel.PreviewView() == true) {
                DynamicHTML += '<td class="site_name"><select data-bind ="options:$root.availableLevelId,optionsText:\'LevelName\',optionsValue:\'LevelUId\',value:selectedLevelId, click: $root.PreviewEdit" disabled></select></td>';
            }
            else {
                DynamicHTML += '<td class="site_name"><select data-bind ="options:$root.availableLevelId,optionsText:\'LevelName\',optionsValue:\'LevelUId\',value:selectedLevelId, click: $root.PreviewEdit"></select></td>';
            }
            DynamicHTML += '<td class="site_name headcol-SurResponse DataRequest-ellipsis Custom-word-wrap-QTDR" data-bind="text:QuestionText">';
            DynamicHTML += '<td style="display:none" data-bind="text:QuestionId">';
            DynamicHTML += '<td class="text-center" style="display: flex;" data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<input class="form-control" data-bind="value:SortOrder, event: { change: $root.InputChangedAreaCont }" type="text" style="margin-right: 1rem;" />';
            DynamicHTML += '<a href="javascript:void(0)" title="Move above" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.UpFunctionalityContSort">';
            DynamicHTML += '<i class="fa fa-arrow-up text-success icon-bar" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '<a href="javascript:void(0)" title="Move Down" style="margin-right: 1rem;" class="btn-borderless widget-button" data-bind="click: $root.DownFunctionalityContSort">';
            DynamicHTML += '<i class="fa fa-arrow-down text-danger" style="margin-top: 7px;font-size: small;"></i></a>';
            DynamicHTML += '</td>';
            for (var i = 0; i < SCViewModel.ControlColumnDetails().length; i++) {
                var ID = 'QuesitonOptionValue()[' + i + '].ResponseOptions()';
                if (SCViewModel.PreviewView()) {
                    DynamicHTML += '<td class="site_name" data-bind="visible : $root.PreviewView()">';
                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '] != undefined && IsHeader() == 0 && QuesitonOptionValue()[' + i + '].ResponseApplicability() == 1-->';

                    // for question where response-option types is not configured
                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'-\' -->';
                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseOptions().length > 0 -->';
                    DynamicHTML += '<select class="form-control" data-bind="options:' + ID + ',optionsCaption:\'Select\',optionsText :\'OptionName\',optionsValue:\'optionId\'"></select>';
                    DynamicHTML += '<!--/ko-->';

                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseOptions().length == 0 -->';
                    DynamicHTML += '<input class="form-control" type="text" placeholder="Type Response"></input>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // single dropdown
                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'D\' -->';
                    DynamicHTML += '<select class="form-control" data-bind="options:' + ID + ',optionsCaption:\'Select\',optionsText :\'OptionName\',optionsValue:\'optionId\'"></select>';
                    DynamicHTML += '<!--/ko-->';

                    // multi select
                    DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'C\' -->';
                    DynamicHTML += '<!--ko foreach: ' + ID + ' -->';
                    DynamicHTML += '<div>';
                    DynamicHTML += '<input type="checkbox" data-bind="checkedValue: optionId">';
                    DynamicHTML += '<span class="ml-1" data-bind="html: OptionName"></span>';
                    DynamicHTML += '</div>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // for both radio-buttons and Horizontal radio-buttons
                    DynamicHTML += '<!-- ko if: (QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'B\' || QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'HB\') -->';
                    DynamicHTML += '<!--ko foreach: ' + ID + ' -->';
                    DynamicHTML += '<div>';
                    DynamicHTML += '<input type="radio" data-bind="checkedValue: optionId">';
                    DynamicHTML += '<span class="ml-1" data-bind="html: OptionName"></span>';
                    DynamicHTML += '</div>';
                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '<!--/ko-->';

                    // for both text input and rich text box
                    DynamicHTML += '<!-- ko if: (QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'T\' || QuesitonOptionValue()[' + i + '].ResponseOptionType() == \'R\') -->';
                    DynamicHTML += '<input class="form-control" type="text" placeholder="Type Response"></input>';
                    DynamicHTML += '<!--/ko-->';

                    DynamicHTML += '<!--/ko-->';
                    DynamicHTML += '</td>';
                }
                else {
                    var colIndex = i + 1;
                    if (SCViewModel.ControlColumnDetails()[i].RTApplicability() == 1) {
                        DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()">'
                        DynamicHTML += '<!-- ko if: IsHeader() == 0 && QuesitonOptionValue()[' + i + '].ResponseApplicability() == 1  && ' + colIndex + ' <= QuesitonOptionValue().length -->';
                        DynamicHTML += '<!-- ko if: QuesitonOptionValue()[' + i + '].ResponseId() == ' + SCViewModel.ControlColumnDetails()[i].ColumnId() +' -->';
                        DynamicHTML += '<input type="checkbox" data-bind="checked: QuesitonOptionValue()[' + i + '].Is_ResponseMandatory_RT, click: $root.PreviewEdit">'
                        DynamicHTML += '<!--/ko-->';
                        DynamicHTML += '<!--/ko-->';
                        DynamicHTML += '</td>'
                    }
                }
            }
            DynamicHTML += '<td class="site_name text-center" data-bind="visible : !$root.PreviewView()" >'
            DynamicHTML += '<!-- ko if: IsHeader() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_CommentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'
            DynamicHTML += '<td class="site_name text-center"  data-bind="visible : !$root.PreviewView()">'
            DynamicHTML += '<!-- ko if: IsHeader() != 1 -->';
            DynamicHTML += '<input  type="checkbox" data-bind="checked: Is_DocumentMandatory, click: $root.PreviewEdit">'
            DynamicHTML += '<!--/ko-->';
            DynamicHTML += '</td>'

            DynamicHTML += '</tr>';
            DynamicHTML += '</tbody>'
            DynamicHTML += '</table>'


            $('#QualControlsDiv').html(" ");
            $('#QualControlsDiv').html(DynamicHTML);
            var element = $('#QualControlsDiv')[0];
            ko.cleanNode(element);
            ko.applyBindings(SCViewModel, document.getElementById('QualControlsDiv'));
            $('#DynamicQuestionPreviewHTMLDiv').show();
            $('#MainTabDivQ').show();
            $('#loadingImgMain').hide();
            $('#tblResponse').DataTable({
                stateSave: SCViewModel.tableStateSave(),
                rowReorder: true,
                columnDefs: [
                    { orderable: true, className: 'reorder', targets: 2 },
                    { orderable: false, targets: '_all' }
                ]
            });
            scrollableTabs();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForControls() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //sort feature quant
    function InputChangedAreaCont(data, event) {
        try {
            $('#valError').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= SCViewModel.ControlsResponseData().length && data.SortOrder() > 0) {

                var riskareacount = SCViewModel.ControlsResponseData().length - 1;
                SCViewModel.ControlsResponseData.remove(function (item) { return item.QuestionId() == data.QuestionId() });
                var count = data.SortOrder() - 1;
                SCViewModel.ContQuesionSortOrder(count);
                var counter = 1;
                var MappedRiskAreaModel1 = $.map(SCViewModel.ControlsResponseData(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return result;
                    }

                });

                var ChangedModel = new ControlResponseModelSort({
                    QuesitonOptionValue: $.map(data.QuesitonOptionValue(), function (result) {
                        return ResponseObject = new ControlSelectResponseModelSort(result);
                    }), IsConditional: data.IsConditional(), selectedLevelId: data.selectedLevelId(), IsHeader: data.IsHeader(), IsReadOnly: data.IsReadOnly(), ParentQuestionId: data.ParentQuestionId(),
                    ParentResponseType: data.ParentResponseType(), SerialNo: data.SerialNo(), QuestionId: data.QuestionId(), QuestionText: data.QuestionText(), SortOrder: data.SortOrder(),
                    Is_CommentMandatory: data.Is_CommentMandatory(), Is_ResponseMandatory: data.Is_ResponseMandatory(), Is_DocumentMandatory: data.Is_DocumentMandatory(),
                })

                var Model = [];
                if (MappedRiskAreaModel1.length > 0) {
                    for (var i = 0; i < MappedRiskAreaModel1.length; i++) {
                        var NewModel = new ControlResponseModelSort2({
                            QuesitonOptionValue: $.map(MappedRiskAreaModel1[i].QuesitonOptionValue(), function (result) {
                                return ResponseObject = new ControlSelectResponseModelSort(result);
                            }), IsConditional: MappedRiskAreaModel1[i].IsConditional(), selectedLevelId: MappedRiskAreaModel1[i].selectedLevelId(), IsHeader: MappedRiskAreaModel1[i].IsHeader(), IsReadOnly: MappedRiskAreaModel1[i].IsReadOnly(),
                            ParentQuestionId: MappedRiskAreaModel1[i].ParentQuestionId(), ParentResponseType: MappedRiskAreaModel1[i].ParentResponseType(), SerialNo: MappedRiskAreaModel1[i].SerialNo(),
                            QuestionId: MappedRiskAreaModel1[i].QuestionId(), QuestionText: MappedRiskAreaModel1[i].QuestionText(), SortOrder: MappedRiskAreaModel1[i].SortOrder(),
                            Is_CommentMandatory: MappedRiskAreaModel1[i].Is_CommentMandatory(), Is_ResponseMandatory: MappedRiskAreaModel1[i].Is_ResponseMandatory(), Is_DocumentMandatory: MappedRiskAreaModel1[i].Is_DocumentMandatory(),
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskareacount + 1; k++) {
                    var ChangedModel = new ControlResponseModelSort({
                        QuesitonOptionValue: $.map(SCViewModel.ControlsResponseData()[k - 1].QuesitonOptionValue(), function (result) {
                            return ResponseObject = new ControlSelectResponseModelSort(result);
                        }), IsConditional: SCViewModel.ControlsResponseData()[k - 1].IsConditional(), selectedLevelId: SCViewModel.ControlsResponseData()[k - 1].selectedLevelId(), IsHeader: SCViewModel.ControlsResponseData()[k - 1].IsHeader(),
                        IsReadOnly: SCViewModel.ControlsResponseData()[k - 1].IsReadOnly(), ParentQuestionId: SCViewModel.ControlsResponseData()[k - 1].ParentQuestionId(),
                        ParentResponseType: SCViewModel.ControlsResponseData()[k - 1].ParentResponseType(), SerialNo: SCViewModel.ControlsResponseData()[k - 1].SerialNo(),
                        QuestionId: SCViewModel.ControlsResponseData()[k - 1].QuestionId(), QuestionText: SCViewModel.ControlsResponseData()[k - 1].QuestionText(),
                        SortOrder: SCViewModel.ControlsResponseData()[k - 1].SortOrder(), Is_CommentMandatory: SCViewModel.ControlsResponseData()[k - 1].Is_CommentMandatory(),
                        Is_ResponseMandatory: SCViewModel.ControlsResponseData()[k - 1].Is_ResponseMandatory(), Is_DocumentMandatory: SCViewModel.ControlsResponseData()[k - 1].Is_DocumentMandatory()
                    })
                    Model.push(ChangedModel);
                }
                SCViewModel.ControlsResponseData([]);
                SCViewModel.ControlsResponseData(Model);

                BindDynamicHtmlForControls();
                SCViewModel.DisablePreviewSaveBtn(false);
            }
            else {
                $('#valError').show();
                $('#valError').html("Please enter a valid number")
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedAreaCont() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function UpFunctionalityContSort(data, event) {
        try {
            $('#valError').hide();
            SCViewModel.PreviewEditUpdated(true);
            for (var i = 0; i < SCViewModel.ControlsResponseData().length; i++) {

                if (data.QuestionId() == SCViewModel.ControlsResponseData()[i].QuestionId()) {
                    if (i == 0) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = SCViewModel.ControlsResponseData()[i].QuestionId();
                        var y = SCViewModel.ControlsResponseData()[i].QuestionText();
                        var z = SCViewModel.ControlsResponseData()[i].SerialNo();
                        var LId = SCViewModel.ControlsResponseData()[i].selectedLevelId();

                        SCViewModel.ControlsResponseData()[i].QuestionId(SCViewModel.ControlsResponseData()[i - 1].QuestionId());
                        SCViewModel.ControlsResponseData()[i].QuestionText(SCViewModel.ControlsResponseData()[i - 1].QuestionText());
                        SCViewModel.ControlsResponseData()[i].SerialNo(SCViewModel.ControlsResponseData()[i - 1].SerialNo());
                        SCViewModel.ControlsResponseData()[i].selectedLevelId(SCViewModel.ControlsResponseData()[i - 1].selectedLevelId());

                        SCViewModel.ControlsResponseData()[i - 1].QuestionId(x);
                        SCViewModel.ControlsResponseData()[i - 1].QuestionText(y);
                        SCViewModel.ControlsResponseData()[i - 1].SerialNo(z);
                        SCViewModel.ControlsResponseData()[i - 1].selectedLevelId(LId);


                        for (var j = 0; j < SCViewModel.ControlColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.ControlsResponseData()[i].QuesitonOptionValue().length; k++) {
                                if (SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseId() == SCViewModel.ControlColumnDetails()[j].ColumnId()) {
                                    if (SCViewModel.ControlsResponseData()[i - 1].QuesitonOptionValue()[k].ResponseApplicability() == 0 && SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability() == 1) {
                                        SCViewModel.ControlsResponseData()[i - 1].QuesitonOptionValue()[k].ResponseApplicability(1);
                                        SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability(0);
                                    }
                                    else if (SCViewModel.ControlsResponseData()[i - 1].QuesitonOptionValue()[k].ResponseApplicability() == 1 && SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability() == 0) {
                                        SCViewModel.ControlsResponseData()[i - 1].QuesitonOptionValue()[k].ResponseApplicability(0);
                                        SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability(1);
                                    }
                                }
                            }
                        }
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpFunctionalityContSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function DownFunctionalityContSort(data, event) {
        try {
            $('#valError').hide();
            SCViewModel.PreviewEditUpdated(true);
            for (var i = 0; i < SCViewModel.ControlsResponseData().length; i++) {

                if (data.QuestionId() == SCViewModel.ControlsResponseData()[i].QuestionId()) {
                    if (i == SCViewModel.ControlsResponseData().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = SCViewModel.ControlsResponseData()[i].QuestionId();
                        var y = SCViewModel.ControlsResponseData()[i].QuestionText();
                        var z = SCViewModel.ControlsResponseData()[i].SerialNo();
                        var LId = SCViewModel.ControlsResponseData()[i].selectedLevelId();

                        SCViewModel.ControlsResponseData()[i].QuestionId(SCViewModel.ControlsResponseData()[i + 1].QuestionId());
                        SCViewModel.ControlsResponseData()[i].QuestionText(SCViewModel.ControlsResponseData()[i + 1].QuestionText());
                        SCViewModel.ControlsResponseData()[i].SerialNo(SCViewModel.ControlsResponseData()[i + 1].SerialNo());
                        SCViewModel.ControlsResponseData()[i].selectedLevelId(SCViewModel.ControlsResponseData()[i + 1].selectedLevelId());

                        SCViewModel.ControlsResponseData()[i + 1].QuestionId(x);
                        SCViewModel.ControlsResponseData()[i + 1].QuestionText(y);
                        SCViewModel.ControlsResponseData()[i + 1].SerialNo(z);
                        SCViewModel.ControlsResponseData()[i + 1].selectedLevelId(LId);

                        for (var j = 0; j < SCViewModel.ControlColumnDetails().length; j++) {
                            for (var k = 0; k < SCViewModel.ControlsResponseData()[i].QuesitonOptionValue().length; k++) {
                                if (SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseId() == SCViewModel.ControlColumnDetails()[j].ColumnId()) {
                                    if (SCViewModel.ControlsResponseData()[i + 1].QuesitonOptionValue()[k].ResponseApplicability() == 0 && SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability() == 1) {
                                        SCViewModel.ControlsResponseData()[i + 1].QuesitonOptionValue()[k].ResponseApplicability(1);
                                        SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability(0);
                                    }
                                    else if (SCViewModel.ControlsResponseData()[i + 1].QuesitonOptionValue()[k].ResponseApplicability() == 1 && SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability() == 0) {
                                        SCViewModel.ControlsResponseData()[i + 1].QuesitonOptionValue()[k].ResponseApplicability(0);
                                        SCViewModel.ControlsResponseData()[i].QuesitonOptionValue()[k].ResponseApplicability(1);
                                    }
                                }
                            }
                        }
                        SCViewModel.DisablePreviewSaveBtn(false);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownFunctionalityContSort() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //Cont sort order save
    function SaveContSortOrder(data) {
        try {
            $('#DynamicQuestionPreviewHTMLDiv').hide();
            var RegenrateFlag = 0;
            if (SCViewModel.RegenertePreviewQuestionFlag() === true) {
                RegenrateFlag = 1;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/SaveContResponseSortData",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(SCViewModel.ControlsResponseData(), function (item) {
                    return {
                        QuestionId: item.QuestionId(), LevelId: item.selectedLevelId(), Is_CommentMandatory: item.Is_CommentMandatory(), Is_DocumentMandatory: item.Is_DocumentMandatory(),
                        SerialNo: item.SerialNo(), SortOrder: item.SortOrder(), SurveyId: SCViewModel.ClickedSurveyProfileId(), RiskAreaId: SCViewModel.ClickedRiskAreaId(),
                        BusinessUnitId: SCViewModel.SelectedBuIdList()[0], RegenerateFlag: RegenrateFlag,
                        ResposneObejct: $.map(item.QuesitonOptionValue(), function (row) {
                            return {
                                ResponseId: row.ResponseId(), Is_ResponseMandatory_RT: row.Is_ResponseMandatory_RT()
                            }
                        })
                    };
                }))
            }).success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try
                {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (jsonResult != null) {

                        if (parseInt(jsonResult) != 1 && !jsonResult.startsWith("INC")) {
                            logger.logSuccess('Changes have been saved successfully.', 'Success', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in SaveContSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    $('#DynamicQuestionPreviewHTMLDiv').show();
                    if (error.status == 401) {
                        app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveContSortOrder() method in ConfigureSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in SaveContSortOrder() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveContSortOrder() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    /// till here Preview question all
    function ClosePreviewQuestionPopUp() {
        try {
            $("#PreviewNewQuestion").modal('hide');
            SCViewModel.QuestionsForCheckedAreasList([]);
            SCViewModel.DisablePreviewSaveBtn(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in ClosePreviewQuestionPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetallSurveys() {
        try {
            var headers = appsecurity.getSecurityHeaders();
            return $.ajax({
                url: "/api/Configuration/GetAllSurveys",
                type: "GET",
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.length > 0) {

                        if (jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            var MappedSurveyList = $.map(jsonResult, function (result) {
                                return new SurveyListModel(result);
                            });

                            var Surveytableobject = $('#SurveyTypeTable').DataTable();
                            Surveytableobject.destroy();
                            $('#SurveyTypeTable tbody tr').remove();
                            SCViewModel.SurveyCreateModel(MappedSurveyList);
                            $('#SurveyTypeTable').DataTable({
                                "bResponsive": true,
                                "stateSave": true,
                                "paging": true,
                                "order": [],
                                "orderable": false
                            })
                        }

                    }
                    else if (jsonResult != null && jsonResult.length == 0) {
                        var Surveytableobject = $('#SurveyTypeTable').DataTable();
                        Surveytableobject.destroy();
                        $('#SurveyTypeTable tbody tr').remove();
                        $('#SurveyTypeTable').DataTable({
                            "stateSave": true,
                            "targets": 'no-sort',
                            "bResponsive": true,
                            "paging": true,
                            "order": [],
                            "orderable": false
                        })
                    }
                    else if (jsonResult == null) {
                        logger.logError('Some error occured. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }


                    else
                        logger.logError('Some error occured while fetching Surveys. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

    }

    function OpenlaunchSurveyPopup() {
        try {

            $("#frmlaunchPopup").modal('show');
            SCViewModel.SelectedBuIdList([]);
            SCViewModel.SelectedSpIdList([]);
            SCViewModel.DisableActionButtons(false);
            SCViewModel.popUpTitle((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyLaunch') == -1) ? 'Launch Survey' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyLaunch')].Name().toString())
            var arr = [];

            for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                if (SCViewModel.BuModelList()[i].isChecked()) {
                    SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
                    SCViewModel.SelectedSpIdList().push(SCViewModel.BuModelList()[i].SpId());

                }
                else {
                    arr.push(SCViewModel.BuModelList()[i].BuId())
                }
            }


            if (SCViewModel.SelectedBuIdList().length == 0) {
                $('#ValErrorLaunch').show();
                $("#LaunchPopupBody").hide();
                $('#ValErrorLaunch').html('No ' + SCViewModel.BUTitle() + ' is selected to perform the group actions');
                SCViewModel.DisableActionButtons(true);
            }
            else {
                $('#ValErrorLaunch').hide();
                $("#LaunchPopupBody").show();
                SCViewModel.LaunchBusinessunitList([])
                if (TableObject != undefined) {

                    TableObject.destroy();
                    $("#SurveyLaunchTable tbody tr").remove();
                }
                else {
                    TableObject = $("#SurveyLaunchTable").DataTable();
                    $("#SurveyLaunchTable").removeClass("border-collpase")
                    $("#SurveyLaunchTable tbody tr").remove();
                    TableObject.destroy();
                }
                var mappedLaunchBuListgroup = $.map(SCViewModel.BuModelList(), function (result) {
                    var BuModelObj = new LaunchBusinessUnitModel(result);
                    return BuModelObj;
                });

                SCViewModel.LaunchBusinessunitList(mappedLaunchBuListgroup);
                for (var i = 0; i < arr.length; i++) {
                    SCViewModel.LaunchBusinessunitList.remove(function (item)
                    //{ return item.BuId == arr[i] })
                    { return item.BuId == arr[i] && item.SpId == arr[i] })
                }
                TableObject = $("#SurveyLaunchTable").DataTable();
                $("#SurveyLaunchTable").removeClass("border-collpase")

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in OpenlaunchSurveyPopup() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function CloseLaunchSurveyPopup() {
        try {
            $("#frmlaunchPopup").modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CloseLaunchSurveyPopup() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function closeQuestionnaire() {
        try {
            SCViewModel.QuantitativeSurveySetup.RiskAreaDetailsList([]);
            SCViewModel.QuantitativeSurveySetup.RiskSubFactorsList([]);
            SCViewModel.SelectedAreas([]);
            SCViewModel.QuantitativeSurveySetup.closeQuestionnaireSCViewModel();
            $("#PreviewQuestionnaire").modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in closeQuestionnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RemoveUserMapping(data, event) {
        try {
            var MappedUserList = generateJsonUsers()
            if (generateJsonUsers().length == 0) {
                var Object = { BusinessUnitID: SCViewModel.SelectedBuIdList()[0], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.BuModelList()[0].SpId() : SCViewModel.ClickedSurveyProfileId()), RoleType: SCViewModel.SurveyUsersList()[0].RoleType(), RoleId: SCViewModel.SurveyUsersList()[0].RoleId() };
                var MappedUserList = [];
                MappedUserList.push(Object)
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Survey/RemoveUsersSurveyAssignment",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) == 1) {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg') == -1) ? 'Survey User Mapping has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            //$('#MapUsersPopUp').modal('hide');
                            GetallProfileSurveys();
                            GetRespondents(SCViewModel.SelectedBuIdList());
                        }
                        else if (parseInt(jsonResult) == 200) {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? 'Survey User assignment failed as the user is working on the survey. Please move the survey to open queue and then reassign the survey.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else if (jsonResult.startsWith("INC"))
                        {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? jsonResult + " - " + 'An error has occurred while saving User Mapping. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                })
                .fail(function (jsonResult, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:RemoveUserMapping() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

    }

    function SaveUserMapping(data, event) {
        try {
            SaveMappingPopUp();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveUserMapping() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function AddUserMapping(data, event) {
        try {
            var MappedUserList = generateJsonUsers()
            if (generateJsonUsers().length == 0) {
                var Object = { BusinessUnitID: SCViewModel.SelectedBuIdList()[0], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.BuModelList()[0].SpId() : SCViewModel.ClickedSurveyProfileId()) , RoleType: SCViewModel.SurveyUsersList()[0].RoleType(), RoleId: SCViewModel.SurveyUsersList()[0].RoleId() };
                var MappedUserList = [];
                MappedUserList.push(Object)
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Survey/AddUsersSurveyAssignment",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) > 0) {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg') == -1) ? 'Survey User Mapping has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            //$('#MapUsersPopUp').modal('hide');
                            GetallProfileSurveys();
                            GetRespondents(SCViewModel.SelectedBuIdList());
                        }
                        else if (jsonResult.startsWith("INC"))
                        {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? jsonResult + " - " + 'An error has occurred while saving User Mapping. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                })
                .fail(function (jsonResult, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:AddUserMapping() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

    }

    function ReplaceUserMapping(data, event) {
        try {
            SaveMappingPopUpReplace();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ReplaceUserMapping() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#region CopyOverUserMapping
    function CopyOverUsers() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/GetCopyOverUserAssignmentFilter",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    if (jsonResult !== null) {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else if (jsonResult.Options.length > 0) {
                            PopUpData = new CopyOverUsersPopUp(jsonResult)
                            $('#CopyOverUsersPopup').modal('show');
                            SCViewModel.CopyOverUsersPopUpData(PopUpData);
                            $('#DestOptDropDown').multiselect('refresh');
                        }
                        else {
                            logger.logError('An error occurred. Please contact the Application Administrator for support.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                })
                .fail(function (error, status) {
                    logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | CopyOverUsers() in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function CopyOverUsersPopUp(item) {
        try {
            var self = this;
            let Option = function (Key, Value, Filter) {
                this.Id = Key;
                this.Text = Value;
                this.Filter = Filter
            };
            let CopyOverRecord = function (SrcOption, DestOption, Message) {
                this.Src = SrcOption;
                this.Dest = DestOption;
                this.Msg = Message;
            }

            self.SrcOptions = ko.observableArray($.map(item.Options, function (result) {
                return new Option(result.Key, result.Value, result.Filter);
            }))
            self.SelectedSrcOption = ko.observable();

            self.DestOptions = ko.observableArray($.map(item.Options, function (result) {
                return new Option(result.Key, result.Value, result.Filter);
            }))
            self.SelectedDestOptions = ko.observableArray([]);

            self.appDestOptions = ko.observableArray();
            self.SelectedSrcOption.subscribe(function () {
                let SelectedSrc = self.SrcOptions().find(o => o.Id == self.SelectedSrcOption())
                let appDestOptList = self.DestOptions().filter(o => o.Filter == SelectedSrc.Filter && o.Id != SelectedSrc.Id);
                self.appDestOptions(appDestOptList);
                $('#DestOptDropDown').multiselect();
                $('#DestOptDropDown').multiselect('refresh');
            });

            self.CopyOverUserAssignmentList = ko.observableArray([]);
            $("#CopyOverUserTable").DataTable();

            self.PreviewPerformed = ko.observable(false);
            self.PreviewSrcOptions = ko.observable();
            self.PreviewDestOptions = ko.observable();

            function ActionCopyOverUserAssignment(Src, Dest, Operation) {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Survey/ActionCopyOverUserAssignment",
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify({
                            SrcParam: Src,
                            DestParam: Dest,
                            Operation: Operation
                        })
                    })
                        .success(function (jsonResult, error) {
                            if (jsonResult !== null) {
                                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                                }
                                else if (jsonResult.Actions.length > 0) {
                                    let CopyOverRecordsList = $.map(jsonResult.Actions, function (result) {
                                        return new CopyOverRecord(result.Source, result.Destination, result.Message);
                                    });
                                    self.CopyOverUserAssignmentList([]);
                                    var table = $("#CopyOverUserTable").DataTable();
                                    table.destroy();
                                    $("#CopyOverUserTable tbody tr").remove();
                                    self.CopyOverUserAssignmentList(CopyOverRecordsList);
                                    $("#CopyOverUserTable").DataTable();
                                }
                                else {
                                    logger.logWarning('The feature is under development. Please contact the Application Administrator for support.', 'Warning', system.getModuleId(SCViewModel), true);
                                }
                            }
                            else {
                                logger.logError('An error occurred while fetching data. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                            }

                        })
                        .fail(function (error, status) {
                            logger.logError('An error occurred while fetching data. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        });
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | During ' + Operation + ' at ActionCopyOverUserAssignment() in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            }

            self.PreviewCopyOver = function () {
                self.CopyOverUserAssignmentList();
                self.PreviewSrcOptions(self.SelectedSrcOption());
                self.PreviewDestOptions(self.SelectedDestOptions().join(","));
                ActionCopyOverUserAssignment(self.PreviewSrcOptions(), self.PreviewDestOptions(), 'PREVIEW').then(() => {
                    self.PreviewPerformed(true);
                });
            }

            self.ExecuteCopyOver = function () {
                self.CopyOverUserAssignmentList();
                if (self.SelectedSrcOption() != self.PreviewSrcOptions() || self.SelectedDestOptions().join(",") != self.PreviewDestOptions()) {
                    logger.logError('Copy Over can only be performed for which the results are reviewed.', 'Error', system.getModuleId(SCViewModel), true);
                    return;
                }
                ActionCopyOverUserAssignment(self.PreviewSrcOptions(), self.PreviewDestOptions(), 'EXECUTE');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CopyOverUserFilterModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //#endregion

    //Compose binds another js
    function GetAreaDetails(data, event) {
        try {
            if (data.SelectedAreas().length <= 0) {
                $('#NoRiskAreasSelectedQTDR').show()
            }
            else {
                $('#NoRiskAreasSelectedQTDR').hide()
                ko.applyBindingsToNode($('#div_RiskArea').get(0), {
                    compose: {
                        model: 'viewmodels/survey/QuantitativeSurveySetup',
                        activationData: {
                            SelectedAreas: SCViewModel.SelectedAreas(),
                            ClickedSurveyProfileId: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                            SelectedBuId: SCViewModel.SelectedBuId(), BulkFlag: SCViewModel.IsBulkAction(), BulkFlagLength: SCViewModel.SelectedBuIdList().length
                        }
                    }
                }, SCViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:GetAreaDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllBusinessUnits(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                    SCViewModel.BuModelList()[i].isChecked(event.currentTarget.checked);
                }
            }
            else {

                for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                    SCViewModel.BuModelList()[i].isChecked(event.currentTarget.checked);
                }
            }
            var rows = $("#tblSurveyDetails").dataTable().fnGetNodes();
            $("#tblSurveyDetails").removeClass("border-collpase")
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllBusinessUnits() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllQuestionnaire(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0; i < SCViewModel.QuestionsForCheckedAreasList().length; i++) {
                    SCViewModel.QuestionsList()[i].IsApplicable(true);
                }
            }
            else {
                for (var i = 0; i < SCViewModel.QuestionsForCheckedAreasList().length; i++) {
                    SCViewModel.QuestionsList()[i].IsApplicable(false);
                }
            }

            var rows = $("#QuestionMappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: function fail in SelectAllQuestionnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllUsers(data, event) {
        try {
            for (var i = 0; i < SCViewModel.SurveyUsersList().length; i++) {
                if (SCViewModel.SurveyUsersList()[i].RoleType() == SCViewModel.CurrentRoleType()) {
                    SCViewModel.SurveyUsersList()[i].IsChecked(event.currentTarget.checked);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllQuestionnaireByArea(data, event) {
        try {
            ko.utils.arrayFilter(SCViewModel.QuestionsList(), function (item) {
                if (item.RiskAreaId() == SCViewModel.SelectedRiskAreaId()) {
                    item.IsApplicable(event.currentTarget.checked);
                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllQuestionnaireByArea() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function generateJsonQuestionnnaire() {
        try {
            ko.utils.arrayForEach(SCViewModel.QuestionsList(), function (item) {
                ko.utils.arrayForEach(SCViewModel.QuestionsForCheckedAreasList(), function (AgainItem) {
                    if (AgainItem.QuestionId() == item.QuestionId()) {
                        item.IsApplicable(AgainItem.IsApplicable());
                    }
                });
            });
            var temp = 0; // if it becomes 1 in below code ,then warning will be shown
            var list = SCViewModel.QuestionsList()
            var MainList = [];
            for (var i = 0; i < SCViewModel.SelectedBuIdList().length; i++) {
                for (var x = 0; x < SCViewModel.BuModelList().length; x++) { 
                    if (SCViewModel.SelectedBuIdList()[i] == SCViewModel.BuModelList()[x].BuId()) {
                        if (SCViewModel.BuModelList()[x].ReadonlyFlag() == 1) {
                            temp = 1;
                        }
                    }
                }
                var mappedlist = $.map(SCViewModel.QuestionsList(), function (item) {
                    if (item.IsApplicable() == true)
                        return {
                            BusinessUnitID: SCViewModel.SelectedBuIdList()[i], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()),
                            QuestionId: (item.QuestionId() == undefined) ? item.RiskFactorId() : item.QuestionId(), RiskAreaId: item.RiskAreaId(), RiskFactorId: item.RiskFactorId(), Rank: item.Rank(), DisplayRank: item.Rank(), Flag: SCViewModel.IsBulkAction()
                        };
                });
                var x = "temp";
                for (var j = 0; j < mappedlist.length; j++) {
                    MainList.push(mappedlist[j]);
                }
            }
            if (temp == 1) {
                logger.logWarning('Some of the selected surveys are launched , Cannot edit questions now ', 'Warning', system.getModuleId(SCViewModel), true);


            }
            return MainList
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: generateJsonQuestionnnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveQuestionnaireMapping() {
        try {
            if (SCViewModel.SelectedAreas().length <= 0) {
                $('#NoRiskAreasSelected').show()
            }
            else {
                $('#SMapQLDRCTDR').prop('disabled', true);
                $('#NoRiskAreasSelected').hide();
                var MappedUserList = generateJsonQuestionnnaire()
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SaveQuestionnaire",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(MappedUserList)
                })

                    .success(function (jsonResult, success) {
                        if (jsonResult != null)
                        {
                            if (parseInt(jsonResult) > 0) {
                                logger.logSuccess('Successfully saved Questionnaire mapping.', 'Success', system.getModuleId(SCViewModel), true);
                                $('#Preview').modal("hide");
                                $('#SMapQLDRCTDR').prop('disabled', false);
                                GetallProfileSurveys();
                            }

                            else if (jsonResult.startsWith("INC"))
                            {
                                logger.logError(jsonResult + " - " + 'An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                                $('#SMapQLDRCTDR').prop('disabled', false);
                            }
                            else
                                logger.logError('An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    })
                    .fail(function (jsonResult, error) {

                    })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveMappingPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function generateJsonQuestionnnaireQTDR() {
        try {
            var list = SCViewModel.QuestionsList()
            var MainList = [];
            for (var i = 0; i < SCViewModel.SelectedBuIdList().length; i++) {
                var mappedlist = $.map(SCViewModel.QuantitativeSurveySetup.RiskAreaDetailsList(), function (item) {
                    if (item.IsApplicable() == true)
                        return {
                            BusinessUnitID: SCViewModel.SelectedBuIdList()[i], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), QuestionId: item.RiskSubFactorId(),
                            RiskAreaId: item.RiskAreaId(), RiskFactorId: item.RiskFactorId(), Rank: i, DisplayRank: i, Flag: SCViewModel.IsBulkAction() };
                });
                var x = "temp";
                for (var j = 0; j < mappedlist.length; j++) {
                    MainList.push(mappedlist[j]);
                }
            }
            return MainList
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: generateJsonQuestionnnaireQTDR() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ClosePopUpMapUsers() {
        GetallProfileSurveys();
    }


    function SaveQuestionnaireMappingQTDR() {
        try {
            if (SCViewModel.QuantitativeSurveySetup.RiskAreaDetailsList().length <= 0) {
                $('#NoRiskAreasSelected').show()
            }
            else {
                $('#SMapQTDR').prop('disabled', true);
                $('#NoRiskAreasSelected').hide();
                var MappedUserList = generateJsonQuestionnnaireQTDR()
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SaveQuestionnaire",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(MappedUserList)
                })

                    .success(function (jsonResult, success) {
                        if (jsonResult != null)
                        {
                            if (parseInt(jsonResult) > 0) {
                                logger.logSuccess('Successfully saved Questionnaire mapping.', 'Success', system.getModuleId(SCViewModel), true);
                                $('#PreviewQuestionnaire').modal("hide");
                                $('#SMapQTDR').prop('disabled', false);
                                GetallProfileSurveys();
                            }
                            else if (jsonResult.startsWith("INC"))
                            {
                                logger.logError(jsonResult + " - " + 'An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                                $('#SMapQTDR').prop('disabled', false);
                            }
                            else
                                logger.logError('An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error occurred while saving the Questionaire mapping. Please contact the Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    })
                    .fail(function (jsonResult, error) {

                    })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveQuestionnaireMappingQTDR() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function closeAssignment() {
        try {
            $('#SurveyQuestionnaire').modal("hide");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:closeAssignment() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveMappingPopUp() {
        try {
            var MappedUserList = generateJsonUsers()
            if (generateJsonUsers().length == 0) {
                var Object = { BusinessUnitID: SCViewModel.SelectedBuIdList()[0], BuSurveyID: SCViewModel.ClickedSurveyProfileId(), RoleType: 'null', RoleId: 0 };
                var MappedUserList = [];
                MappedUserList.push(Object)
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Survey/SaveSurveyAssignment",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) == 1) {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg') == -1) ? 'Survey User Mapping has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            $('#SurveyAssignment').modal('hide');
                            //$('#MapUsersPopUp').modal('hide');
                            GetallProfileSurveys();
                            GetRespondents(SCViewModel.SelectedBuIdList());
                        }
                        else if (parseInt(jsonResult) == 200) {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? 'Survey User assignment failed as the user is working on the survey. Please move the survey to open queue and then reassign the survey.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                            $('#SurveyAssignment').modal('hide');
                            //$('#MapUsersPopUp').modal('hide');
                            GetallProfileSurveys();
                            GetRespondents(SCViewModel.SelectedBuIdList());
                        }
                        else if (jsonResult.startsWith("INC"))
                        {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? jsonResult + " - " + 'An error has occurred while saving User Mapping. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                })
                .fail(function (jsonResult, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveMappingPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveMappingPopUpReplace() {
        try {
            var MappedUserList = generateJsonUsers()
            if (generateJsonUsers().length == 0) {
                var Object = { BusinessUnitID: SCViewModel.SelectedBuIdList()[0], BuSurveyID: SCViewModel.ClickedSurveyProfileId(), RoleType: SCViewModel.SurveyUsersList()[0].RoleType(), RoleId: SCViewModel.SurveyUsersList()[0].RoleId() };
                var MappedUserList = [];
                MappedUserList.push(Object)
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Survey/SaveSurveyAssignment",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) > 0) {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg') == -1) ? (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg') == -1) ? 'Survey User Mapping has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg')].Name() : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            //$('#SurveyAssignment').modal('hide');
                            //$('#MapUsersPopUp').modal('hide');
                            GetallProfileSurveys();
                            GetRespondents(SCViewModel.SelectedBuIdList());
                        }
                        else if (jsonResult.startsWith("INC"))
                        {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg') == -1) ? jsonResult + " - " + 'An error has occurred while saving User Mapping. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyUserMappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                })
                .fail(function (jsonResult, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveMappingPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function AssignQuestionnairePopup(data, event) {
        try {
            SCViewModel.DisableActionButtons(data.ReadonlyFlag());
            $('#ValErrorQuestionnnaire').hide();
            $("#PopupBodyQuestionnaire").show();
            SCViewModel.IsBulkAction(0);
            var BuId = data.BuId();
            SCViewModel.SelectedBuIdList([]);
            SCViewModel.SelectedBuIdList().push(BuId);
            SCViewModel.popUpTitleSurvey("Assign Questionnaire");
            $("#SurveyQuestionnaire").modal('show');
            GetQuestionnaire(BuId)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:AssignQuestionnairePopup() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }


    function PreviewQuestionnaire(data, event) {
        try {
            SCViewModel.IsBulkAction(0);
            var SurveyType = SCViewModel.SurveyType();
            SCViewModel.DisableActionButtons(data.ReadonlyFlag());
            $('#ErrorQuestionnnaire').hide();
            SCViewModel.SelectedBuId(data.BuId());
            SCViewModel.SelectedBuIdList([]);
            SCViewModel.SelectedBuIdList().push(data.BuId());
            SCViewModel.SelectedSpIdList([]);
            SCViewModel.SelectedSpIdList().push(data.SpId());
            SCViewModel.SelectedSpId((data.SpId()));
            SCViewModel.SelectedBusinessUnitName(data.BuName());
            if (data.SurveyType() == '') {
                SCViewModel.SelectedSurveyTypeforSummary(SurveyType);
            }
            else {
                SCViewModel.SelectedSurveyTypeforSummary((data.SurveyType()));
            }
            $('#SelectAllQual').prop('checked', false);
            //GetAllRiskAreas(SurveyType);
            GetAllRiskAreas(SCViewModel.SelectedSurveyTypeforSummary());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:PreviewQuestionnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function PreviewQuestions(data, event) {
        try {
            SCViewModel.PreviewView(true);
            SCViewModel.PreviewEditUpdated(false);
            if (data.SurveyType() == '') {
                var SurveyType = SCViewModel.SurveyType();
            }
            else {
                var SurveyType = data.SurveyType();
            }
            if (SurveyType != 'QTDR')
                $('#togglePreviewQualControl').prop('checked', true);
            else
                $('#togglePreview').prop('checked', true);
            SCViewModel.IsBulkAction(0);
            //var SurveyType = SCViewModel.SurveyType();            
            SCViewModel.DisableActionButtons(data.ReadonlyFlag());
            $('#ErrorQuestionnnaire').hide();
            $('#valError').hide();
            SCViewModel.SelectedBuId(data.BuId());
            SCViewModel.SelectedBuIdList([]);
            SCViewModel.SelectedBuIdList().push(data.BuId())
            SCViewModel.SelectedBusinessUnitName(data.BuName());
            SCViewModel.SelectedSpIdList([]);
            SCViewModel.SelectedSpIdList().push(data.SpId());
            SCViewModel.SelectedSpId((data.SpId()));
            SCViewModel.DisablePreviewSaveBtn(true);
            GetAllRiskAreasForPreview(SurveyType, data.BuId());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:PreviewQuestions() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveMappings(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            SaveSurveyMapping = {
                url: "/api/Configuration/SaveSurveyMapping",
                type: "POST",
                headers: headers,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskAreaDetailsList: data.QuantitativeSurveySetup.RiskAreaDetailsList(),
                    BuId: data.QuantitativeSurveySetup.SelectedBuId,
                    SurveyProfileId: data.QuantitativeSurveySetup.ClickedSurveyProfileId
                })
            };

            $.ajax(SaveSurveyMapping)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveMappings() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult > 0) {
                    logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappingSuccessMsg') == -1) ? 'Mapping has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappingSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                    SCViewModel.SelectedAreas([]);
                    GetAreaDetails(data, event);
                }
                else {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappingErrorMsg') == -1) ? 'An error has occurred whie saving the mapping. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MappingErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetQuestionnaire(BuId) {
        try {
            var headers = appsecurity.getSecurityHeaders();
            return $.ajax({
                url: "/api/Survey/GetQuestionnaire",
                type: "GET",
                data: { ProfileId: SCViewModel.ClickedSurveyProfileId(), BuId: BuId },
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult.length > 0) {

                        if (jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else {
                            var MappedQuestionList = $.map(jsonResult, function (result) {
                                return new QuestionListModel(result);
                            });

                            var Object = $("#QuestionMappingTable").DataTable();
                            Object.destroy();
                            $("#QuestionMappingTable tbody tr").remove();
                            SCViewModel.QuestionsList(MappedQuestionList);
                            $("#QuestionMappingTable").DataTable();
                            var rows = $("#QuestionMappingTable").dataTable().fnGetNodes();
                            var cells = [];
                            for (var i = 0; i < rows.length; i++) {
                                // Get HTML of 3rd column (for example)
                                var RespText = $(rows[i]).find("td:eq(2)").html()
                                var RespTextEdit = RespText.replace(/}/g, '<br/>');
                                $(rows[i]).find("td:eq(2)").html(RespTextEdit);
                            }
                        }
                    }
                    else {

                    }
                })
                .fail(function (error, status) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchQuestionnaire') == -1) ? 'An error has occurred while fetching the Questionnaire. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchQuestionnaire')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:GetQuestionnaire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SaveQuestionMapping() {
        try {
            SaveQuestionnaireMapping();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:SaveQuestionMapping() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    //function AssignBulkResponders() {
    //    try {
    //        SCViewModel.DisableActionButtons(false);
    //        SCViewModel.popUpTitleSurvey('Assign Responders')
    //        SCViewModel.SelectedBuIdList([])
    //        for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
    //            if (SCViewModel.BuModelList()[i].isChecked()) {
    //                SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
    //            }
    //        }
    //        SCViewModel.SelectedUserType("RESP")
    //        $('#SurveyAssignment').modal('show');
    //        $('#selectallUsers').prop('checked', false);
    //        $('#modalContent').css({
    //            'margin-top': '25%'
    //        });
    //        if (SCViewModel.SelectedBuIdList().length == 0) {
    //            $('#ValErrorSurvey').show();
    //            $("#PopupBody").hide();
    //            $('#ValErrorSurvey').html('No ' + SCViewModel.BUTitle() +' is selected to perform the group actions');
    //            SCViewModel.DisableActionButtons(true);
    //        }
    //        else {
    //            $('#ValErrorSurvey').hide();
    //            $("#PopupBody").show();
    //            var object = $('#MappingTable').DataTable();

    //            object.destroy();
    //            $("#MappingTable tbody tr").remove();

    //            GetALLRespondents(SCViewModel.SelectedUserType()).then(function () {


    //            })
    //        }


    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source:AssignBulkResponders() method in ConfigureSurvey.js';
    //        logger.logMessage(msg);
    //    }
    //}

    //function AssignBulkReviewers() {
    //    try {
    //        SCViewModel.DisableActionButtons(false);
    //        SCViewModel.popUpTitleSurvey('Assign Reviewers')
    //        SCViewModel.SelectedBuIdList([])
    //        for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
    //            if (SCViewModel.BuModelList()[i].isChecked()) {
    //                SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
    //            }
    //        }

    //        SCViewModel.SelectedUserType("REV")
    //        $('#SurveyAssignment').modal('show');
    //        $('#selectallUsers').prop('checked', false);
    //        $('#modalContent').css({
    //            'margin-top': '25%'
    //        });
    //        if (SCViewModel.SelectedBuIdList().length == 0) {
    //            $('#ValErrorSurvey').show();
    //            $("#PopupBody").hide();
    //            $('#ValErrorSurvey').html('No ' + SCViewModel.BUTitle() + ' is selected to perform the group actions');
    //            SCViewModel.DisableActionButtons(true);
    //        }
    //        else {
    //            $('#ValErrorSurvey').hide();
    //            $("#PopupBody").show();
    //            var object = $('#MappingTable').DataTable();

    //            object.destroy();
    //            $("#MappingTable tbody tr").remove();

    //            GetALLRespondents(SCViewModel.SelectedUserType()).then(function () {

    //            })
    //        }

    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source:AssignBulkReviewers() method in ConfigureSurvey.js';
    //        logger.logMessage(msg);
    //    }
    //}

    function AssignBulkQuestionnanire() {
        try {
            SCViewModel.IsBulkAction(1);
            SCViewModel.DisableActionButtons(false);
            SCViewModel.popUpTitleSurvey('Assign Questionnaire')
            SCViewModel.SelectedBuIdList([])
            var BuNames;
            for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                if (SCViewModel.BuModelList()[i].isChecked()) {
                    SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
                    if (SCViewModel.SelectedBuIdList().length == 1) {
                        BuNames = SCViewModel.BuModelList()[i].BuName()
                    }
                    else if (SCViewModel.SelectedBuIdList().length > 1) {
                        BuNames = BuNames + ', ' + SCViewModel.BuModelList()[i].BuName()
                    }
                }
            }
            SCViewModel.SelectedBusinessUnitName(BuNames);
            if (SCViewModel.SelectedBuIdList().length == 0) {
                $("#SurveyQuestionnaire").modal('show');
                $('#selectall').prop('checked', false);
                $('#ValErrorQuestionnnaire').show();
                $("#PopupBodyQuestionnaire").hide();
                $('#ValErrorQuestionnnaire').html('No ' + SCViewModel.BUTitle() + ' has been selected to perform this group action.');
                SCViewModel.DisableActionButtons(true);
            }
            else {
                $('#ValErrorQuestionnnaire').hide();
                SCViewModel.SelectedBuId(SCViewModel.SelectedBuIdList()[0])
                var SurveyType = SCViewModel.SurveyType();
                GetAllRiskAreas(SurveyType)
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:AssignBulkQuestionnanire() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function generateJsonUsers() {
        try {
            var MainList = [];
            for (var i = 0; i < SCViewModel.SelectedBuIdList().length; i++) {
                var mappedlist = $.map(SCViewModel.SurveyUsersList(), function (item) {
                    if (item.IsChecked())
                        //return { BusinessUnitID: SCViewModel.SelectedBuIdList()[i], BuSurveyID: SCViewModel.ClickedSurveyProfileId(), RoleID: item.RoleId(), RoleType: item.RoleType(), Username: item.UserName(), UserId: item.UserId() };
                        return { BusinessUnitID: SCViewModel.SelectedBuIdList()[i], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpIdList()[i]: SCViewModel.ClickedSurveyProfileId()), RoleID: item.RoleId(), RoleType: item.RoleType(), Username: item.UserName(), UserId: item.UserId() };
                    //  return { BusinessUnitID: SCViewModel.SelectedBuIdList()[i], BuSurveyID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()), RoleID: item.RoleId(), RoleType: item.RoleType(), Username: item.UserName(), UserId: item.UserId() };
                });
                var x = "temp";
                for (var j = 0; j < mappedlist.length; j++) {
                    MainList.push(mappedlist[j]);
                }
            }


            return MainList

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:generateJsonUsers() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function EnableSave() {
        $('#SurveyApplicabilityDropdown').show();
        SCViewModel.DisableSaveButton(false);
        SCViewModel.DisableLaunchButton(true);
    }

    function EnableLaunch() {
        SCViewModel.DisableLaunchButton(false);
        SCViewModel.DisableSaveButton(true);

    }

    function ActionChanged(data, event) {
        try {
            $('#loadingAssessmentType').prop('visibility', 'visible');
            SCViewModel.ConfigureSurveyFlag(false);
            var surveyType = $('#SurveyCategory').val();
            var selectedoption = $("#SurveyCategory option:selected").text();
            var TypeofSurvey = "";
            for (var i = 0; i < SCViewModel.SurveyTypesList().length; i++) {
                if (SCViewModel.SurveyTypesList()[i].SurveyCategoryName().toLowerCase() == selectedoption.toLowerCase()) {
                    TypeofSurvey = SCViewModel.SurveyTypesList()[i].SurveyGroupShortName();

                    if (SCViewModel.editableSurvey().surveyType() != -1) {
                        SCViewModel.editableSurvey().surveyType(TypeofSurvey);
                    }
                }
            }
            if (surveyType == 'SEL') {
                SCViewModel.AssessmentTypeListAsPerSurveytype([]);
                SCViewModel.AssessmentTypeListDupAsPerSurveytype([]);
                $('#SurveyAssessmentApplicability').multiselect('refresh');
            }
            else {
                GetAllAssessmentTypesAsPerSurveytype(surveyType, TypeofSurvey).then(function () {
                    if (SCViewModel.SelectedActionType() == 'SA') {
                        EnableSave();
                    }
                    else {
                        EnableLaunch();

                    }

                });

            }
            $('#loadingAssessmentType').prop('visibility', 'hidden');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function BulkAssignUsers(data, event) {

        SCViewModel.BulkUserActionsFlag(true);
        SCViewModel.SelectedBuIdList([])
        SCViewModel.SelectedSpIdList([]);
        for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
            if (SCViewModel.BuModelList()[i].isChecked()) {
                SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
                SCViewModel.SelectedSpIdList().push(SCViewModel.BuModelList()[i].SpId());
            }
        }

        if (SCViewModel.SelectedBuIdList().length > 0) {
            GetRespondents(SCViewModel.SelectedBuIdList()).then(function () {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/Survey/GetUsersWorkFlowList",
                        type: "GET",
                        data: { "BulkUsersFlag": true, "SpUid": SCViewModel.ClickedSurveyProfileId() },
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(function (jsonResult, error) {
                            if (jsonResult !== null) {

                                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                                }

                                if (jsonResult.length > 0)
                                {
                                    SCViewModel.CurrentRoleType(jsonResult[0].RoleShortName);
                                    SCViewModel.WorkFlowList([]);
                                    SCViewModel.WorkFlowList(jsonResult);
                                    Obj = $('#tblSurveyUser').DataTable();
                                    Obj.destroy();
                                    $('#tblSurveyUser tbody tr').remove();

                                    $('#UserAssignment').modal('show');

                                    $('#PopupBodyMapUsers').show();
                                    $('#MapUsersActions').show();
                                    $('#ValErrorSurveyMapUsers').hide();

                                    var UserList = ko.toJS(SCViewModel.UsersList());

                                    var UList = $.map(UserList, function (result) {
                                        return new RespondentListModel(result);
                                    });
                                    SCViewModel.SurveyUsersList(UList);

                                    $('#UsersRoleWFChevrons ul li:first').click();

                                    //$('#MapUsersPopUp').modal('show');
                                    //$("#filter.nav-pills a").first().click();

                                    if ($.fn.dataTable.isDataTable('#tblSurveyUser')) {
                                        table = $('#tblSurveyUser').DataTable();
                                    }
                                    else {
                                        table = $('#tblSurveyUser').DataTable({
                                            "order": [],
                                            "aaSorting": [],
                                            "bResponsive": true,
                                            "aoColumnDefs": [
                                                {
                                                    "aTargets": [0],
                                                    "bSortable": false
                                                }]
                                        });
                                    }
                                    $('#tblSurveyUser').DataTable().draw(false);
                                }
                                else {
                                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems') == -1) ? 'An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems')].Name(), 'Error', system.getModuleId(RRSurveyConfigVM), true);
                                }
                            }
                            else {
                                logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems') == -1) ? 'An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems')].Name(), 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }

                        })
                        .fail(function (error, status) {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems') == -1) ? 'An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems')].Name(), 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: bulkassignUsers() method in RRConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            });
        }

        else {
            $('#UserAssignment').modal('show');
            $('#PopupBodyMapUsers').hide();
            $('#MapUsersActions').hide();
            $('#ValErrorSurveyMapUsers').show();
            $('#ValErrorSurveyMapUsers').html('No ' + SCViewModel.BUTitle() + ' is selected to perform the group actions');
        }
    }


    /********************************** NAV TAB CLICK START *******************************************/

    function NavTabClick(data, event) {

        try {
            if (typeof (event) == "undefined") { // First Load Condition
                SCViewModel.NavPillId("REV");
                $("#filter.nav-pills a").first().addClass("active");
            }
            else {
                SCViewModel.NavPillId(event.currentTarget.id); // Get the Id of Navbar Pill Selected
                $('#filter.nav-pills a').removeClass("active");
                document.getElementById(SCViewModel.NavPillId()).classList.add("active");
                //document.getElementById(SCViewModel.NavPillId()).click();
            }


            if (SCViewModel.NavPillId() == "REV") {
                SCViewModel.DisableActionButtons(false);
                SCViewModel.popUpTitleSurvey('Assign Reviewers')
                SCViewModel.SelectedBuIdList([])
                for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                    if (SCViewModel.BuModelList()[i].isChecked()) {
                        SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
                    }
                }

                SCViewModel.SelectedUserType("REV")
                $('#selectallUsers').prop('checked', false);
                if (SCViewModel.SelectedBuIdList().length == 0) {
                    $('#ValErrorSurveyMapUsers').show();
                    $("#PopupBodyMapUsers").hide();
                    $('#ValErrorSurveyMapUsers').html('No Survey' + SCViewModel.BUTitle() + ' is selected to perform the group actions');
                    SCViewModel.DisableActionButtons(true);
                }
                else {
                    $('#ValErrorSurveyMapUsers').hide();
                    $("#PopupBodyMapUsers").show();

                    if (!$.fn.DataTable.isDataTable('#MappingTableMapUsers')) {
                        var object = $('#MappingTableMapUsers').DataTable({
                            "pagingType": "full_numbers",
                            "stateSave": true,
                            "paging": true,
                            "lengthMenu": [10, 25, 50, 75, 100]
                        });

                        object.destroy();
                        $("#MappingTableMapUsers tbody tr").remove();
                    }

                    else {
                        var object = $('#MappingTableMapUsers').DataTable({
                            "pagingType": "full_numbers",
                            "stateSave": true,
                            "retrieve": true,
                            "paging": true,
                            "lengthMenu": [10, 25, 50, 75, 100]
                        });

                        object.destroy();
                        $("#MappingTableMapUsers tbody tr").remove();
                    }


                    GetALLRespondents(SCViewModel.SelectedUserType()).then(function () {

                    })
                }
            }

            else if (SCViewModel.NavPillId() == "RESP") {
                //For Responders
                SCViewModel.DisableActionButtons(false);
                SCViewModel.popUpTitleSurvey('Assign Responders')
                SCViewModel.SelectedBuIdList([])
                for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
                    if (SCViewModel.BuModelList()[i].isChecked()) {
                        SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
                    }
                }
                SCViewModel.SelectedUserType("RESP")
                $('#selectallUsers').prop('checked', false);
                if (SCViewModel.SelectedBuIdList().length == 0) {
                    $('#ValErrorSurveyMapUsers').show();
                    $("#PopupBodyMapUsers").hide();
                    $('#ValErrorSurveyMapUsers').html('No ' + SCViewModel.BUTitle() + ' is selected to perform the group actions');
                    SCViewModel.DisableActionButtons(true);
                }
                else {
                    $('#ValErrorSurveyMapUsers').hide();
                    $("#PopupBodyMapUsers").show();
                    var object = $('#MappingTableMapUsers').DataTable();

                    object.destroy();
                    $("#MappingTableMapUsers tbody tr").remove();
                    GetALLRespondents(SCViewModel.SelectedUserType()).then(function () {
                    })
                }
            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in CreateSurvey.js';
            logger.logMessage(msg);

        }
    }


    /********************************** NAV TAB CLICK END *******************************************/

    function CloseMappingPopUp(data, event) {
        try {
            $('#SurveyAssignment').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CloseMappingPopUp() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AssignUsers(data, event) {

        $("#BuName").text(data.BuName());
        $("#BuName").show();

        SCViewModel.SelectedBuIdList([]);
        SCViewModel.SelectedBuIdList().push(data.BuId());
        SCViewModel.BulkUserActionsFlag(false);
        SCViewModel.SelectedSpIdList([]);
        SCViewModel.SelectedSpIdList().push(data.SpId());
        SCViewModel.SelectedSpId((data.SpId()));

        GetRespondents(SCViewModel.SelectedBuIdList()).then(function () {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/GetUsersWorkFlowList",
                    type: "GET",
                    //data: { "BulkUsersFlag": false, "SpUid": SCViewModel.ClickedSurveyProfileId() },
                    data: { "BulkUsersFlag": false, "SpUid": (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()) },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {

                                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                                }

                                else {
                                    SCViewModel.CurrentRoleType(jsonResult[0].RoleShortName);
                                    SCViewModel.WorkFlowList([]);
                                    SCViewModel.WorkFlowList(jsonResult);
                                    Obj = $('#tblSurveyUser').DataTable();
                                    Obj.destroy();
                                    $('#tblSurveyUser tbody tr').remove();

                                    var UserList = ko.toJS(SCViewModel.UsersList());

                                    var UList = $.map(UserList, function (result) {
                                        return new RespondentListModel(result);
                                    });
                                    SCViewModel.SurveyUsersList(UList);
                                    $('#UserAssignment').modal('show');

                                    $('#tblSurveyUser').DataTable({
                                        "order": [],
                                        "aaSorting": [],
                                        "bResponsive": true,
                                        "aoColumnDefs": [
                                            {
                                                "aTargets": [0],
                                                "bSortable": false
                                            }]
                                    });
                                    $('#tblSurveyUser').DataTable().draw(false);
                                    $('#UsersRoleWFChevrons ul li:first').click();
                                }
                            }
                            else {
                                logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems') == -1) ? 'An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems')].Name(), 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        else {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems') == -1) ? 'An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchWorkFlowListItems')].Name(), 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Users WorkFlow List Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: assignUsers() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        });
    }

    function RoleNameClick(data, event) {
        try {
            SCViewModel.CurrentRoleType(data.RoleShortName);
            document.getElementById("selectallAssignmentUsers").checked = false;
            UsertableObj = $('#tblSurveyUser').DataTable();
            UsertableObj
                .search('')
                .columns().search('')
                .draw(true);

            if (SCViewModel.CurrentRoleType() !== "ASSIGNED_USER_LIST") {
                UsertableObj = $('#tblSurveyUser').DataTable();
                UsertableObj
                    .column(3)
                    .search("^" + SCViewModel.CurrentRoleType() + "$", true, false, true)
                    .draw(true);
            }
            else {
                Obj = $('#tblSurveyUser').DataTable();
                Obj.destroy();
                $('#tblSurveyUser tbody tr').remove();

                var UserList = ko.toJS(SCViewModel.SurveyUsersList());

                var UList = $.map(UserList, function (result) {
                    return new RespondentListModel(result);
                });
                SCViewModel.SurveyUsersList(UList);

                $('#tblSurveyUser').DataTable({
                    "order": [],
                    "aaSorting": [],
                    "bResponsive": true,
                    "aoColumnDefs": [
                        {
                            "aTargets": [0],
                            "bSortable": false
                        }]
                });
                $('#tblSurveyUser').DataTable().draw(false);
                $('#tblSurveyUser').DataTable()
                    .column(4)
                    .search("^" + "true" + "$", true, false, true)
                    .draw(true);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RoleNameClick() method in RRConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetRespondents(BusinessUnitIdList) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Survey/GetSurveyUsers?BulkUsersFlag=" + SCViewModel.BulkUserActionsFlag(),
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                headers: headers,
                data:
                    JSON.stringify($.map(BusinessUnitIdList, function (item) {
                        return { BU_ID: item, PROFILE_ID: (SCViewModel.ClickedSurveyProfileId() == -999 ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId()) };
                        // return { BU_ID: item, PROFILE_ID:  SCViewModel.ClickedSurveyProfileId() };
                    }))
            })
                .success(function (jsonResult, Success) {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                        }
                        else {
                            var UserList = $.map(jsonResult, function (result) {
                                return new RespondentListModel(result);
                            });

                            SCViewModel.UsersList(UserList);
                        }
                    }
                    else {
                        logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRespondents() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetALLRespondents(RoleType) {
        try {
            $('#MappingTableMapUsers').hide();
            return $.ajax({
                url: "/api/Survey/GetALLSurveyUsers",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, Success) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else {
                        var MappedList = $.map(jsonResult, function (result) {
                            if (RoleType == "REV") {
                                if (result.RoleType == RoleType || result.RoleType == "REV2")
                                    return new RespondentListModel(result);
                            }
                            else {
                                if (result.RoleType == RoleType)
                                    return new RespondentListModel(result);
                            }
                        });
                        SCViewModel.SurveyUsersList(MappedList);
                        $('#MappingTableMapUsers').show();
                        $('#MappingTableMapUsers').DataTable();
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetALLRespondents() method in CreateSurvey.js';
            logger.logMessage(msg);
        }
    }

    //function to get all surveys Types
    function GetAllSurveyType() {
        try {
            return $.ajax({
                url: "/api/Survey/GetSurveyTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllSurveyType() in ConfigureSurvey.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult.length > 0 && jsonResult != null && jsonResult[0].UserId == -1)
                {
                    logger.logError(jsonResult[0].SurveyGroupFullName + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                }

                else if (jsonResult != undefined && jsonResult.length > 0 && jsonResult[0].UserId != -1)
                {

                    if (jsonResult != null) {
                        var mappedSurvey = $.map(jsonResult, function (result) {
                            return new SurveyCategoryModel(result);

                        });
                        SCViewModel.SurveyTypesList(mappedSurvey);
                        SCViewModel.SelectedSurveyType(SCViewModel.SurveyTypesList()[0].SurveyGroupShortName());
                        SCViewModel.SelectedSurveyTypeName(SCViewModel.SurveyTypesList()[0].SurveyCategoryName());
                        $('#adddivtabdiv').tabs();
                        $('#adddivtabdiv').tabs('refresh');
                        $('#adddivtabdiv').tabs({
                            active: 0
                        });
                        $('ul#SurveyComponentsUL li:first').click();
                        scrollableTabs();
                    }
                }
                else
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? jsonResult[0].SurveyGroupFullName + " - " + 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyType() in CreateSurvey.js';
                logger.logMessage(msg);

            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in CreateSurvey.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyType() method in CreateSurvey.js';
                logger.logMessage(msg);
            }
        }
    }
    //Funciton to get all survey types eneds here

    function SurveyTypeTabClick(data, event) {
        try {
            SCViewModel.SurveyType(data.SurveyGroupShortName());
            SCViewModel.SelectedSurveyType(data.SurveyCategoryId());
            SCViewModel.SelectedSurveyTypeName(data.SurveyCategoryName());
            $('#SurveyComponentsUL li').removeClass('active');
            $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');
            getSurveysBasedOnType(data.SurveyGroupShortName());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyTypeTabClick() method in CreateSurvey.js';
            logger.logMessage(msg);
        }
    }

    function getSurveysBasedOnType(Type) {
        try {

            SCViewModel.CreatedSurveyList([]);

            return $.ajax({
                url: "/api/Survey/GetCreatedSurveys",
                type: "GET",
                data: { "surveyTypeId": SCViewModel.SelectedSurveyType() },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else if (jsonResult.length > 0) {

                        $("#NoSurveyError").hide();
                        $("#addivSubTab").show();
                        var mappedSurveyListgroup = $.map(jsonResult, function (result) {
                            var SurveyModelObj = new SurveySetupModel(result);
                            return SurveyModelObj;
                        });
                        SCViewModel.CreatedSurveyList(mappedSurveyListgroup);
                        $('#addivSubTab').tabs();
                        $('#addivSubTab').tabs('refresh');
                        $($('#addivSubTab li').get(0)).trigger('click');
                        $('ul#SurveyProfilesUL li:first').click();
                        //$($('#SurveyComponentsUL li').get(0)).trigger('click');
                        scrollableTabs();

                        if (jsonResult[0].SurveyprofileId == -999) {
                            $("#groupActions_AssignQuestionnaire").hide();
                        }
                        else {
                            $("#groupActions_AssignQuestionnaire").show();
                        }

                    }
                    else {
                        SCViewModel.BuModelList([]);
                        var object = $('#tblSurveyDetails').DataTable();
                        object.destroy();
                        $('#tblSurveyDetails tbody tr').remove();
                        $("#tblSurveyDetails").DataTable();
                        //$('#tblSurveyDiv').hide();
                        $("#NoSurveyError").show();
                        $("#addivSubTab").hide();

                    }
                })
                .fail(function (jsonnResult, error) {

                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);

                });
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from getallSurveysBasedonType() method in CreateSurvey.js';
            logger.logMessage(msg);
        }
    }

    function OpenAddSurveyPopup(data, event) {
        try {
            $('#frmSurveyPopup').modal('show');
            $('#DivForScroll').hide();
            SCViewModel.SurveyCateogarySelected(false);
            SCViewModel.EditFactorVisible(false);
            SCViewModel.ConfigureSurveyFlag(true);


            if (SCViewModel.editableSurvey() != null) {
                if (SCViewModel.editableSurvey().surveyType() != null) {
                    SCViewModel.editableSurvey().surveyType([]);
                }
            }
            var newAssessment = new SurveyListModel({ SurveyId: 999, SurveyName: "", SurveySecondName: "", surveyType: "", Applicability: "" });
            SCViewModel.SelectedAssessmentType([]);
            SCViewModel.SurveyCreateModel(newAssessment);
            SCViewModel.editableSurvey(newAssessment);
            SCViewModel.popUpTitle((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey') == -1) ? 'Add New Survey' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey')].Name().toString());
            var windowweight = $(window).height() / 1.8;
            var windowHeight = $(window).innerWidth() - 144;
            SCViewModel.addPopUpCssSurvey(true);

            GetallSurveys().then(function () {
                $('#SurveyAssessmentApplicability').multiselect();
                $('#SurveyAssessmentApplicability').multiselect('refresh');
                $('#DivForScroll').show();

            })

            SCViewModel.DisableSurveyDropdown(false);
            SCViewModel.DisableApplicabilityDropdown(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenAddSurveyPopup() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetAllAssessmentTypes() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: headers

            })
                .success(function (jsonResult, error) {
                    SCViewModel.AssessmentTypeList([]);
                    SCViewModel.AssessmentTypeListDup([]);

                    if (jsonResult.length > 0 && jsonResult[0].Description.startsWith("INC")) {
                        logger.logError(jsonResult[0].Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else if (jsonResult != undefined && jsonResult.length>0 && jsonResult[0].AssessmentId != -1)
                    {

                        if (jsonResult != null) {
                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                            var MappedAssessmentListDup = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });

                        }
                        var tableobject = $('#AssessmentTypeTable').DataTable();
                        tableobject.destroy();
                        $('#AssessmentTypeTable tbody tr').remove();
                        SCViewModel.AssessmentTypeList(MappedAssessmentList);
                        SCViewModel.AssessmentTypeListDup(MappedAssessmentListDup);
                        SCViewModel.AssessmentTypeListAsPerSurveytype(MappedAssessmentList);
                        SCViewModel.AssessmentTypeListDupAsPerSurveytype(MappedAssessmentListDup);
                        $('#AssessmentTypeTable').DataTable({
                            "bResponsive": true,
                            "stateSave": true,
                            "paging": true,
                            "order": [],
                            "orderable": false
                        })
                    }

                    else
                        logger.logError("An error has occurred while fetching the type assessments. Please contact your Administrator.", 'Error', system.getModuleId(SCViewModel), true);
                })

                .fail(function (error, status) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? error.Description + ' - ' + 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function GetAllAssessmentTypesAsPerSurveytype(surveyType, TypeofSurvey) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypesAsPerSurveytype",
                type: "GET",
                headers: headers,
                data: { surveyType: surveyType, typeofSurvey: TypeofSurvey }

            })
                .success(function (jsonResult, error) {
                    SCViewModel.AssessmentTypeListAsPerSurveytype([]);
                    SCViewModel.AssessmentTypeListDupAsPerSurveytype([]);

                    if (jsonResult != null) {

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                            var MappedAssessmentListDup = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                        }

                    }
                    SCViewModel.AssessmentTypeListAsPerSurveytype(MappedAssessmentList);
                    SCViewModel.AssessmentTypeListDupAsPerSurveytype(MappedAssessmentListDup);
                    $('#SurveyAssessmentApplicability').multiselect('refresh');
                })
                .fail(function (error, status) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypesAsPerSurveytype() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }




    function SaveSurvey(data, event) {
        try {

            if (data.editableSurvey().SurveyName().length == 0 || data.editableSurvey().SurveyName() == "") {
                $('#valErrorSurvey').text("Survey Short Name can not be empty");
                $('#valErrorSurvey').show();
                return false;
            }
            else if (data.editableSurvey().SurveySecondName().length == 0 || data.editableSurvey().SurveySecondName() == "") {
                $('#valErrorSurvey').text("Survey Name can not be empty");
                $('#valErrorSurvey').show();
                return false;
            }
            else if (data.editableSurvey().surveyType() == "" || data.editableSurvey().surveyType().length == 0) {
                $('#valErrorSurvey').text("Survey Type can not be empty");
                $('#valErrorSurvey').show();
                return false;
            }
            else if (SCViewModel.SelectedAssessmentType().length == 0) {
                return false;
            }
            else {
                AddSurvey(data)
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function UpdateSurvey(data, event) {
        try {
            if (data.editableSurvey().SurveyName().length == 0 || data.editableSurvey().SurveyName() == "") {
                return false;
            }
            else if (data.editableSurvey().SurveySecondName().length == 0 || data.editableSurvey().SurveySecondName() == "") {
                return false;
            }
            else {
                EditSurveyDetails(data);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UpdateSurvey() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }



    function EditSurveyDetails(data) {
        try {
            var selectedassessmetId = "";
            for (var i = 0; i < SCViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + SCViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + SCViewModel.SelectedAssessmentType()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/EditSurvey",
                type: "POST",
                data: { SurveyId: data.editableSurvey().SurveyId(), SurveyName: data.editableSurvey().SurveyName(), SurveySecondName: data.editableSurvey().SurveySecondName },
                headers: headers,
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) > 0) {
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditSuccessMsg') == -1) ? 'Survey has been edited successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            GetallSurveys();
                            var newAssessment = new SurveyListModel({ SurveyId: 999, SurveyName: "", SurveySecondName: "", surveyType: "", Applicability: "" });
                            SCViewModel.SelectedAssessmentType([]);
                            SCViewModel.editableSurvey(newAssessment);
                            SCViewModel.EditFactorVisible(false);
                            SCViewModel.DisableSurveyDropdown(false);
                            $('#SurveyAssessmentApplicability').multiselect();
                            $('#DivForScroll').show();
                            SCViewModel.popUpTitle((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey') == -1) ? 'Add New Survey' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey')].Name().toString());
                            $("#" + SCViewModel.SelectedSurveyType()).trigger('click');
                        }

                        else if (jsonResult.startsWith("INC"))
                        {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg') == -1) ? (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg') == -1) ? jsonResult + " - " + 'Some error occured while editing the Survey. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg')].Name() : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }

                        else
                        {
                            logger.logError('Some error occured while editing the Survey. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('Some error occured while editing the Survey. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                })
                .fail(function (jsonResult, error) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg') == -1) ? 'Some error occured while editing the Survey. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditSurveyDetails() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AddSurvey(data) {
        try {
            var selectedassessmetId = "";
            for (var i = 0; i < SCViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + SCViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + SCViewModel.SelectedAssessmentType()[i];
            }
            var value = $('#SurveyCategory').val();
            var SelectedText = $("#SurveyCategory option:selected").text();

            var SelectedSurveyid = 0;
            for (var i = 0; i < SCViewModel.SurveyTypesList().length; i++) {
                if (SCViewModel.SurveyTypesList()[i].SurveyCategoryName().toLowerCase() == SelectedText.trim().toLowerCase()) {
                    SelectedSurveyid = SCViewModel.SurveyTypesList()[i].SurveyCategoryId()
                }
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/AddSurvey",
                type: "POST",
                data: { surveyType: value, SurveyName: data.editableSurvey().SurveyName(), SurveySecondName: data.editableSurvey().SurveySecondName, Applicability: selectedassessmetId },
                headers: headers,
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null)
                    {
                        if (parseInt(jsonResult) > 0) {
                            $('#frmSurvey').modal('hide');
                            SCViewModel.ConfigureSurveyFlag(true);
                            logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddSuccessMsg') == -1) ? 'Survey has been added successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                            SCViewModel.AssessmentTypeListDupAsPerSurveytype([]);
                            GetallSurveys();
                            var newAssessment = new SurveyListModel({ SurveyId: 999, SurveyName: "", SurveySecondName: "", surveyType: "", Applicability: "" });
                            SCViewModel.SurveyCreateModel(newAssessment);
                            SCViewModel.editableSurvey(newAssessment);
                            $('#SurveyAssessmentApplicability').multiselect();
                            $("#" + SCViewModel.SelectedSurveyType()).trigger('click');
                            $('#valErrorSurvey').hide();
                        }

                        else if (jsonResult.startsWith("INC")) {
                            logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddErrorMsg') == -1) ? jsonResult + " - " + 'Some error occured while adding the Survey. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('Some error occured while adding the Survey. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }
                    else
                        logger.logError('Some error occured while adding the Survey. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);

                })
                .fail(function (jsonResult, error) {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddErrorMsg') == -1) ? 'Some error occured while adding the Survey. Please contact your Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyAddErrorMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function EditSurvey(data, event) {
        try {
            var newSurvey = new SurveyListModel({ SurveyId: data.SurveyId(), SurveyName: data.SurveyName(), SurveySecondName: data.SurveySecondName(), surveyType: data.surveyType(), Applicability: data.Applicability(), AssessmentId: data.AssessmentIdList });
            newSurvey.Editing = true;
            var Assessment = data.Applicability();
            SCViewModel.EditFactorVisible(true);
            SCViewModel.editableSurvey(newSurvey);
            SCViewModel.popUpTitle((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditDetails') == -1) ? 'Edit Survey Details' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyEditDetails')].Name().toString());
            SCViewModel.SelectedAssessmentType([]);
            $('#EditFactorAssessment').empty();
            document.getElementById('EditFactorAssessment').innerHTML = Assessment;
            $('#SurveyApplicabilityDropdown').hide();
            SCViewModel.addPopUpCssSurvey(false);
            SCViewModel.DisableSurveyDropdown(true);
            SCViewModel.DisableApplicabilityDropdown(true);
            $('#frmSurveyPopup').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditSurvey() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveyClick(data, event) {
        try {
            SCViewModel.ClickedSurveyProfileId(data.SurveyprofileId());
            SCViewModel.ClickedSurveyProfileName(data.SurveyName());
            SCViewModel.NavPillIdSC("ALL");
            $('#SurveyProfilesUL li').removeClass('active');
            $('#ChildTab_' + data.SurveyprofileId()).addClass('active');
            GetallProfileSurveys(data);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyClick() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }
    function GetallProfileSurveys(data) {
        try {
            return $.ajax({
                url: "/api/Survey/GetBusinessunitSurveysConfiguration",
                type: "GET",
                  data: { "Status": SCViewModel.NavPillIdSC(), SelectedBUs: SCViewModel.SelectedBUs(), SelectedFilters: SCViewModel.SelectedFilters(), SelectedSurveyProfiles: (SCViewModel.ClickedSurveyProfileId() == -999) ? SCViewModel.SelectedSurveyTypeFilters() : SCViewModel.ClickedSurveyProfileId(), SelectedSurveyComponent: SCViewModel.SelectedSurveyComponentTypeFilters() },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    SCViewModel.BuModelList([]);
                    var object = $('#tblSurveyDetails').DataTable();
                    object.destroy();
                    $('#tblSurveyDetails tbody tr').remove();

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                    }

                    else if (jsonResult == null) {
                        //SCViewModel.BuModelList([]);
                        //var object = $('#tblSurveyDetails').DataTable();
                        //object.destroy();
                        //$('#tblSurveyDetails tbody tr').remove();
                        $("#tblSurveyDetails").DataTable();
                    }
                    else if (jsonResult.length > 0) {
                        var mappedBuListgroup = $.map(jsonResult, function (result) {
                            var BuModelObj = new BusinessUnitModel(result);
                            return BuModelObj;
                        });

                        //SCViewModel.BuModelList([]);
                        //var object = $('#tblSurveyDetails').DataTable();
                        //object.destroy();
                        //$('#tblSurveyDetails tbody tr').remove();
                        SCViewModel.BuModelList(mappedBuListgroup);
                        var mappedLaunchBuListgroup = $.map(SCViewModel.BuModelList(), function (result) {
                            var BuModelObj = new LaunchBusinessUnitModel(result);
                            return BuModelObj;
                        });

                        SCViewModel.LaunchBusinessunitList(mappedLaunchBuListgroup);
                        $("#tblSurveyDetails").DataTable(
                            {
                                "stateSave": true,
                                "bResponsive": true,
                                "order": [],
                                "ColumnDefs": [{
                                    "targets": [0],
                                    "orderable": false,
                                }]
                            }
                        );
                    }
                    else {
                        // SCViewModel.BuModelList([]);
                        $('#tblSurveyDetails').DataTable({
                            "stateSave": true,
                            "ColumnDefs": [{
                                "targets": [0],
                                "order": [],
                                "visible": false

                            },
                            {
                                "targets": [1],
                                "orderable": false
                            },
                            {
                                "targets": [3],
                                "orderable": true
                            }
                            ]

                        });
                        //show error saying no business units are configured for this profile of assessment
                    }

                    $('#Select_ALL_Business_Units').prop('checked', false);
                    var rows = $("#tblSurveyDetails").dataTable().fnGetNodes();
                    var cells = [];
                    for (var i = 0; i < rows.length; i++) {
                        // Get HTML of 3rd column (for example)
                        var RespText = $(rows[i]).find("td:eq(3)").html();
                        if (RespText) {
                            var RespTextEdit = RespText.replace(/}/g, '<br/>');
                            $(rows[i]).find("td:eq(3)").html(RespTextEdit);
                            var RevText = $(rows[i]).find("td:eq(5)").html();
                            var RevTextEdit = RevText.replace(/}/g, '<br/>');
                            $(rows[i]).find("td:eq(5)").html(RevTextEdit);
                        }
                        if ($(rows[i]).find("td:eq(3)").text().toUpperCase() == 'UNASSIGNED') {
                            if ($(rows[i]).find("td:eq(3)") != null && $(rows[i]).find("td:eq(3)") != undefined) {
                                $(rows[i]).find("td:eq(3)").css('color', '#FF0000');
                            }
                        }
                        if ($(rows[i]).find("td:eq(5)").text().toUpperCase() == 'UNASSIGNED') {
                            if ($(rows[i]).find("td:eq(5)") != null && $(rows[i]).find("td:eq(5)") != undefined) {
                                $(rows[i]).find("td:eq(5)").css('color', '#FF0000');
                            }
                        }

                    }
                    if (SCViewModel.SelectedSurveyTypeFilters() == "" && SCViewModel.SelectedSurveyComponentTypeFilters() == "" && SCViewModel.SelectedBUs() == "") {
                        SCViewModel.AreFiltersApplied(0);
                    }
                    else {
                        SCViewModel.AreFiltersApplied(1);
                    }
                    SCViewModel.ApplyFiltersclickedcount(jsonResult.length);
                })

                .fail(function (jsonnResult, error) {

                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetallProfileSurveys() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveyLaunch(data, event) {
        try {
            var Data = data;
            app.showMessage('Are you sure you want to Launch the Survey?', 'Confirm Survey Launch', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        SCViewModel.SelectedBuIdList([]);
                        SCViewModel.SelectedBuIdList().push(Data.BuId())
                        SCViewModel.SelectedSpIdList([]);
                        SCViewModel.SelectedSpIdList().push(data.SpId());
                        LaunchSurvey();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyLaunch() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function LaunchSurvey() {
        try {

            var BuIdList = ConstructLaunchSurveyJson();
            if (BuIdList.length == 0) {
                logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectedSurveyLaunchSuccessMsg') == -1) ? 'The selected surveys have already been launched or the questionnaire has not been assigned.': SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectedSurveyLaunchSuccessMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
            }
            else {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/LaunchSurvey",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(BuIdList, function (item) {
                        return { BU_ID: item[0], PROFILE_ID: (SCViewModel.ClickedSurveyProfileId() == -999 ? item[1] : SCViewModel.ClickedSurveyProfileId()) };
                    }))
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult != null)
                        {
                            if (parseInt(jsonResult) > 0) {
                                $('#frmlaunchPopup').modal('hide');
                                logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyLaunchInitiated') == -1) ? 'Selected Survey launch has been initiated.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyLaunchInitiated')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                                GetallProfileSurveys();

                            }
                            else if (jsonResult.startsWith("INC"))
                                logger.logError(jsonResult + " - " + 'An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                            else
                                logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                            logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);

                    })
                    .fail(function (jsonResult, error) {

                    })
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LaunchSurvey() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function ConstructLaunchSurveyJson() {
        try {
            var x = [];
            for (var i = 0; i < SCViewModel.SelectedBuIdList().length; i++) {
                for (var j = 0; j < SCViewModel.BuModelList().length; j++) {
                    if (SCViewModel.SelectedBuIdList()[i] == SCViewModel.BuModelList()[j].BuId()) {
                        if (SCViewModel.BuModelList()[j].QuestionnaireAssignedCount() > 0 && SCViewModel.BuModelList()[j].ReadonlyFlag() == 0) {
                            x.push([SCViewModel.BuModelList()[j].BuId(), SCViewModel.SelectedSpIdList()[i]]);
                        }
                    }
                }


            }
            return x;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConstructLaunchSurveyJson() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }

    }

    /******************************** ROLE WISE USERS BEGIN ******************************/

    function GetRoleUserDetailsForBUSurveyConfiguration(surveyId, surveyType) {
        try {
            $.ajax({
                url: "/api/Configuration/GetRoleUserDetailsForSurveyConfiguration",
                data: {
                    "Spr_uid": surveyId,
                    "Survey_type": surveyType
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    SCViewModel.workflowModelList([]);
                    if (jsonResult == null) {
                        $('#UsersRoleWFChevrons').hide();
                    }
                    if (jsonResult.length > 0 && jsonResult != null)
                    {
                        if (jsonResult[0].Incident_Description != null)
                        {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                        }
                        else
                        {
                            $('#UsersRoleWFChevrons').show();
                            SCViewModel.workflowModelList(jsonResult);
                        }
                    }
                })
                .fail(function (error, fail) { });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetRRSDrpDwnList() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    /******************************** ROLE WISE USERS END ******************************/

    /******************************** BU EXPAND COLLAPSE START ******************************/

    function showBusinessUnitInfoClick(BuId,SpId) {
        try {
            if ($('.BuInfoDiv_' + BuId + SpId).is(':visible')) {
                $('.BuInfoDiv_' + BuId + SpId).hide();
                $('.BuInfoDivMore_' + BuId + SpId).show();
                $('.BuInfoDivLess_' + BuId + SpId).hide();
            }
            else {
                $('.BuInfoDiv_' + BuId + SpId).show();
                $('.BuInfoDivLess_' + BuId + SpId).show();
                $('.BuInfoDivMore_' + BuId + SpId).hide();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    /******************************** BU EXPAND COLLAPSE END ******************************/

    /********************************** NAV TAB CLICK SC START *******************************************/

    function NavTabClickSC(data, event) {

        try {
            if (typeof (event) == "undefined") { // First Load Condition
                SCViewModel.NavPillIdSC("ALL");
                $("#filterSC.nav-pills a").first().addClass("active");
            }
            else {
                SCViewModel.NavPillIdSC(event.currentTarget.id); // Get the Id of Navbar Pill Selected
                $('#filterSC.nav-pills a').removeClass("active");
                document.getElementById(SCViewModel.NavPillIdSC()).classList.add("active");
                //document.getElementById(SCViewModel.NavPillId()).click();
            }


            if (SCViewModel.NavPillIdSC() == "ALL") {
                // For All
                SCViewModel.NavPillIdSC("ALL");
            }

            else if (SCViewModel.NavPillIdSC() == "LAUNCHED") {
                //For Launched
                SCViewModel.NavPillIdSC("LAUNCHED");

            }

            else if (SCViewModel.NavPillIdSC() == "NOTLAUNCHED") {
                // For NotLaunched
                SCViewModel.NavPillIdSC("NOTLAUNCHED");
            }
            GetallProfileSurveys();
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in CreateSurvey.js';
            logger.logMessage(msg);

        }
    }


    /********************************** NAV TAB CLICK SC END *******************************************/

    /********************************** CONFIGURE DUE DATE GLOBAL START *******************************************/

    function OpenConfigureDueDatePopupBulk() {
        SCViewModel.SelectedBuIdList([]);
        for (var i = 0; i < SCViewModel.BuModelList().length; i++) {
            if (SCViewModel.BuModelList()[i].isChecked()) {
                SCViewModel.SelectedBuIdList().push(SCViewModel.BuModelList()[i].BuId());
            }
        }
        if (SCViewModel.SelectedBuIdList().length > 0)
            SCViewModel.SaveDueDateGlobalFlag(2); // 2-for Bulk Action
        else
            SCViewModel.SaveDueDateGlobalFlag(1); // Global Configuration

        SCViewModel.DueDate("");
        $('#DueDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
        $('#DueDateConfigurePopUp').modal('show');
    }

    function OpenConfigureDueDatePopup(data, event) {
        SCViewModel.SaveDueDateGlobalFlag(0);
        SCViewModel.SelectedBuIdList([]);
        SCViewModel.DueDate(data.BuDueDate());
        SCViewModel.SelectedSurveyName(data.BuName());
        SCViewModel.SelectedSurveyId(data.BuId());
        SCViewModel.SelectedSpIdList([]);
        SCViewModel.SelectedSpIdList().push(data.SpId());
        SCViewModel.SelectedSpId((data.SpId()));
        $('#DueDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
        $('#DueDateConfigurePopUp').modal('show');
    }

    function CloseConfigureDueDatePopup() {
        $('#DueDateConfigurePopUp').modal('hide');
    }

    function SaveDueDate(data, event) {
        // We will pass BU Id and SP Uid for individual surveys
        try {
            var BusinessUnitId = "";
            var BuIds = "";
            var SelectedBuIds = "";

            for (var i = 0; i < SCViewModel.SelectedBuIdList().length; i++) {
                BuIds += SCViewModel.SelectedBuIdList()[i];
                BuIds += ",";
            }

            if (BuIds.length > 0)
                SelectedBuIds = BuIds.slice(0, -1); // To remove one extra comma inserted

            if (SCViewModel.SelectedBuIdList().length > 0) {
                BusinessUnitId = SelectedBuIds;
                SCViewModel.SaveDueDateGlobalFlag(2); // To recognize bulk option
            }
            else if (SCViewModel.SelectedSurveyId())
                BusinessUnitId = SCViewModel.SelectedSurveyId();

            var SurveyProfileId = (SCViewModel.ClickedSurveyProfileId() == -999) ? SCViewModel.SelectedSpId() : SCViewModel.ClickedSurveyProfileId();
            var AssessmentTypeId = SCViewModel.SurveyComponentSelected(); //SCViewModel.SelectedSurveyType();

            if (!((new Date(data.DueDate()) !== "Invalid Date") && !isNaN(new Date(data.DueDate())))) {
                logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDateAlert') == -1) ? 'Please enter a valid Date.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDateAlert')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                //return;
            }
            else {
                if (!AssessmentTypeId)
                    AssessmentTypeId = 0;
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/SetDueDate",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        GlobalFlag: SCViewModel.SaveDueDateGlobalFlag(),
                        BusinessUnitId: BusinessUnitId,
                        SurveyProfileId: SurveyProfileId,
                        AssessmentTypeId: AssessmentTypeId,
                        DueDate: data.DueDate()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveDueDate() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }


        function ajaxSuccess(jsonResult, status) {
            try {
                var code = jsonResult.substring(0, 2);
                var msg = jsonResult.substring(2, 13);
                if (parseInt(jsonResult) > 0) {
                    logger.logSuccess((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DueDateSuccessMsg') == -1) ? 'Due Date has been saved successfully.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DueDateSuccessMsg')].Name(), 'Success', system.getModuleId(SCViewModel), true);
                    GetallProfileSurveys();
                }
                else if (code == '-2') {
                    logger.logError((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyNotConfiguredMsg') == -1) ? msg + " - " + 'Selected survey has not been configured..' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyNotConfiguredMsg')].Name(), 'Error', system.getModuleId(SCViewModel), true);
                }
                else {
                    logger.logError(jsonResult + " - " + 'An error has occurred whie saving the Due Date. Please contact your Administrator.', 'Error', system.getModuleId(SCViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveDueDate() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!SCViewModel.LocaleCheckFlag() || SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SCViewModel.ObjGeneralSettings.LocalizedTextList()[SCViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveDueDate() method in ConfigureSurvey.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveDueDate() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        };

    }

    /********************************** CONFIGURE DUE DATE GLOBAL END *******************************************/

    function SurveyListModel(item) {
        try {
            var self = this;
            self.SurveyId = ko.observable($('<div/>').html(item.SurveyId).text());
            self.SurveyName = ko.observable(item.SurveyName);
            self.SurveySecondName = ko.observable($('<div/>').html(item.SurveySecondName).text());
            self.surveyType = ko.observable($('<div/>').html(item.surveyType).text());
            self.Applicability = ko.observable($('<div/>').html(item.Applicability).text());
            if (item.AssessmentId) {
                var AssessmentId = $.map(item.AssessmentId, function (result) {
                    return result
                });
            }
            else
                var AssessmentId;
            self.AssessmentIdList = AssessmentId;
            self.Editing = false;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyListModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListDupModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListDupModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveyModel(item) {
        try {
            var self = this;
            self.SurveyName = ko.observable($('<div/>').html(item.SurveyName).text());
            self.SurveySecondName = ko.observable($('<div/>').html(item.SurveySecondName).text());
            self.surveyType = ko.observable($('<div/>').html(item.surveyType).text());
            self.surveyTypeId = ko.observable($('<div/>').html(item.SurveyId).text());
            self.SurveyStatus = ko.observable(item.SurveyStatus);
            self.TypeId = ko.observable(item.TypeId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BuId = ko.observable(item.BuId);
            self.BuName = ko.observable($('<div/>').html(item.BuName).text());
            self.SpId = ko.observable(item.SpId);
            self.ProfileName = ko.observable($('<div/>').html(item.ProfileName).text());
            self.ComponentName = ko.observable($('<div/>').html(item.ComponentName).text());
            self.SurveyType = ko.observable($('<div/>').html(item.SurveyType).text());
            self.AssignedUsersList = ko.observable($('<div/>').html(item.L2ReviewerList).text());
            self.ReadonlyFlag = ko.observable(item.ReadonlyFlag);
            self.QuestionnaireAssignedCount = ko.observable(item.QuestionnaireAssignedCount);
            self.isChecked = ko.observable(false);
            self.workflowModelList = ko.observableArray(item.WorkflowUsersList);
            self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
            self.SpId = ko.observable(item.SpId);
            self.SubLevelId = ko.observable(item.SubLevelId);

            self.BuDueDate = ko.observable(item.DueDate);
            if (item.QuestionnaireAssignedCount > 0) {
                self.ColorCode = ko.observable("#DA291C")
                self.Status = ko.observable("Can be Launched");
            }
            else {
                self.Status = ko.observable("Cannot be  Launched");
                self.ColorCode = ko.observable("#D0D0CE");
            }
            if (item.ReadonlyFlag == 1) {
                self.LaunchStatus = ko.observable("Launched");
                self.MainListColourCode = ko.observable("#43B02A");
            }
            else if (item.ReadonlyFlag == 2) {
                self.LaunchStatus = ko.observable("In Progress");
                self.MainListColourCode = ko.observable("#ED8B00");
            }
            else {
                self.LaunchStatus = ko.observable("Not Launched");
                self.MainListColourCode = ko.observable("#63666A");
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function LaunchBusinessUnitModel(item) {
        try {
            var self = this;
            self.BuId = item.BuId();
            self.BuName = $('<div/>').html(item.BuName()).text();
            self.ComponentName = $('<div/>').html(item.ComponentName()).text();
            self.ProfileName = $('<div/>').html(item.ProfileName()).text();
            self.ReadonlyFlag = item.ReadonlyFlag();
            self.QuestionnaireAssignedCount = item.QuestionnaireAssignedCount();
            if (item.ReadonlyFlag() > 0) {
                self.ColorCode = "#007cb0"
                self.Status = "Launched";
            }
            else if (item.QuestionnaireAssignedCount() > 0) {
                self.ColorCode = "#007cb0"
                self.Status = "Can be Launched";
            }
            else {
                self.Status = "Cannot be  Launched";
                self.ColorCode = "#97999B";
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LaunchBusinessUnitModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveySetupModel(item) {
        try {
            var self = this;
            self.SurveyprofileId = ko.observable(item.SurveyprofileId);
            self.SurveyName = ko.observable($('<div/>').html(item.SurveyName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveySetupModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RespondentListModel(item) {
        try {
            var self = this;
            if (item.UserName.length > 0)
                self.UserName = ko.observable(item.UserName);
            else
                self.UserName = ko.observable(item.UserName());
            if (item.Role.length > 0)
                self.Role = ko.observable(item.Role);
            else
                self.Role = ko.observable(item.Role());
            if (!isNaN(item.UserId))
                self.UserId = ko.observable(item.UserId);
            else
                self.UserId = ko.observable(item.UserId());
            if (item.RoleType.length > 0)
                self.RoleType = ko.observable(item.RoleType);
            else
                self.RoleType = ko.observable(item.RoleType());
            if (typeof (item.IsChecked) === "boolean")
                self.IsChecked = ko.observable(item.IsChecked);
            else
                self.IsChecked = ko.observable(item.IsChecked());
            if (!isNaN(item.RoleId))
                self.RoleId = ko.observable(item.RoleId);
            else
                self.RoleId = ko.observable(item.RoleId());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RespondentListModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.Parent_Flag = ko.observable(item.Parent_Flag);
            self.Parent_Id = ko.observable(item.Parent_Id);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    };

    function QuestionListModel(item) {
        try {
            var self = this;
            self.Question = ko.observable($('<div/>').html(item.Question).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.Is_Child_Flag = ko.observable(item.Is_Child_Flag);
            self.Parent_Id = ko.observable(item.Parent_Id);
            if (item.QuestionId == undefined) {
                self.QuestionId = ko.observable(item.RiskSubFactorId);
            }
            else {
                self.QuestionId = ko.observable(item.QuestionId);
            }
            self.IsApplicable = ko.observable(item.IsApplicable);
            self.Rank = ko.observable(item.Rank);//tobechnaged
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuestionListModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function IndentationLevelsModel(item) {
        try {
            var self = this;
            self.LevelUId = ko.observable(item.LevelUId);
            self.LevelName = ko.observable(item.LevelName);
            self.LevelValue = ko.observable(item.LevelValue);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IndentationLevelsModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.LaunchFlag = ko.observable(item.LaunchFlag);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

    function SurveyProfileModel(item) {
        try {
            var self = this;
            self.SurveyProfileId = ko.observable($('<div/>').html(item.SurveyProfileId).text());
            self.SurveyProfileName = ko.observable($('<div/>').html(item.SurveyProfileName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyProfileModel() method in ConfigureSurvey.js';
            logger.logMessage(msg);
        }
    }

});
